export const data = {
  'CCI-000001': 'AC-1 a 1',
  'CCI-000002': 'AC-1 a 1 (a)',
  'CCI-000003': 'AC-1 c 1',
  'CCI-000004': 'AC-1 a 2',
  'CCI-000005': 'AC-1 a 2',
  'CCI-000006': 'AC-1 c 2',
  'CCI-000007': 'AC-2 a',
  'CCI-000008': 'AC-2 c',
  'CCI-000009': 'AC-2 c',
  'CCI-000010': 'AC-2 e',
  'CCI-000011': 'AC-2 f',
  'CCI-000012': 'AC-2 j',
  'CCI-000013': 'AC-2 g',
  'CCI-000014': 'AC-2 i',
  'CCI-000015': 'AC-2 (1)',
  'CCI-000016': 'AC-2 (2)',
  'CCI-000017': 'AC-2 (3) (d)',
  'CCI-000018': 'AC-2 (4)',
  'CCI-000019': 'AC-2 (5)',
  'CCI-000020': 'AC-2 (6)',
  'CCI-000021': 'AC-3 (2)',
  'CCI-000022': 'AC-3 (3) (a)',
  'CCI-000023': 'PM-1 a',
  'CCI-000024': 'AC-3 (5)',
  'CCI-000025': 'AC-4 (1)',
  'CCI-000026': 'AC-4 (2)',
  'CCI-000027': 'AC-4 (3)',
  'CCI-000028': 'AC-4 (4)',
  'CCI-000029': 'AC-4 (5)',
  'CCI-000030': 'AC-4 (6)',
  'CCI-000031': 'AC-4 (7)',
  'CCI-000032': 'AC-4 (8) (a)',
  'CCI-000033': 'AC-4 (9)',
  'CCI-000034': 'AC-4 (10)',
  'CCI-000035': 'AC-4 (11)',
  'CCI-000036': 'AC-5 a',
  'CCI-000037': 'AC-5 c',
  'CCI-000038': 'AC-6 (1)',
  'CCI-000039': 'AC-6 (2)',
  'CCI-000040': 'AC-6 (2)',
  'CCI-000041': 'AC-6 (3)',
  'CCI-000042': 'AC-6 (3)',
  'CCI-000043': 'AC-7 a',
  'CCI-000044': 'AC-7 a',
  'CCI-000045': 'AC-7 b',
  'CCI-000046': 'AC-7 b',
  'CCI-000047': 'AC-7 b',
  'CCI-000048': 'AC-8 a',
  'CCI-000049': 'AC-8 a',
  'CCI-000050': 'AC-8 b',
  'CCI-000051': 'AC-8 a',
  'CCI-000052': 'AC-9',
  'CCI-000053': 'AC-9 (1)',
  'CCI-000054': 'AC-10',
  'CCI-000055': 'AC-10',
  'CCI-000056': 'AC-11 b',
  'CCI-000057': 'AC-11 a',
  'CCI-000058': 'AC-11 a',
  'CCI-000059': 'AC-11 a',
  'CCI-000060': 'AC-11 (1)',
  'CCI-000061': 'AC-14 a',
  'CCI-000062': 'AC-14 (1)',
  'CCI-000063': 'AC-17 a',
  'CCI-000064': 'AC-17 b',
  'CCI-000065': 'AC-17 b',
  'CCI-000066': 'AC-17 e',
  'CCI-000067': 'AC-17 (1)',
  'CCI-000068': 'AC-17 (2)',
  'CCI-000069': 'AC-17 (3)',
  'CCI-000070': 'AC-17 (4) (a)',
  'CCI-000071': 'AC-17 (5)',
  'CCI-000072': 'AC-17 (6)',
  'CCI-000073': 'PM-1 a 1',
  'CCI-000074': 'PM-1 a 4',
  'CCI-000075': 'PM-1 b',
  'CCI-000076': 'PM-1 b',
  'CCI-000077': 'PM-1 c',
  'CCI-000078': 'PM-2',
  'CCI-000079': 'AC-17 (7)',
  'CCI-000080': 'PM-3 a',
  'CCI-000081': 'PM-3 b',
  'CCI-000082': 'AC-19 a',
  'CCI-000083': 'AC-19 a',
  'CCI-000084': 'AC-19 b',
  'CCI-000085': 'AC-19 c',
  'CCI-000086': 'AC-19 d',
  'CCI-000087': 'AC-19 e',
  'CCI-000088': 'AC-19 f',
  'CCI-000089': 'AC-19 g',
  'CCI-000090': 'AC-19 (1)',
  'CCI-000091': 'AC-19 (2)',
  'CCI-000092': 'AC-19 (3)',
  'CCI-000093': 'AC-20 a 1',
  'CCI-000094': 'AC-20 b',
  'CCI-000095': 'AC-20 (1) (a)',
  'CCI-000096': 'AC-20 (1) (b)',
  'CCI-000097': 'AC-20 (2)',
  'CCI-000098': 'AC-21 a',
  'CCI-000099': 'AC-21 (1)',
  'CCI-000100': 'AT-1 a 1 (a)',
  'CCI-000101': 'AT-1 a 1 (a)',
  'CCI-000102': 'AT-1 c 1',
  'CCI-000103': 'AT-1 a 2',
  'CCI-000104': 'AT-1 a 2',
  'CCI-000105': 'AT-1 c 2',
  'CCI-000106': 'AT-2 a 1',
  'CCI-000107': 'AT-2 (1)',
  'CCI-000108': 'AT-3 a 1',
  'CCI-000109': 'AT-3 a 2',
  'CCI-000110': 'AT-3 c',
  'CCI-000111': 'AT-3 c',
  'CCI-000112': 'AT-2 a 2',
  'CCI-000113': 'AT-4 a',
  'CCI-000114': 'AT-4 a',
  'CCI-000115': 'AT-5',
  'CCI-000116': 'AT-5',
  'CCI-000117': 'AU-1 a 1 (a)',
  'CCI-000118': 'AU-1 a',
  'CCI-000119': 'AU-1 c 1',
  'CCI-000120': 'AU-1 a 2',
  'CCI-000121': 'AU-1 b',
  'CCI-000122': 'AU-1 c 2',
  'CCI-000123': 'AU-2 a',
  'CCI-000124': 'AU-2 b',
  'CCI-000125': 'AU-2 d',
  'CCI-000126': 'AU-2 c',
  'CCI-000127': 'AU-2 (3)',
  'CCI-000128': 'AU-2 (4)',
  'CCI-000129': 'AU-2 a',
  'CCI-000130': 'AU-3 a',
  'CCI-000131': 'AU-3 b',
  'CCI-000132': 'AU-3 c',
  'CCI-000133': 'AU-3 d',
  'CCI-000134': 'AU-3 e',
  'CCI-000135': 'AU-3 (1)',
  'CCI-000136': 'AU-3 (2)',
  'CCI-000137': 'AU-4',
  'CCI-000138': 'AU-4',
  'CCI-000139': 'AU-5 a',
  'CCI-000140': 'AU-5 b',
  'CCI-000141': 'PM-3 c',
  'CCI-000142': 'PM-4 a 1',
  'CCI-000143': 'AU-5 (1)',
  'CCI-000144': 'AU-5 (2)',
  'CCI-000145': 'AU-5 (3)',
  'CCI-000146': 'AU-5 (1)',
  'CCI-000147': 'AU-5 (2)',
  'CCI-000148': 'AU-6 a',
  'CCI-000149': 'AU-6 b',
  'CCI-000150': 'AU-6 b',
  'CCI-000151': 'AU-6 a',
  'CCI-000152': 'AU-6 (1)',
  'CCI-000153': 'AU-6 (3)',
  'CCI-000154': 'AU-6 (4)',
  'CCI-000155': 'AU-6 (5)',
  'CCI-000156': 'AU-7',
  'CCI-000157': 'AU-7',
  'CCI-000158': 'AU-7 (1)',
  'CCI-000159': 'AU-8 a',
  'CCI-000160': 'AU-8 (1)',
  'CCI-000161': 'AU-8 (1) (a)',
  'CCI-000162': 'AU-9 a',
  'CCI-000163': 'AU-9 a',
  'CCI-000164': 'AU-9 a',
  'CCI-000165': 'AU-9 (1)',
  'CCI-000166': 'AU-10',
  'CCI-000167': 'AU-11',
  'CCI-000168': 'AU-11',
  'CCI-000169': 'AU-12 a',
  'CCI-000170': 'PM-4 a 2',
  'CCI-000171': 'AU-12 b',
  'CCI-000172': 'AU-12 c',
  'CCI-000173': 'AU-12 (1)',
  'CCI-000174': 'AU-12 (1)',
  'CCI-000175': 'IA-5 a',
  'CCI-000176': 'IA-5 b',
  'CCI-000177': 'IA-5 d',
  'CCI-000178': 'IA-5 e',
  'CCI-000179': 'IA-5 f',
  'CCI-000180': 'IA-5 f',
  'CCI-000181': 'IA-5 f',
  'CCI-000182': 'IA-5 f',
  'CCI-000183': 'IA-5 g',
  'CCI-000184': 'IA-5 h',
  'CCI-000185': 'IA-5 (2) (b) (1)',
  'CCI-000186': 'IA-5 (2) (a) (1)',
  'CCI-000187': 'IA-5 (2) (a) (2)',
  'CCI-000188': 'IA-5 (3)',
  'CCI-000189': 'IA-5 (4)',
  'CCI-000190': 'IA-5 (5)',
  'CCI-000191': 'IA-5 (1) (a)',
  'CCI-000192': 'IA-5 (1) (a)',
  'CCI-000193': 'IA-5 (1) (a)',
  'CCI-000194': 'IA-5 (1) (a)',
  'CCI-000195': 'IA-5 (1) (b)',
  'CCI-000196': 'IA-5 (1) (c)',
  'CCI-000197': 'IA-5 (1) (c)',
  'CCI-000198': 'IA-5 (1) (d)',
  'CCI-000199': 'IA-5 (1) (d)',
  'CCI-000200': 'IA-5 (1) (e)',
  'CCI-000201': 'IA-5 (6)',
  'CCI-000202': 'IA-5 (7)',
  'CCI-000203': 'IA-5 (7)',
  'CCI-000204': 'IA-5 (8)',
  'CCI-000205': 'IA-5 (1) (a)',
  'CCI-000206': 'IA-6',
  'CCI-000207': 'PM-5',
  'CCI-000208': 'AC-2 (5) (b)',
  'CCI-000209': 'PM-6',
  'CCI-000210': 'PM-6',
  'CCI-000211': 'PM-6',
  'CCI-000212': 'PM-7',
  'CCI-000213': 'AC-3',
  'CCI-000214': 'AC-3 (4) (b)',
  'CCI-000215': 'AC-3 (4) (c)',
  'CCI-000216': 'PM-8',
  'CCI-000217': 'AC-2 (3)',
  'CCI-000218': 'AC-4 (12)',
  'CCI-000219': 'AC-4 (13)',
  'CCI-000221': 'AC-4 (16)',
  'CCI-000223': 'AC-4 (17) (b)',
  'CCI-000224': 'AC-4 (17) (c)',
  'CCI-000225': 'AC-6',
  'CCI-000226': 'AC-6 (4)',
  'CCI-000227': 'PM-9 a 1',
  'CCI-000228': 'PM-9 b',
  'CCI-000229': 'PM-10 a',
  'CCI-000230': 'PM-10 a',
  'CCI-000231': 'PM-10 a',
  'CCI-000232': 'AC-14 b',
  'CCI-000233': 'PM-10 b',
  'CCI-000234': 'PM-10 c',
  'CCI-000235': 'PM-11 a',
  'CCI-000236': 'PM-11 b',
  'CCI-000237': 'AC-2 f',
  'CCI-000238': 'CA-1 c 1',
  'CCI-000239': 'CA-1 a 1 (a)',
  'CCI-000240': 'CA-1 a 1 (a)',
  'CCI-000241': 'CA-1 c 1',
  'CCI-000242': 'CA-1 a 2',
  'CCI-000243': 'CA-1 a 2',
  'CCI-000244': 'CA-1 c 2',
  'CCI-000245': 'CA-2 a',
  'CCI-000246': 'CA-2 b 1',
  'CCI-000247': 'CA-2 b 2',
  'CCI-000248': 'CA-2 b 3',
  'CCI-000249': 'CA-2 a',
  'CCI-000250': 'CA-2 a',
  'CCI-000251': 'CA-2 d',
  'CCI-000252': 'CA-2 d',
  'CCI-000253': 'CA-2 e',
  'CCI-000254': 'CA-2 f',
  'CCI-000255': 'CA-2 (1)',
  'CCI-000256': 'CA-2 (2)',
  'CCI-000257': 'CA-3 a',
  'CCI-000258': 'CA-3 b',
  'CCI-000259': 'CA-3 b',
  'CCI-000260': 'CA-3 b',
  'CCI-000261': 'CA-3 c',
  'CCI-000262': 'CA-3 (1)',
  'CCI-000263': 'CA-3 (2)',
  'CCI-000264': 'CA-5 a',
  'CCI-000265': 'CA-5 b',
  'CCI-000266': 'CA-5 b',
  'CCI-000267': 'CA-5 (1)',
  'CCI-000268': 'CA-5 (1)',
  'CCI-000269': 'CA-5 (1)',
  'CCI-000270': 'CA-6 a',
  'CCI-000271': 'CA-6 c 2',
  'CCI-000272': 'CA-6 e',
  'CCI-000273': 'CA-6 e',
  'CCI-000274': 'CA-7',
  'CCI-000275': 'CA-7 a',
  'CCI-000276': 'CA-7 a',
  'CCI-000277': 'CA-7 b',
  'CCI-000278': 'CA-7 b',
  'CCI-000279': 'CA-7 c',
  'CCI-000280': 'CA-7 g',
  'CCI-000281': 'CA-7 g',
  'CCI-000282': 'CA-7 (1)',
  'CCI-000283': 'CA-7 (2)',
  'CCI-000284': 'CA-7 (2)',
  'CCI-000285': 'CA-7 (2)',
  'CCI-000286': 'CM-1 c 1',
  'CCI-000287': 'CM-1 a 1 (a)',
  'CCI-000288': 'CM-1 a',
  'CCI-000289': 'CM-1 c 1',
  'CCI-000290': 'CM-1 a 2',
  'CCI-000291': 'CM-1 b',
  'CCI-000292': 'CM-1 a 2',
  'CCI-000293': 'CM-2',
  'CCI-000294': 'CM-2',
  'CCI-000295': 'CM-2 a',
  'CCI-000296': 'CM-2 b 1',
  'CCI-000297': 'CM-2 b 2',
  'CCI-000298': 'CM-2 (1) (c)',
  'CCI-000299': 'CM-2 (1) (c)',
  'CCI-000300': 'CM-2 (2)',
  'CCI-000301': 'CM-2 (2)',
  'CCI-000302': 'CM-2 (2)',
  'CCI-000303': 'CM-2 (2)',
  'CCI-000304': 'CM-2 (3)',
  'CCI-000305': 'CM-7 (2)',
  'CCI-000306': 'CM-7 (2)',
  'CCI-000307': 'CM-2 (4) (b)',
  'CCI-000308': 'CM-7 (2)',
  'CCI-000309': 'CM-7 (2)',
  'CCI-000310': 'CM-2 (5) (b)',
  'CCI-000311': 'CM-2 (6)',
  'CCI-000312': 'CM-2 (6)',
  'CCI-000313': 'CM-3 a',
  'CCI-000314': 'CM-3 b',
  'CCI-000315': 'CM-3 c',
  'CCI-000316': 'CM-3 e',
  'CCI-000317': 'CM-3 d',
  'CCI-000318': 'CM-3 f',
  'CCI-000319': 'CM-3 g',
  'CCI-000320': 'CM-3 g',
  'CCI-000321': 'CM-3 g',
  'CCI-000322': 'CM-3 (1) (a)',
  'CCI-000323': 'CM-3 (1) (b)',
  'CCI-000324': 'CM-3 (1) (c)',
  'CCI-000325': 'CM-3 (1) (d)',
  'CCI-000326': 'CM-3 (1) (e)',
  'CCI-000327': 'CM-3 (2)',
  'CCI-000328': 'CM-3 (2)',
  'CCI-000329': 'CM-3 (2)',
  'CCI-000330': 'CM-3 (3)',
  'CCI-000331': 'CM-3 (3)',
  'CCI-000332': 'CM-3 (4)',
  'CCI-000333': 'CM-4',
  'CCI-000334': 'CM-4 (1)',
  'CCI-000335': 'CM-4 (2)',
  'CCI-000336': 'CM-4 (2)',
  'CCI-000337': 'CM-4 (2)',
  'CCI-000338': 'CM-5',
  'CCI-000339': 'CM-5',
  'CCI-000340': 'CM-5',
  'CCI-000341': 'CM-5',
  'CCI-000342': 'CM-5',
  'CCI-000343': 'CM-5',
  'CCI-000344': 'CM-5',
  'CCI-000345': 'CM-5',
  'CCI-000346': 'CM-5 (1)',
  'CCI-000347': 'CM-5 (1)',
  'CCI-000348': 'CM-5 (2)',
  'CCI-000349': 'CM-5 (2)',
  'CCI-000350': 'CM-5 (2)',
  'CCI-000351': 'CM-5 (3)',
  'CCI-000352': 'CM-5 (3)',
  'CCI-000353': 'CM-5 (4)',
  'CCI-000354': 'CM-5 (4)',
  'CCI-000355': 'CM-5 (5) (a)',
  'CCI-000356': 'CM-5 (5) (a)',
  'CCI-000357': 'CM-5 (5) (a)',
  'CCI-000358': 'CM-5 (5) (a)',
  'CCI-000359': 'CM-5 (5) (b)',
  'CCI-000360': 'CM-5 (5) (b)',
  'CCI-000361': 'CM-5 (5) (b)',
  'CCI-000362': 'CM-5 (5) (b)',
  'CCI-000363': 'CM-6 a',
  'CCI-000364': 'CM-6 a',
  'CCI-000365': 'CM-6 a',
  'CCI-000366': 'CM-6 b',
  'CCI-000367': 'CM-6 c',
  'CCI-000368': 'CM-6 c',
  'CCI-000369': 'CM-6 c',
  'CCI-000370': 'CM-6 (1)',
  'CCI-000371': 'CM-6 (1)',
  'CCI-000372': 'CM-6 (1)',
  'CCI-000373': 'CM-6 (2)',
  'CCI-000374': 'CM-6 (2)',
  'CCI-000375': 'CM-6 (3)',
  'CCI-000376': 'CM-6 (3)',
  'CCI-000377': 'CM-6 (3)',
  'CCI-000378': 'CM-6 (3)',
  'CCI-000379': 'CM-6 (4)',
  'CCI-000380': 'CM-7 b',
  'CCI-000381': 'CM-7 a',
  'CCI-000382': 'CM-7 b',
  'CCI-000383': 'CM-7 (1)',
  'CCI-000384': 'CM-7 (1) (a)',
  'CCI-000385': 'CM-7 (1)',
  'CCI-000386': 'CM-7 (2)',
  'CCI-000387': 'CM-7 (3)',
  'CCI-000388': 'CM-7 (3)',
  'CCI-000389': 'CM-8 a 1',
  'CCI-000390': 'CM-8 a 1',
  'CCI-000391': 'CM-8 a',
  'CCI-000392': 'CM-8 a 2',
  'CCI-000393': 'CM-8 a 2',
  'CCI-000394': 'CM-8 b',
  'CCI-000395': 'CM-8 a 3',
  'CCI-000396': 'CM-8 a 3',
  'CCI-000397': 'CM-8 c',
  'CCI-000398': 'CM-8 a 5',
  'CCI-000399': 'CM-8 a 4',
  'CCI-000400': 'CM-8 a 4',
  'CCI-000401': 'CM-8 d',
  'CCI-000402': 'CM-8 e',
  'CCI-000403': 'CM-8 e',
  'CCI-000404': 'CM-8 e',
  'CCI-000405': 'CM-8 e',
  'CCI-000406': 'CM-8 e',
  'CCI-000407': 'CM-8 e',
  'CCI-000408': 'CM-8 (1)',
  'CCI-000409': 'CM-8 (1)',
  'CCI-000410': 'CM-8 (1)',
  'CCI-000411': 'CM-8 (2)',
  'CCI-000412': 'CM-8 (2)',
  'CCI-000413': 'CM-8 (2)',
  'CCI-000414': 'CM-8 (2)',
  'CCI-000415': 'CM-8 (3) (a)',
  'CCI-000416': 'CM-8 (3) (a)',
  'CCI-000417': 'CM-8 (3) (b)',
  'CCI-000418': 'CM-8 (4)',
  'CCI-000419': 'CM-8 (5)',
  'CCI-000420': 'CM-8 (6)',
  'CCI-000421': 'CM-9 a',
  'CCI-000422': 'CM-9 a',
  'CCI-000423': 'CM-9 a',
  'CCI-000424': 'CM-9 c',
  'CCI-000425': 'CM-9 c',
  'CCI-000426': 'CM-9 c',
  'CCI-000427': 'CM-9 b',
  'CCI-000428': 'CM-9 b',
  'CCI-000429': 'CM-9 b',
  'CCI-000430': 'CM-9 c',
  'CCI-000431': 'CM-9 c',
  'CCI-000432': 'CM-9 c',
  'CCI-000433': 'CM-9 c',
  'CCI-000434': 'CM-9 c',
  'CCI-000435': 'CM-9 c',
  'CCI-000436': 'CM-9 (1)',
  'CCI-000437': 'CP-1 c 1',
  'CCI-000438': 'CP-1 a 1 (a)',
  'CCI-000439': 'CP-1 a 1 (a)',
  'CCI-000440': 'CP-1 c 1',
  'CCI-000441': 'CP-1 a 2',
  'CCI-000443': 'CP-2 a 1',
  'CCI-000444': 'CP-2 a 1',
  'CCI-000445': 'CP-2 a 1',
  'CCI-000446': 'CP-2 a 2',
  'CCI-000447': 'CP-2 a 2',
  'CCI-000448': 'CP-2 a 2',
  'CCI-000449': 'CP-2 a 3',
  'CCI-000450': 'CP-2 a 4',
  'CCI-000451': 'CP-2 a 4',
  'CCI-000452': 'CP-2 a 4',
  'CCI-000453': 'CP-2 a 4',
  'CCI-000454': 'CP-2 a 4',
  'CCI-000455': 'CP-2 a 4',
  'CCI-000456': 'CP-2 a 5',
  'CCI-000457': 'CP-2 a 7',
  'CCI-000458': 'CP-2 b',
  'CCI-000459': 'CP-2 b',
  'CCI-000460': 'CP-2 c',
  'CCI-000461': 'CP-2 d',
  'CCI-000462': 'CP-2 d',
  'CCI-000463': 'CP-2 e',
  'CCI-000464': 'CP-2 e',
  'CCI-000465': 'CP-2 e',
  'CCI-000466': 'CP-2 e',
  'CCI-000468': 'CP-2 f',
  'CCI-000469': 'CP-2 (1)',
  'CCI-000470': 'CP-2 (2)',
  'CCI-000471': 'CP-2 (2)',
  'CCI-000472': 'CP-2 (2)',
  'CCI-000473': 'CP-2 (3)',
  'CCI-000474': 'CP-2 (3)',
  'CCI-000475': 'CP-2 (3)',
  'CCI-000476': 'CP-2 (3)',
  'CCI-000477': 'CP-2 (4)',
  'CCI-000478': 'CP-2 (4)',
  'CCI-000479': 'CP-2 (4)',
  'CCI-000480': 'CP-2 (4)',
  'CCI-000481': 'CP-2 (5)',
  'CCI-000482': 'CP-2 (5)',
  'CCI-000483': 'CP-2 (6)',
  'CCI-000484': 'CP-2 (6)',
  'CCI-000485': 'CP-3 a 3',
  'CCI-000486': 'CP-3 a 1',
  'CCI-000487': 'CP-3 a 3',
  'CCI-000488': 'CP-3 (1)',
  'CCI-000489': 'CP-3 (2)',
  'CCI-000490': 'CP-4 a',
  'CCI-000491': 'CP-4',
  'CCI-000492': 'CP-4 a',
  'CCI-000493': 'CP-4',
  'CCI-000494': 'CP-4 a',
  'CCI-000495': 'CP-4 a',
  'CCI-000496': 'CP-4 b',
  'CCI-000497': 'CP-4 c',
  'CCI-000498': 'CP-4 (1)',
  'CCI-000499': 'CP-4 (1)',
  'CCI-000500': 'CP-4 (2) (a)',
  'CCI-000501': 'CP-4 (2)',
  'CCI-000502': 'CP-4 (3)',
  'CCI-000503': 'CP-4 (3)',
  'CCI-000504': 'CP-4 (4)',
  'CCI-000505': 'CP-6 a',
  'CCI-000506': 'CP-6',
  'CCI-000507': 'CP-6 (1)',
  'CCI-000508': 'CP-6 (2)',
  'CCI-000509': 'CP-6 (3)',
  'CCI-000510': 'CP-7 a',
  'CCI-000511': 'CP-7',
  'CCI-000512': 'CP-7 a',
  'CCI-000513': 'CP-7 a',
  'CCI-000514': 'CP-7 a',
  'CCI-000515': 'CP-7 b',
  'CCI-000516': 'CP-7 (1)',
  'CCI-000517': 'CP-7 (2)',
  'CCI-000518': 'CP-7 (3)',
  'CCI-000519': 'CP-7 (4)',
  'CCI-000520': 'CP-7 (4)',
  'CCI-000521': 'CP-7 c',
  'CCI-000522': 'CP-8',
  'CCI-000523': 'CP-8',
  'CCI-000524': 'CP-8',
  'CCI-000525': 'CP-8',
  'CCI-000526': 'CP-8 (1) (a)',
  'CCI-000527': 'CP-8 (1) (a)',
  'CCI-000528': 'CP-8 (1) (b)',
  'CCI-000529': 'CP-8 (1) (b)',
  'CCI-000530': 'CP-8 (2)',
  'CCI-000531': 'CP-8 (3)',
  'CCI-000532': 'CP-8 (4) (a)',
  'CCI-000533': 'CP-8 (4) (a)',
  'CCI-000534': 'CP-9 (a)',
  'CCI-000535': 'CP-9 (a)',
  'CCI-000536': 'CP-9 (b)',
  'CCI-000537': 'CP-9 (b)',
  'CCI-000538': 'CP-9 (c)',
  'CCI-000539': 'CP-9 (c)',
  'CCI-000540': 'CP-9 (d)',
  'CCI-000541': 'CP-9 (1)',
  'CCI-000542': 'CP-9 (1)',
  'CCI-000543': 'CP-9 (2)',
  'CCI-000544': 'CP-9 (3)',
  'CCI-000545': 'CP-9 (3)',
  'CCI-000546': 'CP-9 (3)',
  'CCI-000547': 'CP-9 (5)',
  'CCI-000548': 'CP-9 (5)',
  'CCI-000549': 'CP-9 (6)',
  'CCI-000550': 'CP-10',
  'CCI-000551': 'CP-10',
  'CCI-000552': 'CP-10',
  'CCI-000553': 'CP-10 (2)',
  'CCI-000554': 'CP-10 (3)',
  'CCI-000555': 'CP-10 (3)',
  'CCI-000556': 'CP-10 (4)',
  'CCI-000557': 'CP-10 (4)',
  'CCI-000558': 'SI-13 (5)',
  'CCI-000559': 'SI-13 (5)',
  'CCI-000560': 'CP-10 (6)',
  'CCI-000561': 'CP-10 (6)',
  'CCI-000562': 'CP-10 (6)',
  'CCI-000563': 'PL-1 a 1 (a)',
  'CCI-000564': 'PL-1 a 1 (a)',
  'CCI-000565': 'PL-1 a',
  'CCI-000566': 'PL-1 a 2',
  'CCI-000567': 'PL-1 a 2',
  'CCI-000568': 'PL-1 c 2',
  'CCI-000570': 'PL-2 a',
  'CCI-000571': 'PL-2 a 15',
  'CCI-000572': 'PL-2 c',
  'CCI-000573': 'PL-2 c',
  'CCI-000574': 'PL-2 d',
  'CCI-000576': 'PL-2 (1) (a)',
  'CCI-000577': 'PL-7 b',
  'CCI-000578': 'PL-7 b',
  'CCI-000580': 'PL-2 (2) (a)',
  'CCI-000581': 'PL-2 (2) (a)',
  'CCI-000582': 'PL-2 (2) (a)',
  'CCI-000583': 'PL-2 (2) (b)',
  'CCI-000584': 'PL-2 (2) (b)',
  'CCI-000585': 'PL-2 (2) (c)',
  'CCI-000586': 'PL-2 (2) (d)',
  'CCI-000587': 'PL-2 (2) (d)',
  'CCI-000588': 'PL-2 (2) (d)',
  'CCI-000589': 'PL-2 (2) (d)',
  'CCI-000590': 'PL-2 (2) (e)',
  'CCI-000591': 'PL-2 (2) (e)',
  'CCI-000592': 'PL-4 a',
  'CCI-000593': 'PL-4 b',
  'CCI-000594': 'PL-4 (1) (a)',
  'CCI-000595': 'PL-4 (1) (b)',
  'CCI-000596': 'PL-4 (1)',
  'CCI-000597': 'PL-5',
  'CCI-000598': 'PL-6',
  'CCI-000599': 'PL-6',
  'CCI-000600': 'PL-6',
  'CCI-000601': 'SA-1 c 1',
  'CCI-000602': 'SA-1 a 1 (a)',
  'CCI-000603': 'SA-1 a 1',
  'CCI-000604': 'SA-1 c 1',
  'CCI-000605': 'SA-1 a 2',
  'CCI-000606': 'SA-1 a 2',
  'CCI-000607': 'SA-1 c 2',
  'CCI-000608': 'SA-2 a',
  'CCI-000609': 'SA-2 a',
  'CCI-000610': 'SA-2 b',
  'CCI-000611': 'SA-2 b',
  'CCI-000612': 'SA-2 b',
  'CCI-000613': 'SA-2 c',
  'CCI-000614': 'SA-2 c',
  'CCI-000615': 'SA-3 a',
  'CCI-000616': 'SA-3 b',
  'CCI-000617': 'SA-3 b',
  'CCI-000618': 'SA-3 c',
  'CCI-000619': 'SA-4 a',
  'CCI-000620': 'SA-4 b',
  'CCI-000621': 'SA-4 c',
  'CCI-000623': 'SA-4 (1)',
  'CCI-000624': 'SA-4 (2)',
  'CCI-000625': 'SA-4 (2)',
  'CCI-000626': 'SA-4 (3)',
  'CCI-000627': 'SA-4 (3)',
  'CCI-000628': 'SA-4 (3)',
  'CCI-000629': 'SA-4 (4)',
  'CCI-000630': 'SA-4 (5)',
  'CCI-000631': 'SA-4 (6) (a)',
  'CCI-000632': 'SA-4 (6) (a)',
  'CCI-000633': 'SA-4 (6) (b)',
  'CCI-000634': 'SA-4 (7) (a)',
  'CCI-000635': 'SA-4 (7) (b)',
  'CCI-000636': 'SA-5 a',
  'CCI-000637': 'SA-5 a',
  'CCI-000638': 'SA-5 a',
  'CCI-000639': 'SA-5 b',
  'CCI-000640': 'SA-5 b',
  'CCI-000641': 'SA-5 b',
  'CCI-000642': 'SA-5 c',
  'CCI-000643': 'SA-5 (1)',
  'CCI-000644': 'SA-5 (1)',
  'CCI-000645': 'SA-5 (2)',
  'CCI-000646': 'SA-5 (2)',
  'CCI-000647': 'SA-5 (3)',
  'CCI-000648': 'SA-5 (3)',
  'CCI-000650': 'SA-5 (4)',
  'CCI-000651': 'SA-5 (4)',
  'CCI-000653': 'SA-5 (5)',
  'CCI-000654': 'SA-5 (5)',
  'CCI-000655': 'SA-6 a',
  'CCI-000656': 'SA-6 b',
  'CCI-000657': 'SA-6 c',
  'CCI-000658': 'SA-6 c',
  'CCI-000659': 'SA-6 (1) (a)',
  'CCI-000660': 'SA-6 (1) (a)',
  'CCI-000661': 'SA-6 (1) (b)',
  'CCI-000662': 'SA-6 (1) (b)',
  'CCI-000663': 'SA-7',
  'CCI-000664': 'SA-8',
  'CCI-000665': 'SA-8',
  'CCI-000666': 'SA-8',
  'CCI-000667': 'SA-8',
  'CCI-000668': 'SA-8',
  'CCI-000669': 'SA-9',
  'CCI-000670': 'SA-9 a',
  'CCI-000671': 'SA-9 b',
  'CCI-000672': 'SA-9 b',
  'CCI-000673': 'SA-9 b',
  'CCI-000674': 'SA-9 b',
  'CCI-000675': 'SA-9 c',
  'CCI-000676': 'SA-9 (1) (a)',
  'CCI-000677': 'SA-9 (1) (a)',
  'CCI-000678': 'SA-9 (1) (b)',
  'CCI-000679': 'SA-9 (1) (b)',
  'CCI-000680': 'SA-9 (1) (b)',
  'CCI-000681': 'SA-9 (1) (b)',
  'CCI-000682': 'SA-10 (a)',
  'CCI-000683': 'SA-10 (a)',
  'CCI-000684': 'SA-10 (a)',
  'CCI-000685': 'SA-10 (a)',
  'CCI-000686': 'SA-10 (a)',
  'CCI-000687': 'SA-10 (a)',
  'CCI-000688': 'SA-10 (a)',
  'CCI-000689': 'SA-10 (a)',
  'CCI-000690': 'SA-10 (b)',
  'CCI-000691': 'SA-10 (b)',
  'CCI-000692': 'SA-10 c',
  'CCI-000693': 'SA-10 (c)',
  'CCI-000694': 'SA-10 d',
  'CCI-000695': 'SA-10 (d)',
  'CCI-000696': 'SA-10 (e)',
  'CCI-000697': 'SA-10 (e)',
  'CCI-000698': 'SA-10 (1)',
  'CCI-000699': 'SA-10 (1)',
  'CCI-000700': 'SA-10 (2)',
  'CCI-000701': 'SA-10 (2)',
  'CCI-000702': 'SA-11 (a)',
  'CCI-000703': 'SA-11 (a)',
  'CCI-000704': 'SA-11 (a)',
  'CCI-000705': 'SA-11 (a)',
  'CCI-000706': 'SA-11 (b)',
  'CCI-000707': 'SA-11 (b)',
  'CCI-000708': 'SA-11 (c)',
  'CCI-000709': 'SA-11 (c)',
  'CCI-000710': 'SA-11 (c)',
  'CCI-000711': 'SA-11 (c)',
  'CCI-000712': 'SA-11 (1)',
  'CCI-000713': 'SA-11 (1)',
  'CCI-000714': 'SA-11 (2)',
  'CCI-000715': 'SA-11 (2)',
  'CCI-000716': 'SA-11 (2)',
  'CCI-000717': 'SA-11 (2)',
  'CCI-000718': 'SA-11 (2)',
  'CCI-000719': 'SA-11 (2)',
  'CCI-000720': 'SA-11 (3)',
  'CCI-000721': 'SA-11 (3)',
  'CCI-000722': 'SA-12',
  'CCI-000723': 'SA-12',
  'CCI-000724': 'SA-12 (1)',
  'CCI-000725': 'SA-12 (2)',
  'CCI-000726': 'SA-12 (2)',
  'CCI-000727': 'SA-12 (2)',
  'CCI-000728': 'SA-12 (2)',
  'CCI-000729': 'SA-12 (3)',
  'CCI-000730': 'SA-12 (3)',
  'CCI-000731': 'SA-12 (3)',
  'CCI-000732': 'SA-12 (3)',
  'CCI-000733': 'SA-12 (3)',
  'CCI-000734': 'SA-12 (3)',
  'CCI-000735': 'SA-12 (4)',
  'CCI-000736': 'SA-12 (4)',
  'CCI-000737': 'SA-12 (4)',
  'CCI-000738': 'SA-12 (4)',
  'CCI-000739': 'SA-12 (5)',
  'CCI-000740': 'SA-12 (5)',
  'CCI-000741': 'SA-12 (5)',
  'CCI-000742': 'SA-12 (6)',
  'CCI-000743': 'SA-12 (6)',
  'CCI-000744': 'SA-12 (6)',
  'CCI-000745': 'SA-12 (7)',
  'CCI-000746': 'SA-12 (7)',
  'CCI-000747': 'SA-12 (7)',
  'CCI-000748': 'SA-13',
  'CCI-000749': 'SA-13',
  'CCI-000750': 'SA-14',
  'CCI-000751': 'SA-14 a',
  'CCI-000752': 'SA-14 b',
  'CCI-000753': 'SA-14 (1) (a)',
  'CCI-000754': 'SA-14 (1) (b)',
  'CCI-000755': 'SA-14 (1) (b)',
  'CCI-000756': 'IA-1 a 1',
  'CCI-000757': 'IA-1 a 1 (a)',
  'CCI-000758': 'IA-1 c 1',
  'CCI-000759': 'IA-1 c 1',
  'CCI-000760': 'IA-1 a 2',
  'CCI-000761': 'IA-1 a 2',
  'CCI-000762': 'IA-1 c 2',
  'CCI-000763': 'IA-1 c 2',
  'CCI-000764': 'IA-2',
  'CCI-000765': 'IA-2 (1)',
  'CCI-000766': 'IA-2 (2)',
  'CCI-000767': 'IA-2 (3)',
  'CCI-000768': 'IA-2 (4)',
  'CCI-000769': 'IA-2 (5) (a)',
  'CCI-000770': 'IA-2 (5)',
  'CCI-000771': 'IA-2 (6)',
  'CCI-000772': 'IA-2 (7)',
  'CCI-000773': 'IA-2 (8)',
  'CCI-000774': 'IA-2 (8)',
  'CCI-000775': 'IA-2 (9)',
  'CCI-000776': 'IA-2 (9)',
  'CCI-000777': 'IA-3',
  'CCI-000778': 'IA-3',
  'CCI-000779': 'IA-3 (1)',
  'CCI-000780': 'IA-3 (1)',
  'CCI-000781': 'IA-3 (2)',
  'CCI-000782': 'IA-3 (3)',
  'CCI-000783': 'IA-3 (3) (b)',
  'CCI-000784': 'IA-4 a',
  'CCI-000785': 'IA-4 a',
  'CCI-000786': 'IA-4 b',
  'CCI-000787': 'IA-4 b',
  'CCI-000788': 'IA-4 c',
  'CCI-000789': 'IA-4 c',
  'CCI-000790': 'IA-4 d',
  'CCI-000791': 'IA-4 d',
  'CCI-000792': 'IA-4 d',
  'CCI-000793': 'IA-4 d',
  'CCI-000794': 'IA-4 e',
  'CCI-000795': 'IA-4 e',
  'CCI-000796': 'IA-4 (1)',
  'CCI-000797': 'IA-4 (2)',
  'CCI-000798': 'IA-4 (2)',
  'CCI-000799': 'IA-4 (3)',
  'CCI-000800': 'IA-4 (4)',
  'CCI-000801': 'IA-4 (4)',
  'CCI-000802': 'IA-4 (5)',
  'CCI-000803': 'IA-7',
  'CCI-000804': 'IA-8',
  'CCI-000805': 'IR-1 a 1 (a)',
  'CCI-000806': 'IR-1 a 1 (a)',
  'CCI-000807': 'IR-1 c 1',
  'CCI-000808': 'IR-1 c 1',
  'CCI-000809': 'IR-1 a 2',
  'CCI-000810': 'IR-1 a 2',
  'CCI-000811': 'IR-1 c 2',
  'CCI-000812': 'IR-1 c 2',
  'CCI-000813': 'IR-2 a 1',
  'CCI-000814': 'IR-2 a 3',
  'CCI-000815': 'IR-2 c',
  'CCI-000816': 'IR-2 (1)',
  'CCI-000817': 'IR-2 (2)',
  'CCI-000818': 'IR-3',
  'CCI-000819': 'IR-3',
  'CCI-000820': 'IR-3',
  'CCI-000821': 'IR-3 (1)',
  'CCI-000822': 'IR-4 a',
  'CCI-000823': 'IR-4 b',
  'CCI-000824': 'IR-4 c',
  'CCI-000825': 'IR-4 (1)',
  'CCI-000826': 'IR-4 (2)',
  'CCI-000827': 'IR-4 (3)',
  'CCI-000828': 'IR-4 (3)',
  'CCI-000829': 'IR-4 (4)',
  'CCI-000830': 'IR-4 (5)',
  'CCI-000831': 'IR-4 (5)',
  'CCI-000832': 'IR-5',
  'CCI-000833': 'IR-5 (1)',
  'CCI-000834': 'IR-6 a',
  'CCI-000835': 'IR-6 a',
  'CCI-000836': 'IR-6 b',
  'CCI-000837': 'IR-6 (1)',
  'CCI-000838': 'IR-6 (2)',
  'CCI-000839': 'IR-7',
  'CCI-000840': 'IR-7 (1)',
  'CCI-000841': 'IR-7 (2) (a)',
  'CCI-000842': 'IR-7 (2) (b)',
  'CCI-000843': 'IR-8 a',
  'CCI-000844': 'IR-8 a 9',
  'CCI-000845': 'IR-8 b',
  'CCI-000846': 'IR-8 b',
  'CCI-000847': 'IR-8 c',
  'CCI-000848': 'IR-8 c',
  'CCI-000849': 'IR-8 c',
  'CCI-000850': 'IR-8 d',
  'CCI-000851': 'MA-1 c 1',
  'CCI-000852': 'MA-1 a 1 (a)',
  'CCI-000853': 'MA-1 a 1',
  'CCI-000854': 'MA-1 c 1',
  'CCI-000855': 'MA-1 a 2',
  'CCI-000856': 'MA-1 a 2',
  'CCI-000857': 'MA-1 c 2',
  'CCI-000858': 'MA-2 a',
  'CCI-000859': 'MA-2 b',
  'CCI-000860': 'MA-2 c',
  'CCI-000861': 'MA-2 d',
  'CCI-000862': 'MA-2 e',
  'CCI-000863': 'MA-2 (1) (a)(b)(c)(d)(e)',
  'CCI-000864': 'MA-2 (2)',
  'CCI-000865': 'MA-3 a',
  'CCI-000866': 'MA-3 a',
  'CCI-000867': 'MA-3 a',
  'CCI-000868': 'MA-3',
  'CCI-000869': 'MA-3 (1)',
  'CCI-000870': 'MA-3 (2)',
  'CCI-000871': 'MA-3 (3)',
  'CCI-000872': 'MA-3 (4)',
  'CCI-000873': 'MA-4 a',
  'CCI-000874': 'MA-4 a',
  'CCI-000875': 'MA-4 a',
  'CCI-000876': 'MA-4 b',
  'CCI-000877': 'MA-4 c',
  'CCI-000878': 'MA-4 d',
  'CCI-000879': 'MA-4 e',
  'CCI-000880': 'MA-4 (1)',
  'CCI-000881': 'MA-4 (2)',
  'CCI-000882': 'MA-4 (3) (a)',
  'CCI-000883': 'MA-4 (3) (b)',
  'CCI-000884': 'MA-4 (4) (a)',
  'CCI-000885': 'MA-4 (5) (a)',
  'CCI-000886': 'MA-4 (5) (b)',
  'CCI-000887': 'MA-4 (5) (a)',
  'CCI-000888': 'MA-4 (6)',
  'CCI-000889': 'MA-4 (7)',
  'CCI-000890': 'MA-5 a',
  'CCI-000891': 'MA-5 a',
  'CCI-000892': 'MA-5 b',
  'CCI-000893': 'MA-5 (1) (a)',
  'CCI-000894': 'MA-5 (1) (a) (1)',
  'CCI-000895': 'MA-5 (1) (a) (2)',
  'CCI-000896': 'MA-5 (1) (c)',
  'CCI-000897': 'MA-5 (2)',
  'CCI-000898': 'MA-5 (3)',
  'CCI-000899': 'MA-5 (4) (a)',
  'CCI-000900': 'MA-5 (4) (b)',
  'CCI-000901': 'MA-6',
  'CCI-000902': 'MA-6',
  'CCI-000903': 'MA-6',
  'CCI-000904': 'PE-1 a 1 (a)',
  'CCI-000905': 'PE-1 a 1',
  'CCI-000906': 'PE-1 c 1',
  'CCI-000907': 'PE-1 c 1',
  'CCI-000908': 'PE-1 a 2',
  'CCI-000909': 'PE-1 a 2',
  'CCI-000910': 'PE-1 c 2',
  'CCI-000911': 'PE-1 c 2',
  'CCI-000912': 'PE-2 a',
  'CCI-000913': 'PE-2 b',
  'CCI-000914': 'PE-2 c',
  'CCI-000915': 'PE-2 c',
  'CCI-000916': 'PE-2 (1)',
  'CCI-000917': 'PE-2 (2)',
  'CCI-000918': 'PE-2 (3)',
  'CCI-000919': 'PE-3 a',
  'CCI-000920': 'PE-3 a 1',
  'CCI-000921': 'PE-3 a 2',
  'CCI-000922': 'PE-3 d',
  'CCI-000923': 'PE-3 e',
  'CCI-000924': 'PE-3 f',
  'CCI-000925': 'PE-3 f',
  'CCI-000926': 'PE-3 g',
  'CCI-000927': 'PE-3 g',
  'CCI-000928': 'PE-3 (1)',
  'CCI-000929': 'PE-3 (2)',
  'CCI-000930': 'PE-3 (3)',
  'CCI-000931': 'PE-3 (4)',
  'CCI-000932': 'PE-3 (4)',
  'CCI-000933': 'PE-3 (5)',
  'CCI-000934': 'PE-3 (6)',
  'CCI-000935': 'PE-3 (6)',
  'CCI-000936': 'PE-4',
  'CCI-000937': 'PE-5',
  'CCI-000938': 'PE-6 a',
  'CCI-000939': 'PE-6 b',
  'CCI-000940': 'PE-6 b',
  'CCI-000941': 'PE-6 c',
  'CCI-000942': 'PE-6 (1)',
  'CCI-000943': 'PE-6 (2)',
  'CCI-000944': 'PE-7',
  'CCI-000945': 'PE-7 (1)',
  'CCI-000946': 'PE-7 (2)',
  'CCI-000947': 'PE-8 a',
  'CCI-000948': 'PE-8 b',
  'CCI-000949': 'PE-8 b',
  'CCI-000950': 'PE-8 (1)',
  'CCI-000951': 'PE-8 (2)',
  'CCI-000952': 'PE-9',
  'CCI-000953': 'PE-9 (1)',
  'CCI-000954': 'PE-9 (2)',
  'CCI-000955': 'PE-9 (2)',
  'CCI-000956': 'PE-10 a',
  'CCI-000957': 'PE-10 b',
  'CCI-000958': 'PE-10 b',
  'CCI-000959': 'PE-10 c',
  'CCI-000960': 'PE-11',
  'CCI-000961': 'PE-11 (1)',
  'CCI-000962': 'PE-11 (2)',
  'CCI-000963': 'PE-12',
  'CCI-000964': 'PE-12 (1)',
  'CCI-000965': 'PE-13',
  'CCI-000966': 'PE-13 (1)',
  'CCI-000967': 'PE-13 (2)',
  'CCI-000968': 'PE-13 (2) (b)',
  'CCI-000969': 'PE-13 (4)',
  'CCI-000970': 'PE-13 (4)',
  'CCI-000971': 'PE-14 a',
  'CCI-000972': 'PE-14 a',
  'CCI-000973': 'PE-14 b',
  'CCI-000974': 'PE-14 b',
  'CCI-000975': 'PE-14 (1)',
  'CCI-000976': 'PE-14 (2)',
  'CCI-000977': 'PE-15',
  'CCI-000978': 'PE-15',
  'CCI-000979': 'PE-15',
  'CCI-000980': 'PE-15 (1)',
  'CCI-000981': 'PE-16 a',
  'CCI-000982': 'PE-16',
  'CCI-000983': 'PE-16 a',
  'CCI-000984': 'PE-16 b',
  'CCI-000985': 'PE-17 b',
  'CCI-000986': 'PE-17 a',
  'CCI-000987': 'PE-17 c',
  'CCI-000988': 'PE-17 d',
  'CCI-000989': 'PE-18',
  'CCI-000990': 'PE-18',
  'CCI-000991': 'PE-18',
  'CCI-000992': 'PE-18 (1)',
  'CCI-000993': 'PE-19',
  'CCI-000994': 'PE-19 (1)',
  'CCI-000995': 'MP-1 a 1 (a)',
  'CCI-000996': 'MP-1 a 1',
  'CCI-000997': 'MP-1 c 1',
  'CCI-000998': 'MP-1 c 1',
  'CCI-000999': 'MP-1 a 2',
  'CCI-001000': 'MP-1 a 2',
  'CCI-001001': 'MP-1 c 2',
  'CCI-001002': 'MP-1 c 2',
  'CCI-001003': 'MP-2',
  'CCI-001004': 'MP-2',
  'CCI-001005': 'MP-2',
  'CCI-001006': 'MP-2',
  'CCI-001007': 'MP-4 (2)',
  'CCI-001008': 'MP-4 (2)',
  'CCI-001009': 'MP-2 (2)',
  'CCI-001010': 'MP-3 a',
  'CCI-001011': 'MP-3 b',
  'CCI-001012': 'MP-3 b',
  'CCI-001013': 'MP-3 b',
  'CCI-001014': 'MP-4 a',
  'CCI-001015': 'MP-4 a',
  'CCI-001016': 'MP-4 a',
  'CCI-001017': 'MP-4 a',
  'CCI-001018': 'MP-4 b',
  'CCI-001019': 'MP-4 (1)',
  'CCI-001020': 'MP-5 a',
  'CCI-001021': 'MP-5 a',
  'CCI-001022': 'MP-5 a',
  'CCI-001023': 'MP-5 b',
  'CCI-001024': 'MP-5 d',
  'CCI-001025': 'MP-5 c',
  'CCI-001026': 'MP-5 (3)',
  'CCI-001027': 'MP-5 (4)',
  'CCI-001028': 'MP-6 a',
  'CCI-001029': 'MP-6 (1)',
  'CCI-001030': 'MP-6 (2)',
  'CCI-001031': 'MP-6 (2)',
  'CCI-001032': 'MP-6 (3)',
  'CCI-001033': 'MP-6 (3)',
  'CCI-001034': 'MP-6 (4)',
  'CCI-001035': 'MP-6 (5)',
  'CCI-001036': 'MP-6 (6)',
  'CCI-001037': 'RA-1 a 1 (a)',
  'CCI-001038': 'RA-1 a 1 (a)',
  'CCI-001039': 'RA-1 c 1',
  'CCI-001040': 'RA-1 c 1',
  'CCI-001041': 'RA-1 a 2',
  'CCI-001042': 'RA-1 a 2',
  'CCI-001043': 'RA-1 c 2',
  'CCI-001044': 'RA-1 c 2',
  'CCI-001045': 'RA-2 a',
  'CCI-001046': 'RA-2 b',
  'CCI-001047': 'RA-2 c',
  'CCI-001048': 'RA-3 a 2',
  'CCI-001049': 'RA-3 c',
  'CCI-001050': 'RA-3 d',
  'CCI-001051': 'RA-3 d',
  'CCI-001052': 'RA-3 f',
  'CCI-001053': 'RA-3 f',
  'CCI-001054': 'RA-5 a',
  'CCI-001055': 'RA-5 a',
  'CCI-001056': 'RA-5 a',
  'CCI-001057': 'RA-5 b 1',
  'CCI-001058': 'RA-5 c',
  'CCI-001059': 'RA-5 d',
  'CCI-001060': 'RA-5 d',
  'CCI-001061': 'RA-5 e',
  'CCI-001062': 'RA-5 (1)',
  'CCI-001063': 'RA-5 (2)',
  'CCI-001064': 'RA-5 (2)',
  'CCI-001065': 'RA-5 (3)',
  'CCI-001066': 'RA-5 (4)',
  'CCI-001067': 'RA-5 (5)',
  'CCI-001068': 'RA-5 (6)',
  'CCI-001069': 'RA-5 (7)',
  'CCI-001070': 'RA-5 (7)',
  'CCI-001071': 'RA-5 (8)',
  'CCI-001072': 'RA-5 (9) (a)',
  'CCI-001073': 'RA-5 (9) (b)',
  'CCI-001074': 'SC-1 a 1',
  'CCI-001075': 'SC-1 a 1  ',
  'CCI-001076': 'SC-1 c 1',
  'CCI-001077': 'SC-1 c 1',
  'CCI-001078': 'SC-1 a 2',
  'CCI-001079': 'SC-1 a 2',
  'CCI-001080': 'SC-1 c 2',
  'CCI-001081': 'SC-1 c 2',
  'CCI-001082': 'SC-2',
  'CCI-001083': 'SC-2 (1)',
  'CCI-001084': 'SC-3',
  'CCI-001085': 'SC-3 (1)',
  'CCI-001086': 'SC-3 (2)',
  'CCI-001087': 'SC-3 (3)',
  'CCI-001088': 'SC-3 (4)',
  'CCI-001089': 'SC-3 (5)',
  'CCI-001090': 'SC-4',
  'CCI-001091': 'SC-4 (1)',
  'CCI-001092': 'SC-5',
  'CCI-001093': 'SC-5 a',
  'CCI-001094': 'SC-5 (1)',
  'CCI-001095': 'SC-5 (2)',
  'CCI-001096': 'SC-6',
  'CCI-001097': 'SC-7 a',
  'CCI-001098': 'SC-7 c',
  'CCI-001099': 'SC-7 (1)',
  'CCI-001100': 'SC-7 (2)',
  'CCI-001101': 'SC-7 (3)',
  'CCI-001102': 'SC-7 (4) (a)',
  'CCI-001103': 'SC-7 (4) (b)',
  'CCI-001104': 'SC-7 (4) (c)',
  'CCI-001105': 'SC-7 (4) (d)',
  'CCI-001106': 'SC-7 (4) (e)',
  'CCI-001107': 'SC-7 (4) (e)',
  'CCI-001108': 'SC-7 (4) (e)',
  'CCI-001109': 'SC-7 (5)',
  'CCI-001110': 'SC-7 (6)',
  'CCI-001111': 'SC-7 (7)',
  'CCI-001112': 'SC-7 (8)',
  'CCI-001113': 'SC-7 (8)',
  'CCI-001114': 'SC-7 (8)',
  'CCI-001115': 'SC-7 (9)',
  'CCI-001116': 'SC-7 (10) (a)',
  'CCI-001117': 'SC-7 (11)',
  'CCI-001118': 'SC-7 (12)',
  'CCI-001119': 'SC-7 (13)',
  'CCI-001120': 'SC-7 (13)',
  'CCI-001121': 'SC-7 (14)',
  'CCI-001122': 'SC-7 (14)',
  'CCI-001123': 'SC-7 (15)',
  'CCI-001124': 'SC-7 (16)',
  'CCI-001125': 'SC-7 (17)',
  'CCI-001126': 'SC-7 (18)',
  'CCI-001127': 'SC-8',
  'CCI-001128': 'SC-8 (1)',
  'CCI-001129': 'SC-8 (2)',
  'CCI-001130': 'SC-9',
  'CCI-001131': 'SC-9 (1)',
  'CCI-001132': 'SC-9 (2)',
  'CCI-001133': 'SC-10',
  'CCI-001134': 'SC-10',
  'CCI-001135': 'SC-11 a',
  'CCI-001136': 'SC-11',
  'CCI-001137': 'SC-12',
  'CCI-001138': 'SC-12',
  'CCI-001139': 'SC-12 (1)',
  'CCI-001140': 'SC-12 (2)',
  'CCI-001141': 'SC-12 (3)',
  'CCI-001142': 'SC-12 (4)',
  'CCI-001143': 'SC-12 (5)',
  'CCI-001144': 'SC-13',
  'CCI-001145': 'SC-13 (1)',
  'CCI-001146': 'SC-13 (2)',
  'CCI-001147': 'SC-13 (3)',
  'CCI-001148': 'AU-10 (5)',
  'CCI-001149': 'SC-14',
  'CCI-001150': 'SC-15 a',
  'CCI-001151': 'SC-15 a',
  'CCI-001152': 'SC-15 b',
  'CCI-001153': 'SC-15 (1)',
  'CCI-001154': 'SC-15 (2)',
  'CCI-001155': 'SC-15 (3)',
  'CCI-001156': 'SC-15 (3)',
  'CCI-001157': 'SC-16',
  'CCI-001158': 'SC-16 (1)',
  'CCI-001159': 'SC-17 a',
  'CCI-001160': 'SC-18 a',
  'CCI-001161': 'SC-18 b',
  'CCI-001162': 'SC-18 b',
  'CCI-001163': 'SC-18 b',
  'CCI-001164': 'SC-18 b',
  'CCI-001165': 'SC-18 b',
  'CCI-001166': 'SC-18 (1)',
  'CCI-001167': 'SC-18 (2)',
  'CCI-001168': 'SC-18 (2)',
  'CCI-001169': 'SC-18 (3)',
  'CCI-001170': 'SC-18 (4)',
  'CCI-001171': 'SC-18 (4)',
  'CCI-001172': 'SC-18 (4)',
  'CCI-001173': 'SC-19 a',
  'CCI-001174': 'SC-19 a',
  'CCI-001175': 'SC-19 b',
  'CCI-001176': 'SC-19 b',
  'CCI-001177': 'SC-19 b',
  'CCI-001178': 'SC-20 a',
  'CCI-001179': 'SC-20 b',
  'CCI-001180': 'SC-21',
  'CCI-001181': 'SC-21 (1)',
  'CCI-001182': 'SC-22',
  'CCI-001183': 'SC-22',
  'CCI-001184': 'SC-23',
  'CCI-001185': 'SC-23 (1)',
  'CCI-001186': 'SC-23 (2)',
  'CCI-001187': 'SC-23 (3)',
  'CCI-001188': 'SC-23 (3)',
  'CCI-001189': 'SC-23 (3)',
  'CCI-001190': 'SC-24',
  'CCI-001191': 'SC-24',
  'CCI-001192': 'SC-24',
  'CCI-001193': 'SC-24',
  'CCI-001194': 'SC-25',
  'CCI-001195': 'SC-26',
  'CCI-001196': 'SC-35',
  'CCI-001197': 'SC-27',
  'CCI-001198': 'SC-27',
  'CCI-001199': 'SC-28',
  'CCI-001200': 'SC-28 (1)',
  'CCI-001201': 'SC-29',
  'CCI-001202': 'SC-30',
  'CCI-001203': 'SC-29 (1)',
  'CCI-001204': 'SC-29 (1)',
  'CCI-001205': 'SC-30 (2)',
  'CCI-001206': 'SC-31',
  'CCI-001207': 'SC-31 (1)',
  'CCI-001208': 'SC-32',
  'CCI-001209': 'SC-33',
  'CCI-001210': 'SC-34 a',
  'CCI-001211': 'SC-34 b',
  'CCI-001212': 'SC-34',
  'CCI-001213': 'SC-34 b',
  'CCI-001214': 'SC-34 (1)',
  'CCI-001215': 'SC-34 (1)',
  'CCI-001216': 'SC-34 (2)',
  'CCI-001217': 'SI-1 a 1 (a)',
  'CCI-001218': 'SI-1 a 1',
  'CCI-001219': 'SI-1 c 1',
  'CCI-001220': 'SI-1 a 2',
  'CCI-001221': 'SI-1 a 2',
  'CCI-001222': 'SI-1 c 2',
  'CCI-001223': 'SI-1 c 1',
  'CCI-001224': 'SI-1 c 2',
  'CCI-001225': 'SI-2 a',
  'CCI-001226': 'SI-2 a',
  'CCI-001227': 'SI-2 a',
  'CCI-001228': 'SI-2 b',
  'CCI-001229': 'SI-2 b',
  'CCI-001230': 'SI-2 d',
  'CCI-001231': 'SI-2 (1)',
  'CCI-001232': 'SI-2 (1)',
  'CCI-001233': 'SI-2 (2)',
  'CCI-001234': 'SI-2 (2)',
  'CCI-001235': 'SI-2 (3) (a)',
  'CCI-001236': 'SI-2 (3) (b)',
  'CCI-001237': 'SI-2 (4)',
  'CCI-001238': 'SI-2 (4)',
  'CCI-001239': 'SI-3 a',
  'CCI-001240': 'SI-3 b',
  'CCI-001241': 'SI-3 c 1',
  'CCI-001242': 'SI-3 c 1',
  'CCI-001243': 'SI-3 c 2',
  'CCI-001244': 'SI-3 c 2',
  'CCI-001245': 'SI-3 d',
  'CCI-001246': 'SI-3 (1)',
  'CCI-001247': 'SI-3 (2)',
  'CCI-001248': 'SI-3 (3)',
  'CCI-001249': 'SI-3 (4)',
  'CCI-001250': 'SI-3 (5)',
  'CCI-001251': 'SI-3 (6) (a)',
  'CCI-001252': 'SI-4 a',
  'CCI-001253': 'SI-4 a 1',
  'CCI-001254': 'SI-4 b',
  'CCI-001255': 'SI-4 c 1',
  'CCI-001256': 'SI-4 c 2',
  'CCI-001257': 'SI-4 e',
  'CCI-001258': 'SI-4 f',
  'CCI-001259': 'SI-4 (1)',
  'CCI-001260': 'SI-4 (2)',
  'CCI-001261': 'SI-4 (3)',
  'CCI-001262': 'SI-4 (4)',
  'CCI-001263': 'SI-4 (5)',
  'CCI-001264': 'SI-4 (5)',
  'CCI-001265': 'SI-4 (6)',
  'CCI-001266': 'SI-4 (7) (a)',
  'CCI-001267': 'SI-4 (7) (a)',
  'CCI-001268': 'SI-4 (7) (b)',
  'CCI-001269': 'SI-4 (8)',
  'CCI-001270': 'SI-4 (9)',
  'CCI-001271': 'SI-4 (9)',
  'CCI-001272': 'SI-4 (10)',
  'CCI-001273': 'SI-4 (11)',
  'CCI-001274': 'SI-4 (12)',
  'CCI-001275': 'SI-4 (12)',
  'CCI-001276': 'SI-4 (13) (a)',
  'CCI-001277': 'SI-4 (13) (b)',
  'CCI-001278': 'SI-4 (13) (c)',
  'CCI-001279': 'SI-4 (13) (c)',
  'CCI-001280': 'SI-4 (13) (c)',
  'CCI-001281': 'SI-4 (14)',
  'CCI-001282': 'SI-4 (15)',
  'CCI-001283': 'SI-4 (16)',
  'CCI-001284': 'SI-4 (17)',
  'CCI-001285': 'SI-5 a',
  'CCI-001286': 'SI-5 b',
  'CCI-001287': 'SI-5 c',
  'CCI-001288': 'SI-5 c',
  'CCI-001289': 'SI-5 d',
  'CCI-001290': 'SI-5 (1)',
  'CCI-001291': 'SI-6',
  'CCI-001292': 'SI-6',
  'CCI-001293': 'SI-6',
  'CCI-001294': 'SI-6 c',
  'CCI-001295': 'SI-6 (2)',
  'CCI-001296': 'SI-6 (3)',
  'CCI-001297': 'SI-7',
  'CCI-001298': 'SI-7 (1)',
  'CCI-001299': 'SI-7 (1)',
  'CCI-001300': 'SI-7 (2)',
  'CCI-001301': 'SI-7 (3)',
  'CCI-001302': 'SI-7 (4)',
  'CCI-001303': 'SI-7 (4)',
  'CCI-001304': 'SI-7 (4)',
  'CCI-001305': 'SI-8 a',
  'CCI-001306': 'SI-8 b',
  'CCI-001307': 'SI-8 (1)',
  'CCI-001308': 'SI-8 (2)',
  'CCI-001309': 'SI-9',
  'CCI-001310': 'SI-10',
  'CCI-001311': 'SI-11 a',
  'CCI-001312': 'SI-11 a',
  'CCI-001313': 'SI-11 b',
  'CCI-001314': 'SI-11 b',
  'CCI-001315': 'SI-12',
  'CCI-001316': 'SI-13 a',
  'CCI-001317': 'SI-13 a',
  'CCI-001318': 'SI-13 b',
  'CCI-001319': 'SI-13 (1)',
  'CCI-001320': 'SI-13 (1)',
  'CCI-001321': 'SI-7 (16)',
  'CCI-001322': 'SI-7 (16)',
  'CCI-001323': 'SI-13 (3)',
  'CCI-001324': 'SI-13 (3)',
  'CCI-001325': 'SI-13 (3)',
  'CCI-001326': 'SI-13 (4) (a)',
  'CCI-001327': 'SI-13 (4) (a)',
  'CCI-001328': 'SI-13 (4) (b)',
  'CCI-001329': 'SI-13 (4) (b)',
  'CCI-001330': 'AC-19 (4) (a)',
  'CCI-001331': 'AC-19 (4) (b) (1)',
  'CCI-001332': 'AC-19 (4) (b) (2)',
  'CCI-001333': 'AC-19 (4) (b) (3)',
  'CCI-001334': 'AC-19 (4) (b) (4)',
  'CCI-001335': 'AC-19 (4) (b) (4)',
  'CCI-001336': 'AT-4 b',
  'CCI-001337': 'AT-4 b',
  'CCI-001338': 'AU-10 (1)',
  'CCI-001339': 'AU-10 (2)',
  'CCI-001340': 'AU-10 (3)',
  'CCI-001341': 'AU-10 (4) (a)',
  'CCI-001342': 'AU-10 (5)',
  'CCI-001343': 'AU-5 (4)',
  'CCI-001344': 'AU-6 (7)',
  'CCI-001345': 'AU-6 (8)',
  'CCI-001346': 'AU-6 (8)',
  'CCI-001347': 'AU-6 (9)',
  'CCI-001348': 'AU-9 (2)',
  'CCI-001349': 'AU-9 (2)',
  'CCI-001350': 'AU-9 (3)',
  'CCI-001351': 'AU-9 (4)',
  'CCI-001352': 'AU-9 (4) (b)',
  'CCI-001353': 'AU-12 (2)',
  'CCI-001354': 'AC-2 h',
  'CCI-001355': 'AC-2 h',
  'CCI-001356': 'AC-2 (5) (c)',
  'CCI-001357': 'AC-2 (5) (d)',
  'CCI-001358': 'AC-2 (7) (a)',
  'CCI-001359': 'AC-2 (7) (b)',
  'CCI-001360': 'AC-2 (7) (b)',
  'CCI-001361': 'AC-2 (2)',
  'CCI-001362': 'AC-3 (4)',
  'CCI-001363': 'AC-3 (4) (a)',
  'CCI-001365': 'AC-2 (2)',
  'CCI-001366': 'AC-3 (6)',
  'CCI-001367': 'AC-3 (6)',
  'CCI-001368': 'AC-4',
  'CCI-001371': 'AC-4 (14)',
  'CCI-001372': 'AC-4 (14)',
  'CCI-001373': 'AC-4 (15)',
  'CCI-001374': 'AC-4 (15)',
  'CCI-001376': 'AC-4 (17) (a)',
  'CCI-001377': 'AC-4 (17) (a)',
  'CCI-001380': 'AC-5 b',
  'CCI-001382': 'AC-7 (2)',
  'CCI-001383': 'AC-7 (2)',
  'CCI-001384': 'AC-8 c 1',
  'CCI-001385': 'AC-8 c 2',
  'CCI-001386': 'AC-8 c 2',
  'CCI-001387': 'AC-8 c 2',
  'CCI-001388': 'AC-8 c 3',
  'CCI-001389': 'AC-9 (2)',
  'CCI-001390': 'AC-9 (2)',
  'CCI-001391': 'AC-9 (2)',
  'CCI-001392': 'AC-9 (2)',
  'CCI-001393': 'AC-9 (3)',
  'CCI-001394': 'AC-9 (3)',
  'CCI-001395': 'AC-9 (3)',
  'CCI-001396': 'AC-16',
  'CCI-001397': 'AC-16',
  'CCI-001398': 'AC-16',
  'CCI-001399': 'AC-16',
  'CCI-001400': 'AC-16',
  'CCI-001401': 'AC-16',
  'CCI-001402': 'AC-17 c',
  'CCI-001403': 'AC-2 (4)',
  'CCI-001404': 'AC-2 (4)',
  'CCI-001405': 'AC-2 (4)',
  'CCI-001406': 'AC-2 (5)',
  'CCI-001407': 'AC-2 (7) (a)',
  'CCI-001408': 'AC-3 (2)',
  'CCI-001409': 'AC-3 (3)',
  'CCI-001410': 'AC-3 (3)',
  'CCI-001411': 'AC-3 (5)',
  'CCI-001412': 'AC-3 (6)',
  'CCI-001413': 'AC-3 (6)',
  'CCI-001414': 'AC-4',
  'CCI-001415': 'AC-4 (5)',
  'CCI-001416': 'AC-4 (7)',
  'CCI-001417': 'AC-4 (8) (a)',
  'CCI-001418': 'AC-4 (9)',
  'CCI-001419': 'AC-6 (2)',
  'CCI-001420': 'AC-6 (3)',
  'CCI-001421': 'AC-6 (5)',
  'CCI-001422': 'AC-6 (6)',
  'CCI-001423': 'AC-7 a',
  'CCI-001424': 'AC-16 (1)',
  'CCI-001425': 'AC-16 (2)',
  'CCI-001426': 'AC-16 (3)',
  'CCI-001427': 'AC-16 (4)',
  'CCI-001428': 'AC-16 (4)',
  'CCI-001429': 'AC-16 (5)',
  'CCI-001430': 'AC-16 (5)',
  'CCI-001431': 'AC-17 (5)',
  'CCI-001432': 'AC-17 (5)',
  'CCI-001433': 'AC-17 (7)',
  'CCI-001434': 'AC-17 (7)',
  'CCI-001435': 'AC-17 (8)',
  'CCI-001436': 'AC-17 (8)',
  'CCI-001437': 'AC-17 (4)',
  'CCI-001438': 'AC-18 a',
  'CCI-001439': 'AC-18 a',
  'CCI-001440': 'AC-18 b',
  'CCI-001441': 'AC-18 b',
  'CCI-001442': 'AC-18 d',
  'CCI-001443': 'AC-18 (1)',
  'CCI-001444': 'AC-18 (1)',
  'CCI-001445': 'AC-18 (2)',
  'CCI-001446': 'AC-18 (2)',
  'CCI-001447': 'AC-18 (2)',
  'CCI-001448': 'AC-18 (2)',
  'CCI-001449': 'AC-18 (3)',
  'CCI-001450': 'AC-18 (4)',
  'CCI-001451': 'AC-18 (5)',
  'CCI-001452': 'AC-7 a',
  'CCI-001453': 'AC-17 (2)',
  'CCI-001454': 'AC-17 (7)',
  'CCI-001455': 'AC-17 (8)',
  'CCI-001456': 'AC-19 f',
  'CCI-001457': 'AC-19 g',
  'CCI-001458': 'AC-19 (4) (b) (4)',
  'CCI-001459': 'AU-12 a',
  'CCI-001460': 'AU-13 a',
  'CCI-001461': 'AU-13 a',
  'CCI-001462': 'AU-14 (2)',
  'CCI-001463': 'AU-14 b',
  'CCI-001464': 'AU-14 (1)',
  'CCI-001465': 'AC-20 b',
  'CCI-001466': 'AC-20 b',
  'CCI-001467': 'AC-20 (1) (a)',
  'CCI-001468': 'AC-20 (1) (a)',
  'CCI-001469': 'AC-20 (1) (a)',
  'CCI-001470': 'AC-21 a',
  'CCI-001471': 'AC-21 b',
  'CCI-001472': 'AC-21 b',
  'CCI-001473': 'AC-22 a',
  'CCI-001474': 'AC-22 b',
  'CCI-001475': 'AC-22 c',
  'CCI-001476': 'AC-22 d',
  'CCI-001477': 'AC-22 d',
  'CCI-001478': 'AC-22 d',
  'CCI-001479': 'AT-2 c',
  'CCI-001480': 'AT-2',
  'CCI-001481': 'AT-3 (1)',
  'CCI-001482': 'AT-3 (1)',
  'CCI-001483': 'AT-3 (1)',
  'CCI-001484': 'AU-2 c',
  'CCI-001485': 'AU-2 c',
  'CCI-001486': 'AU-2 (3)',
  'CCI-001487': 'AU-3 f',
  'CCI-001488': 'AU-3 (1)',
  'CCI-001489': 'AU-3 (2)',
  'CCI-001490': 'AU-5 b',
  'CCI-001491': 'AU-6 (6)',
  'CCI-001492': 'AU-8 (1) (a)',
  'CCI-001493': 'AU-9 a',
  'CCI-001494': 'AU-9',
  'CCI-001495': 'AU-9',
  'CCI-001496': 'AU-9 (3)',
  'CCI-001497': 'CM-2 b 1',
  'CCI-001498': 'CM-3 (1) (c)',
  'CCI-001499': 'CM-5 (6)',
  'CCI-001500': 'CM-5 (7)',
  'CCI-001501': 'CM-5 (7)',
  'CCI-001502': 'CM-6 d',
  'CCI-001503': 'CM-6 d',
  'CCI-001504': 'PS-1 a 1 (a)',
  'CCI-001505': 'PS-1 a 1',
  'CCI-001506': 'PS-1 c 1',
  'CCI-001507': 'PS-1 c 1',
  'CCI-001508': 'PS-1 c 2',
  'CCI-001509': 'PS-1 a 2',
  'CCI-001510': 'PS-1 a 2',
  'CCI-001511': 'PS-1 c 2',
  'CCI-001512': 'PS-2 a',
  'CCI-001513': 'PS-2 b',
  'CCI-001514': 'PS-2 c',
  'CCI-001515': 'PS-2 c',
  'CCI-001516': 'PS-3 a',
  'CCI-001517': 'PS-3 b',
  'CCI-001518': 'PS-3 b',
  'CCI-001519': 'PS-3 b',
  'CCI-001520': 'PS-3 (1)',
  'CCI-001521': 'PS-3 (2)',
  'CCI-001522': 'PS-4 a',
  'CCI-001523': 'PS-4 c',
  'CCI-001524': 'PS-4 d',
  'CCI-001525': 'PS-4 e',
  'CCI-001526': 'PS-4 e',
  'CCI-001527': 'PS-5 a',
  'CCI-001528': 'PS-5 b',
  'CCI-001529': 'PS-5 b',
  'CCI-001530': 'PS-5 b',
  'CCI-001531': 'PS-6 c 1',
  'CCI-001532': 'PS-6 b',
  'CCI-001533': 'PS-6 b',
  'CCI-001534': 'PS-6 (1) (a)',
  'CCI-001535': 'PS-6 (1) (b)',
  'CCI-001536': 'PS-6 (2) (a)',
  'CCI-001537': 'PS-6 (2) (b)',
  'CCI-001538': 'PS-6 (2) (c)',
  'CCI-001539': 'PS-7 a',
  'CCI-001540': 'PS-7 c',
  'CCI-001541': 'PS-7 e',
  'CCI-001542': 'PS-8 a',
  'CCI-001543': 'PM-1 a',
  'CCI-001544': 'IA-5 c',
  'CCI-001545': 'AC-1 c 1',
  'CCI-001546': 'AC-1 c 2',
  'CCI-001547': 'AC-2 j',
  'CCI-001548': 'AC-4',
  'CCI-001549': 'AC-4',
  'CCI-001550': 'AC-4',
  'CCI-001551': 'AC-4',
  'CCI-001552': 'AC-4 (3)',
  'CCI-001553': 'AC-4 (10)',
  'CCI-001554': 'AC-4 (11)',
  'CCI-001555': 'AC-4 (17) (a)',
  'CCI-001556': 'AC-4 (17) (a)',
  'CCI-001557': 'AC-4 (17) c',
  'CCI-001558': 'AC-6 (1) (a)',
  'CCI-001559': 'AC-16 (2)',
  'CCI-001560': 'AC-16 (4)',
  'CCI-001561': 'AC-17 (3)',
  'CCI-001562': 'AC-17 (5)',
  'CCI-001563': 'AC-18 (2)',
  'CCI-001564': 'AT-1 c 1',
  'CCI-001565': 'AT-1 c 2',
  'CCI-001566': 'AT-3 (2)',
  'CCI-001567': 'AT-3 (2)',
  'CCI-001568': 'AT-3 (2)',
  'CCI-001569': 'AU-1 c 1',
  'CCI-001570': 'AU-1 c 2',
  'CCI-001571': 'AU-2 a',
  'CCI-001572': 'AU-5 a',
  'CCI-001573': 'AU-5 (3)',
  'CCI-001574': 'AU-5 (3)',
  'CCI-001575': 'AU-9 (2)',
  'CCI-001576': 'AU-12 (1)',
  'CCI-001577': 'AU-12 (1)',
  'CCI-001578': 'CA-1 c 2',
  'CCI-001579': 'CA-2 (2)',
  'CCI-001580': 'CA-3 b',
  'CCI-001581': 'CA-7 g',
  'CCI-001582': 'CA-2 (2)',
  'CCI-001583': 'CA-2 (2)',
  'CCI-001584': 'CM-1 c 2',
  'CCI-001585': 'CM-2 b 2',
  'CCI-001586': 'CM-3 g',
  'CCI-001587': 'CM-4 (1)',
  'CCI-001588': 'CM-6 a',
  'CCI-001589': 'CM-6 (3)',
  'CCI-001590': 'CM-7 (2)',
  'CCI-001591': 'CM-7 (2)',
  'CCI-001592': 'CM-7 (2)',
  'CCI-001593': 'CM-7 (2)',
  'CCI-001594': 'CM-7 (2)',
  'CCI-001595': 'CM-7 (2)',
  'CCI-001596': 'CP-1 c 2',
  'CCI-001597': 'CP-1 a 2',
  'CCI-001598': 'CP-1 c 2',
  'CCI-001599': 'CP-2 (5)',
  'CCI-001600': 'CP-2 (5)',
  'CCI-001601': 'CP-2 (6)',
  'CCI-001602': 'CP-2 (6)',
  'CCI-001603': 'CP-6 (1)',
  'CCI-001604': 'CP-6 (3)',
  'CCI-001605': 'CP-7 (1)',
  'CCI-001606': 'CP-7 (2)',
  'CCI-001607': 'CP-8 (2)',
  'CCI-001608': 'CP-8 (3)',
  'CCI-001609': 'CP-9 (6)',
  'CCI-001610': 'IA-5 f',
  'CCI-001611': 'IA-5 (1) (a)',
  'CCI-001612': 'IA-5 (1) (a)',
  'CCI-001613': 'IA-5 (1) (a)',
  'CCI-001614': 'IA-5 (1) (a)',
  'CCI-001615': 'IA-5 (1) (b)',
  'CCI-001616': 'IA-5 (1) (d)',
  'CCI-001617': 'IA-5 (1) (d)',
  'CCI-001618': 'IA-5 (1) (e)',
  'CCI-001619': 'IA-5 (1) (a)',
  'CCI-001620': 'IA-5 (3)',
  'CCI-001621': 'IA-5 (8)',
  'CCI-001622': 'IR-2',
  'CCI-001623': 'IR-2',
  'CCI-001624': 'IR-3',
  'CCI-001625': 'IR-4 c',
  'CCI-001626': 'IR-5 (1)',
  'CCI-001627': 'IR-5 (1)',
  'CCI-001628': 'MA-1 c 2',
  'CCI-001629': 'MA-2 (2)',
  'CCI-001630': 'MA-4 (1)',
  'CCI-001631': 'MA-4 (3) (b)',
  'CCI-001632': 'MA-4 (4) (b) (1)',
  'CCI-001633': 'MP-3 a',
  'CCI-001634': 'PE-2 (3)',
  'CCI-001635': 'PE-2 d',
  'CCI-001636': 'PL-1 c 1',
  'CCI-001637': 'PL-1 c 1',
  'CCI-001638': 'PL-1 c 2',
  'CCI-001639': 'PL-4 a',
  'CCI-001640': 'PM-8',
  'CCI-001641': 'RA-5 a',
  'CCI-001642': 'RA-3 c',
  'CCI-001643': 'RA-5 a',
  'CCI-001644': 'RA-5 (3)',
  'CCI-001645': 'RA-5 (5)',
  'CCI-001646': 'SA-1 c 2',
  'CCI-001647': 'SA-4 (7) (b)',
  'CCI-001648': 'SA-5 (5)',
  'CCI-001649': 'SA-7',
  'CCI-001650': 'SA-10 (b)',
  'CCI-001651': 'SA-10 (b)',
  'CCI-001652': 'SA-10 (b)',
  'CCI-001653': 'SA-10 (b)',
  'CCI-001654': 'SA-10 (b)',
  'CCI-001655': 'SA-10 (b)',
  'CCI-001656': 'SC-3',
  'CCI-001657': 'SC-7 a',
  'CCI-001658': 'SC-7 a',
  'CCI-001659': 'SC-7 (2)',
  'CCI-001660': 'SC-7 (14)',
  'CCI-001661': 'SC-11 b',
  'CCI-001662': 'SC-18 (1)',
  'CCI-001663': 'SC-20 b',
  'CCI-001664': 'SC-23 (3)',
  'CCI-001665': 'SC-24',
  'CCI-001666': 'SC-28 (1)',
  'CCI-001667': 'SI-2 (3)',
  'CCI-001668': 'SI-3 a',
  'CCI-001669': 'SI-3 (6) (a)',
  'CCI-001670': 'SI-4 (7) (b)',
  'CCI-001671': 'SI-4 (11)',
  'CCI-001672': 'SI-4 (14)',
  'CCI-001673': 'SI-4 (14)',
  'CCI-001674': 'SI-6',
  'CCI-001675': 'SI-6 (3)',
  'CCI-001676': 'SI-6',
  'CCI-001677': 'SI-8 a',
  'CCI-001678': 'SI-12',
  'CCI-001679': 'SI-13 b',
  'CCI-001680': 'PM-1 a 2',
  'CCI-001681': 'CA-2 (2)',
  'CCI-001682': 'AC-2 (2)',
  'CCI-001683': 'AC-2 (4)',
  'CCI-001684': 'AC-2 (4)',
  'CCI-001685': 'AC-2 (4)',
  'CCI-001686': 'AC-2 (4)',
  'CCI-001687': 'SC-18 (2)',
  'CCI-001688': 'SC-18 (2)',
  'CCI-001689': 'SI-13 (4) (b)',
  'CCI-001690': 'SA-5 (1)',
  'CCI-001691': 'SA-5 (1)',
  'CCI-001692': 'SA-5 (4)',
  'CCI-001693': 'AC-3 (4)',
  'CCI-001694': 'AC-3 (4)',
  'CCI-001695': 'SC-18 (3)',
  'CCI-001726': 'CM-10 a',
  'CCI-001727': 'CM-10 a',
  'CCI-001728': 'CM-10 a',
  'CCI-001729': 'CM-10 a',
  'CCI-001730': 'CM-10 b',
  'CCI-001731': 'CM-10 b',
  'CCI-001732': 'CM-10 c',
  'CCI-001733': 'CM-10 c',
  'CCI-001734': 'CM-10 (1)',
  'CCI-001735': 'CM-10 (1)',
  'CCI-001736': 'CM-2 (3)',
  'CCI-001737': 'CM-2 (7) (a)',
  'CCI-001738': 'CM-2 (7) (a)',
  'CCI-001739': 'CM-2 (7) (a)',
  'CCI-001740': 'CM-3 b',
  'CCI-001741': 'CM-3 c',
  'CCI-001742': 'CM-3 (1) (b)',
  'CCI-001743': 'CM-3 (5)',
  'CCI-001744': 'CM-3 (5)',
  'CCI-001745': 'CM-3 (6)',
  'CCI-001746': 'CM-3 (6)',
  'CCI-001747': 'CM-5 (3)',
  'CCI-001748': 'CM-5 (3)',
  'CCI-001749': 'CM-5 (3)',
  'CCI-001750': 'CM-5 (3)',
  'CCI-001751': 'CM-5 (4)',
  'CCI-001752': 'CM-5 (4)',
  'CCI-001753': 'CM-5 (5) (a)',
  'CCI-001754': 'CM-5 (5) (a)',
  'CCI-001755': 'CM-6 c',
  'CCI-001756': 'CM-6 c',
  'CCI-001757': 'CM-6 (2)',
  'CCI-001758': 'CM-6 (2)',
  'CCI-001759': 'CM-6 (2)',
  'CCI-001760': 'CM-7 (1) (a)',
  'CCI-001761': 'CM-7 (1) (b)',
  'CCI-001762': 'CM-7 (1) (b)',
  'CCI-001763': 'CM-7 (2)',
  'CCI-001764': 'CM-7 (2)',
  'CCI-001765': 'CM-7 (4) (a)',
  'CCI-001766': 'CM-7 (4) (a)',
  'CCI-001767': 'CM-7 (4) (b)',
  'CCI-001768': 'CM-7 (4) (c)',
  'CCI-001769': 'CM-7 (4) (c)',
  'CCI-001770': 'CM-7 (4) (c)',
  'CCI-001771': 'CM-7 (4) (c)',
  'CCI-001772': 'CM-7 (5) (a)',
  'CCI-001773': 'CM-7 (5) (a)',
  'CCI-001774': 'CM-7 (5) (b)',
  'CCI-001775': 'CM-7 (5) (c)',
  'CCI-001776': 'CM-7 (5) (c)',
  'CCI-001777': 'CM-7 (5) (c)',
  'CCI-001778': 'CM-7 (5) (c)',
  'CCI-001779': 'CM-8 b',
  'CCI-001780': 'CM-8 b',
  'CCI-001781': 'CM-8 b',
  'CCI-001782': 'CM-8 b',
  'CCI-001783': 'CM-8 (3) (b)',
  'CCI-001784': 'CM-8 (3) (b)',
  'CCI-001785': 'CM-8 (7)',
  'CCI-001786': 'CM-8 (8)',
  'CCI-001787': 'CM-8 (9) (a)',
  'CCI-001788': 'CM-8 (9) (a)',
  'CCI-001789': 'CM-8 (9) (b)',
  'CCI-001790': 'CM-9 b',
  'CCI-001791': 'CM-9 b',
  'CCI-001792': 'CM-9 b',
  'CCI-001793': 'CM-9 b',
  'CCI-001794': 'CM-9 b',
  'CCI-001795': 'CM-9 b',
  'CCI-001796': 'CM-9 c',
  'CCI-001797': 'CM-9 c',
  'CCI-001798': 'CM-9 c',
  'CCI-001799': 'CM-9 e',
  'CCI-001800': 'CM-9 d',
  'CCI-001801': 'CM-9 e',
  'CCI-001802': 'CM-10 b',
  'CCI-001803': 'CM-10 b',
  'CCI-001804': 'CM-11 a',
  'CCI-001805': 'CM-11 a',
  'CCI-001806': 'CM-11 b',
  'CCI-001807': 'CM-11 b',
  'CCI-001808': 'CM-11 c',
  'CCI-001809': 'CM-11 c',
  'CCI-001810': 'CM-11 (1)',
  'CCI-001811': 'CM-11 (1)',
  'CCI-001812': 'CM-11 (2)',
  'CCI-001813': 'CM-5 (1) (a)',
  'CCI-001814': 'CM-5 (1)',
  'CCI-001815': 'CM-2 (7) (b)',
  'CCI-001816': 'CM-2 (7) (b)',
  'CCI-001817': 'CM-4 (1)',
  'CCI-001818': 'CM-4 (1)',
  'CCI-001819': 'CM-3 d',
  'CCI-001820': 'CM-1 a 1',
  'CCI-001821': 'CM-1 a 1 (a)',
  'CCI-001822': 'CM-1 a 1 (a)',
  'CCI-001823': 'CM-1 a 2',
  'CCI-001824': 'CM-1 a 2',
  'CCI-001825': 'CM-1 a 2',
  'CCI-001826': 'CM-5 (2)',
  'CCI-001827': 'CM-5 (5) (b)',
  'CCI-001828': 'CM-5 (5) (b)',
  'CCI-001829': 'CM-5 (5) (b)',
  'CCI-001830': 'CM-5 (5) (b)',
  'CCI-001831': 'AU-1 a 1',
  'CCI-001832': 'AU-1 a 1 (a)',
  'CCI-001833': 'AU-1 a 2',
  'CCI-001834': 'AU-1 a 2',
  'CCI-001835': 'AU-1 b 1',
  'CCI-001836': 'AU-1 b 1',
  'CCI-001837': 'AU-1 b 1',
  'CCI-001838': 'AU-1 b 1',
  'CCI-001839': 'AU-1 b 2',
  'CCI-001840': 'AU-1 b 2',
  'CCI-001841': 'AU-1 b 2',
  'CCI-001842': 'AU-1 b 2',
  'CCI-001843': 'AU-2 (3)',
  'CCI-001844': 'AU-3 (2)',
  'CCI-001845': 'AU-3 (2)',
  'CCI-001846': 'AU-3 (2)',
  'CCI-001847': 'AU-3 (2)',
  'CCI-001848': 'AU-4',
  'CCI-001849': 'AU-4',
  'CCI-001850': 'AU-4 (1)',
  'CCI-001851': 'AU-4 (1)',
  'CCI-001852': 'AU-5 (1)',
  'CCI-001853': 'AU-5 (1)',
  'CCI-001854': 'AU-5 (1)',
  'CCI-001855': 'AU-5 (1)',
  'CCI-001856': 'AU-5 (2)',
  'CCI-001857': 'AU-5 (2)',
  'CCI-001858': 'AU-5 (2)',
  'CCI-001859': 'AU-5 (3)',
  'CCI-001860': 'AU-5 (4)',
  'CCI-001861': 'AU-5 (4)',
  'CCI-001862': 'AU-6 a',
  'CCI-001863': 'AU-6 b',
  'CCI-001864': 'AU-6 (1)',
  'CCI-001865': 'AU-6 (1)',
  'CCI-001866': 'AU-6 (5)',
  'CCI-001867': 'AU-6 (5)',
  'CCI-001868': 'AU-6 (7)',
  'CCI-001869': 'AU-6 (7)',
  'CCI-001870': 'AU-6 (8)',
  'CCI-001871': 'AU-6 (9)',
  'CCI-001872': 'AU-6 (10)',
  'CCI-001873': 'AU-6 (10)',
  'CCI-001874': 'AU-6 (10)',
  'CCI-001875': 'AU-7 a',
  'CCI-001876': 'AU-7 a',
  'CCI-001877': 'AU-7 a',
  'CCI-001878': 'AU-7 a',
  'CCI-001879': 'AU-7 a',
  'CCI-001880': 'AU-7 a',
  'CCI-001881': 'AU-7 b',
  'CCI-001882': 'AU-7 b',
  'CCI-001883': 'AU-7 (1)',
  'CCI-001884': 'AU-7 (2)',
  'CCI-001885': 'AU-7 (2)',
  'CCI-001886': 'AU-7 (2)',
  'CCI-001887': 'AU-7 (2)',
  'CCI-001888': 'AU-8 b',
  'CCI-001889': 'AU-8 b',
  'CCI-001890': 'AU-8 b',
  'CCI-001891': 'AU-8 (1) (a)',
  'CCI-001892': 'AU-8 (1) (b)',
  'CCI-001893': 'AU-8 (2)',
  'CCI-001894': 'AU-9 (4)',
  'CCI-001895': 'AU-9 (5)',
  'CCI-001896': 'AU-9 (5)',
  'CCI-001897': 'AU-9 (6)',
  'CCI-001898': 'AU-9 (6)',
  'CCI-001899': 'AU-10',
  'CCI-001900': 'AU-10 (1) (a)',
  'CCI-001901': 'AU-10 (1) (a)',
  'CCI-001902': 'AU-10 (1) (b)',
  'CCI-001903': 'AU-10 (2) (a)',
  'CCI-001904': 'AU-10 (2) (a)',
  'CCI-001905': 'AU-10 (2) (b)',
  'CCI-001906': 'AU-10 (2) (b)',
  'CCI-001907': 'AU-10 (4) (a)',
  'CCI-001908': 'AU-10 (4) (b)',
  'CCI-001909': 'AU-10 (4) (b)',
  'CCI-001910': 'AU-12 b',
  'CCI-001911': 'AU-12 (3)',
  'CCI-001912': 'AU-12 (3)',
  'CCI-001913': 'AU-12 (3)',
  'CCI-001914': 'AU-12 (3)',
  'CCI-001915': 'AU-13 a',
  'CCI-001916': 'AU-13 (1)',
  'CCI-001917': 'AU-13 (2)',
  'CCI-001918': 'AU-13 (2)',
  'CCI-001919': 'AU-14 a',
  'CCI-001920': 'AU-14 (3)',
  'CCI-001921': 'AU-15',
  'CCI-001922': 'AU-15',
  'CCI-001923': 'AU-16',
  'CCI-001924': 'AU-16',
  'CCI-001925': 'AU-16',
  'CCI-001926': 'AU-16 (1)',
  'CCI-001927': 'AU-16 (2)',
  'CCI-001928': 'AU-16 (2)',
  'CCI-001929': 'AU-16 (2)',
  'CCI-001930': 'AU-1 a 1',
  'CCI-001931': 'AU-1 a 2',
  'CCI-001932': 'IA-1 a 1',
  'CCI-001933': 'IA-1 a 1',
  'CCI-001934': 'IA-1 a 2',
  'CCI-001935': 'IA-2 (6)',
  'CCI-001936': 'IA-2 (6)',
  'CCI-001937': 'IA-2 (6)',
  'CCI-001938': 'IA-2 (7)',
  'CCI-001939': 'IA-2 (7)',
  'CCI-001940': 'IA-2 (7)',
  'CCI-001941': 'IA-2 (8)',
  'CCI-001942': 'IA-2 (9)',
  'CCI-001943': 'IA-2 (10)',
  'CCI-001944': 'IA-2 (10)',
  'CCI-001945': 'IA-2 (10)',
  'CCI-001946': 'IA-2 (10)',
  'CCI-001947': 'IA-2 (11)',
  'CCI-001948': 'IA-2 (11)',
  'CCI-001949': 'IA-2 (11)',
  'CCI-001950': 'IA-2 (11)',
  'CCI-001951': 'IA-2 (11)',
  'CCI-001952': 'IA-2 (11)',
  'CCI-001953': 'IA-2 (12)',
  'CCI-001954': 'IA-2 (12)',
  'CCI-001955': 'IA-2 (13)',
  'CCI-001956': 'IA-2 (13)',
  'CCI-001957': 'IA-2 (13)',
  'CCI-001958': 'IA-3',
  'CCI-001959': 'IA-3 (1)',
  'CCI-001960': 'IA-3 (3) (a)',
  'CCI-001961': 'IA-3 (3) (a)',
  'CCI-001962': 'IA-3 (3) (a)',
  'CCI-001963': 'IA-3 (3) (a)',
  'CCI-001964': 'IA-3 (4)',
  'CCI-001965': 'IA-3 (4)',
  'CCI-001966': 'IA-3 (4)',
  'CCI-001967': 'IA-3 (1)',
  'CCI-001968': 'IA-3 (4)',
  'CCI-001969': 'IA-3 (4)',
  'CCI-001970': 'IA-4 a',
  'CCI-001971': 'IA-4 a',
  'CCI-001972': 'IA-4 b',
  'CCI-001973': 'IA-4 c',
  'CCI-001974': 'IA-4 d',
  'CCI-001975': 'IA-4 d',
  'CCI-001976': 'IA-4 (5)',
  'CCI-001977': 'IA-4 (6)',
  'CCI-001978': 'IA-4 (6)',
  'CCI-001979': 'IA-4 (7)',
  'CCI-001980': 'IA-5 a',
  'CCI-001981': 'IA-5 d',
  'CCI-001982': 'IA-5 d',
  'CCI-001983': 'IA-5 d',
  'CCI-001984': 'IA-5 d',
  'CCI-001985': 'IA-5 d',
  'CCI-001986': 'IA-5 d',
  'CCI-001987': 'IA-5 d',
  'CCI-001988': 'IA-5 d',
  'CCI-001989': 'IA-5 e',
  'CCI-001990': 'IA-5 i',
  'CCI-001991': 'IA-5 (2) (d)',
  'CCI-001992': 'IA-5 (3)',
  'CCI-001993': 'IA-5 (3)',
  'CCI-001994': 'IA-5 (3)',
  'CCI-001995': 'IA-5 (3)',
  'CCI-001996': 'IA-5 (4)',
  'CCI-001997': 'IA-5 (4)',
  'CCI-001998': 'IA-5 (5)',
  'CCI-001999': 'IA-5 (9)',
  'CCI-002000': 'IA-5 (9)',
  'CCI-002001': 'IA-5 (10)',
  'CCI-002002': 'IA-5 (11)',
  'CCI-002003': 'IA-5 (11)',
  'CCI-002004': 'IA-5 (12)',
  'CCI-002005': 'IA-5 (12)',
  'CCI-002006': 'IA-5 (13)',
  'CCI-002007': 'IA-5 (13)',
  'CCI-002008': 'IA-5 (14)',
  'CCI-002009': 'IA-8 (1)',
  'CCI-002010': 'IA-8 (1)',
  'CCI-002011': 'IA-8 (2)',
  'CCI-002012': 'IA-8 (3)',
  'CCI-002013': 'IA-8 (3)',
  'CCI-002014': 'IA-8 (4)',
  'CCI-002015': 'IA-8 (5)',
  'CCI-002016': 'IA-8 (5)',
  'CCI-002017': 'IA-9',
  'CCI-002018': 'IA-9',
  'CCI-002019': 'IA-9',
  'CCI-002020': 'IA-9',
  'CCI-002021': 'IA-9',
  'CCI-002022': 'IA-9',
  'CCI-002023': 'IA-9 (1)',
  'CCI-002024': 'IA-9 (1)',
  'CCI-002025': 'IA-9 (1)',
  'CCI-002026': 'IA-9 (1)',
  'CCI-002027': 'IA-9 (1)',
  'CCI-002028': 'IA-9 (1)',
  'CCI-002029': 'IA-9 (2)',
  'CCI-002030': 'IA-9 (2)',
  'CCI-002031': 'IA-9 (2)',
  'CCI-002032': 'IA-9 (2)',
  'CCI-002033': 'IA-10',
  'CCI-002034': 'IA-10',
  'CCI-002035': 'IA-10',
  'CCI-002036': 'IA-11',
  'CCI-002037': 'IA-11',
  'CCI-002038': 'IA-11',
  'CCI-002039': 'IA-11',
  'CCI-002040': 'IA-4 (2)',
  'CCI-002041': 'IA-5 (1) (f)',
  'CCI-002042': 'IA-5 g',
  'CCI-002043': 'IA-5 (15)',
  'CCI-002044': 'AU-11 (1)',
  'CCI-002045': 'AU-11 (1)',
  'CCI-002046': 'AU-8 (1) (b)',
  'CCI-002047': 'AU-12 (3)',
  'CCI-002048': 'AT-1 a 1 (a)',
  'CCI-002049': 'AT-1 a 2',
  'CCI-002050': 'AT-3 (1)',
  'CCI-002051': 'AT-3 (2)',
  'CCI-002052': 'AT-3 (3)',
  'CCI-002053': 'AT-3 (4)',
  'CCI-002054': 'AT-3 (4)',
  'CCI-002055': 'AT-2 (2)',
  'CCI-002056': 'CM-3 d',
  'CCI-002057': 'CM-3 (1) (f)',
  'CCI-002058': 'CM-3 (1) (f)',
  'CCI-002059': 'CM-6 (1)',
  'CCI-002060': 'CA-1 a 1',
  'CCI-002061': 'CA-1 a 1 (a)',
  'CCI-002062': 'CA-1 a 2',
  'CCI-002063': 'CA-2 (1)',
  'CCI-002064': 'CA-2 (2)',
  'CCI-002065': 'CA-2 (2)',
  'CCI-002066': 'CA-2 (3)',
  'CCI-002067': 'CA-2 (3)',
  'CCI-002068': 'CA-2 (3)',
  'CCI-002069': 'CA-2 (3)',
  'CCI-002070': 'CA-2 b 3',
  'CCI-002071': 'CA-2 f',
  'CCI-002072': 'CA-3 (1)',
  'CCI-002073': 'CA-3 (1)',
  'CCI-002074': 'CA-3 (2)',
  'CCI-002075': 'CA-3 (3)',
  'CCI-002076': 'CA-3 (3)',
  'CCI-002077': 'CA-3 (3)',
  'CCI-002078': 'CA-3 (4)',
  'CCI-002079': 'CA-3 (4)',
  'CCI-002080': 'CA-3 (5)',
  'CCI-002081': 'CA-3 (5)',
  'CCI-002082': 'CA-3 (5)',
  'CCI-002083': 'CA-3 c',
  'CCI-002084': 'CA-3 c',
  'CCI-002085': 'CA-7 (1)',
  'CCI-002086': 'CA-7 (3)',
  'CCI-002087': 'CA-7 a',
  'CCI-002088': 'CA-7 b',
  'CCI-002089': 'CA-7 b',
  'CCI-002090': 'CA-7 d',
  'CCI-002091': 'CA-7 e',
  'CCI-002092': 'CA-7 f',
  'CCI-002093': 'CA-8',
  'CCI-002094': 'CA-8',
  'CCI-002095': 'CA-8',
  'CCI-002096': 'CA-8 (1)',
  'CCI-002097': 'CA-8 (2)',
  'CCI-002098': 'CA-8 (2)',
  'CCI-002099': 'CA-8 (2)',
  'CCI-002100': 'CA-9 (1)',
  'CCI-002101': 'CA-9 (a)',
  'CCI-002102': 'CA-9 (a)',
  'CCI-002103': 'CA-9 (b)',
  'CCI-002104': 'CA-9 (b)',
  'CCI-002105': 'CA-9 (b)',
  'CCI-002106': 'AC-1 a 1',
  'CCI-002107': 'AC-1 a 1 (a)',
  'CCI-002108': 'AC-1 a 2',
  'CCI-002109': 'AC-1 a 2',
  'CCI-002110': 'AC-2 a',
  'CCI-002111': 'AC-2 a',
  'CCI-002112': 'AC-2 b',
  'CCI-002113': 'AC-2 c',
  'CCI-002114': 'AC-2 d',
  'CCI-002115': 'AC-2 d 1',
  'CCI-002116': 'AC-2 d 2',
  'CCI-002117': 'AC-2 d 2',
  'CCI-002118': 'AC-2 d 3',
  'CCI-002119': 'AC-2 d 3',
  'CCI-002120': 'AC-2 e',
  'CCI-002121': 'AC-2 f',
  'CCI-002122': 'AC-2 g',
  'CCI-002123': 'AC-2 h 1',
  'CCI-002124': 'AC-2 h 2',
  'CCI-002125': 'AC-2 h 3',
  'CCI-002126': 'AC-2 i 1',
  'CCI-002127': 'AC-2 i 2',
  'CCI-002128': 'AC-2 i 3',
  'CCI-002129': 'AC-2 k',
  'CCI-002130': 'AC-2 (4)',
  'CCI-002131': 'AC-2 (4)',
  'CCI-002132': 'AC-2 (4)',
  'CCI-002133': 'AC-2 (5)',
  'CCI-002134': 'AC-2 (6)',
  'CCI-002135': 'AC-2 (6)',
  'CCI-002136': 'AC-2 (7) (c)',
  'CCI-002137': 'AC-2 (7) (d)',
  'CCI-002138': 'AC-2 (8)',
  'CCI-002139': 'AC-2 (8)',
  'CCI-002140': 'AC-2 (9)',
  'CCI-002141': 'AC-2 (9)',
  'CCI-002142': 'AC-2 (10)',
  'CCI-002143': 'AC-2 (11)',
  'CCI-002144': 'AC-2 (11)',
  'CCI-002145': 'AC-2 (11)',
  'CCI-002146': 'AC-2 (12) (a)',
  'CCI-002147': 'AC-2 (12) (a)',
  'CCI-002148': 'AC-2 (12) (b)',
  'CCI-002149': 'AC-2 (12) (b)',
  'CCI-002150': 'AC-2 (13)',
  'CCI-002151': 'AC-2 (13)',
  'CCI-002152': 'AC-3 (2)',
  'CCI-002153': 'AC-3 (3)',
  'CCI-002154': 'AC-3 (3) (a)',
  'CCI-002155': 'AC-3 (3) (b) (1)',
  'CCI-002156': 'AC-3 (3) (b) (2)',
  'CCI-002157': 'AC-3 (3) (b) (3)',
  'CCI-002158': 'AC-3 (3) (b) (4)',
  'CCI-002159': 'AC-3 (3) (b) (4)',
  'CCI-002160': 'AC-3 (3) (b) (5)',
  'CCI-002161': 'AC-3 (3) (c)',
  'CCI-002162': 'AC-3 (3) (c)',
  'CCI-002163': 'AC-3 (4)',
  'CCI-002164': 'AC-3 (4)',
  'CCI-002165': 'AC-3 (4)',
  'CCI-002166': 'AC-3 (7)',
  'CCI-002167': 'AC-3 (7)',
  'CCI-002168': 'AC-3 (7)',
  'CCI-002169': 'AC-3 (7)',
  'CCI-002170': 'AC-3 (7)',
  'CCI-002171': 'AC-3 (7)',
  'CCI-002172': 'AC-3 (7)',
  'CCI-002173': 'AC-3 (7)',
  'CCI-002174': 'AC-3 (7)',
  'CCI-002175': 'AC-3 (7)',
  'CCI-002176': 'AC-3 (7)',
  'CCI-002177': 'AC-3 (8)',
  'CCI-002178': 'AC-3 (8)',
  'CCI-002179': 'AC-3 (8)',
  'CCI-002180': 'AC-3 (9) (a)',
  'CCI-002181': 'AC-3 (9) (a)',
  'CCI-002182': 'AC-3 (9) (a)',
  'CCI-002183': 'AC-3 (9) (b)',
  'CCI-002184': 'AC-3 (9) (b)',
  'CCI-002185': 'AC-3 (10)',
  'CCI-002186': 'AC-3 (10)',
  'CCI-002187': 'AC-4 (1)',
  'CCI-002188': 'AC-4 (1)',
  'CCI-002189': 'AC-4 (1)',
  'CCI-002190': 'AC-4 (1)',
  'CCI-002191': 'AC-4 (2)',
  'CCI-002192': 'AC-4 (3)',
  'CCI-002193': 'AC-4 (4)',
  'CCI-002194': 'AC-4 (6)',
  'CCI-002195': 'AC-4 (8) (a)',
  'CCI-002196': 'AC-4 (9)',
  'CCI-002197': 'AC-4 (9)',
  'CCI-002198': 'AC-4 (9)',
  'CCI-002199': 'AC-4 (10)',
  'CCI-002200': 'AC-4 (12)',
  'CCI-002201': 'AC-4 (12)',
  'CCI-002202': 'AC-4 (13)',
  'CCI-002203': 'AC-4 (15)',
  'CCI-002204': 'AC-4 (15)',
  'CCI-002205': 'AC-4 (17)',
  'CCI-002206': 'AC-4 (17)',
  'CCI-002207': 'AC-4 (17)',
  'CCI-002208': 'AC-4 (17)',
  'CCI-002209': 'AC-4 (18)',
  'CCI-002210': 'AC-4 (18)',
  'CCI-002211': 'AC-4 (19)',
  'CCI-002212': 'AC-4 (20)',
  'CCI-002213': 'AC-4 (20)',
  'CCI-002214': 'AC-4 (20)',
  'CCI-002215': 'AC-4 (21)',
  'CCI-002216': 'AC-4 (21)',
  'CCI-002217': 'AC-4 (21)',
  'CCI-002218': 'AC-4 (22)',
  'CCI-002219': 'AC-5 a',
  'CCI-002220': 'AC-5 b',
  'CCI-002221': 'AC-6 (1) (b)',
  'CCI-002222': 'AC-6 (1) (a)',
  'CCI-002223': 'AC-6 (1) (b)',
  'CCI-002224': 'AC-6 (3)',
  'CCI-002225': 'AC-6 (4)',
  'CCI-002226': 'AC-6 (5)',
  'CCI-002227': 'AC-6 (5)',
  'CCI-002228': 'AC-6 (7) (a)',
  'CCI-002229': 'AC-6 (7) (a)',
  'CCI-002230': 'AC-6 (7) (a)',
  'CCI-002231': 'AC-6 (7) (b)',
  'CCI-002232': 'AC-6 (8)',
  'CCI-002233': 'AC-6 (8)',
  'CCI-002234': 'AC-6 (9)',
  'CCI-002235': 'AC-6 (10)',
  'CCI-002236': 'AC-7 b',
  'CCI-002237': 'AC-7 b',
  'CCI-002238': 'AC-7 b',
  'CCI-002239': 'AC-7 (2)',
  'CCI-002240': 'AC-7 (2)',
  'CCI-002241': 'AC-7 (2)',
  'CCI-002242': 'AC-7 (2)',
  'CCI-002243': 'AC-8 a 1',
  'CCI-002244': 'AC-8 a 2',
  'CCI-002245': 'AC-8 a 3',
  'CCI-002246': 'AC-8 a 4',
  'CCI-002247': 'AC-8 a',
  'CCI-002248': 'AC-8 c 1',
  'CCI-002249': 'AC-9 (4)',
  'CCI-002250': 'AC-9 (4)',
  'CCI-002251': 'AC-9 (4)',
  'CCI-002252': 'AC-10',
  'CCI-002253': 'AC-10',
  'CCI-002254': 'AC-12',
  'CCI-002255': 'AC-14 a',
  'CCI-002256': 'AC-16 a',
  'CCI-002257': 'AC-16 a',
  'CCI-002258': 'AC-16 a',
  'CCI-002259': 'AC-16 a',
  'CCI-002260': 'AC-16 a',
  'CCI-002261': 'AC-16 a',
  'CCI-002262': 'AC-16 a',
  'CCI-002263': 'AC-16 a',
  'CCI-002264': 'AC-16 a',
  'CCI-002265': 'AC-16 b',
  'CCI-002266': 'AC-16 b  ',
  'CCI-002267': 'AC-16 c',
  'CCI-002268': 'AC-16 c',
  'CCI-002269': 'AC-16 c',
  'CCI-002270': 'AC-16 d',
  'CCI-002271': 'AC-16 d',
  'CCI-002272': 'AC-16 (1)',
  'CCI-002273': 'AC-16 (1)',
  'CCI-002274': 'AC-16 (1)',
  'CCI-002275': 'AC-16 (1)',
  'CCI-002276': 'AC-16 (2)',
  'CCI-002277': 'AC-16 (2)',
  'CCI-002278': 'AC-16 (3)',
  'CCI-002279': 'AC-16 (3)',
  'CCI-002280': 'AC-16 (3)',
  'CCI-002281': 'AC-16 (3)',
  'CCI-002282': 'AC-16 (3)',
  'CCI-002283': 'AC-16 (3)',
  'CCI-002284': 'AC-16 (3)',
  'CCI-002285': 'AC-16 (4)',
  'CCI-002286': 'AC-16 (4)',
  'CCI-002287': 'AC-16 (4)',
  'CCI-002288': 'AC-16 (4)',
  'CCI-002289': 'AC-16 (4)',
  'CCI-002290': 'AC-16 (4)',
  'CCI-002291': 'AC-16 (6)',
  'CCI-002292': 'AC-16 (6)',
  'CCI-002293': 'AC-16 (6)',
  'CCI-002294': 'AC-16 (6)',
  'CCI-002295': 'AC-16 (6)',
  'CCI-002296': 'AC-16 (6)',
  'CCI-002297': 'AC-16 (6)',
  'CCI-002298': 'AC-16 (6)',
  'CCI-002299': 'AC-16 (7)',
  'CCI-002300': 'AC-16 (8)',
  'CCI-002301': 'AC-16 (8)',
  'CCI-002302': 'AC-16 (8)',
  'CCI-002303': 'AC-16 (9)',
  'CCI-002304': 'AC-16 (9)',
  'CCI-002305': 'AC-16 (10)',
  'CCI-002306': 'AC-16 (10)',
  'CCI-002307': 'AC-16 (10)',
  'CCI-002308': 'AC-16 (10)',
  'CCI-002309': 'AC-16 (10)',
  'CCI-002310': 'AC-17 a',
  'CCI-002311': 'AC-17 a',
  'CCI-002312': 'AC-17 a',
  'CCI-002313': 'AC-17 (1)',
  'CCI-002314': 'AC-17 (1)',
  'CCI-002315': 'AC-17 (3)',
  'CCI-002316': 'AC-17 (4) (a)',
  'CCI-002317': 'AC-17 (4) (a)',
  'CCI-002318': 'AC-17 (4) (a)',
  'CCI-002319': 'AC-17 (4) (b)',
  'CCI-002320': 'AC-17 (4) (b)',
  'CCI-002321': 'AC-17 (9)',
  'CCI-002322': 'AC-17 (9)',
  'CCI-002323': 'AC-18 a',
  'CCI-002324': 'AC-18 (4)',
  'CCI-002325': 'AC-19 a',
  'CCI-002326': 'AC-19 a',
  'CCI-002327': 'AC-19 (4) (c)',
  'CCI-002328': 'AC-19 (4) (c)',
  'CCI-002329': 'AC-19 (5)',
  'CCI-002330': 'AC-19 (5)',
  'CCI-002331': 'AC-19 (5)',
  'CCI-002332': 'AC-20 a 2',
  'CCI-002333': 'AC-20 (1) (a)',
  'CCI-002334': 'AC-20 (1) (a)',
  'CCI-002335': 'AC-20 (1) (a)',
  'CCI-002336': 'AC-20 (1) (a)',
  'CCI-002337': 'AC-20 (1) (b)',
  'CCI-002338': 'AC-20 (3)',
  'CCI-002339': 'AC-20 (4)',
  'CCI-002340': 'AC-20 (4)',
  'CCI-002341': 'AC-21 (2)',
  'CCI-002342': 'AC-21 (2)',
  'CCI-002343': 'AC-23',
  'CCI-002344': 'AC-23',
  'CCI-002345': 'AC-23',
  'CCI-002346': 'AC-23',
  'CCI-002347': 'AC-23',
  'CCI-002348': 'AC-24',
  'CCI-002349': 'AC-24',
  'CCI-002350': 'AC-24 (1)',
  'CCI-002351': 'AC-24 (1)',
  'CCI-002352': 'AC-24 (1)',
  'CCI-002353': 'AC-24 (1)',
  'CCI-002354': 'AC-24 (2)',
  'CCI-002355': 'AC-24 (2)',
  'CCI-002356': 'AC-25',
  'CCI-002357': 'AC-25',
  'CCI-002358': 'AC-25',
  'CCI-002359': 'AC-25',
  'CCI-002360': 'AC-12',
  'CCI-002361': 'AC-12',
  'CCI-002362': 'AC-12 (1)',
  'CCI-002363': 'AC-12 (1)',
  'CCI-002364': 'AC-12 (2)',
  'CCI-002365': 'IA-5 i',
  'CCI-002366': 'IA-5 i',
  'CCI-002367': 'IA-5 (7)',
  'CCI-002368': 'RA-1 a 1 (a)',
  'CCI-002369': 'RA-1 a 2',
  'CCI-002370': 'RA-3 e',
  'CCI-002371': 'RA-3 e',
  'CCI-002372': 'RA-5 (10)',
  'CCI-002373': 'RA-5 (3)',
  'CCI-002374': 'RA-5 (4)',
  'CCI-002375': 'RA-5 (4)',
  'CCI-002376': 'RA-5 e',
  'CCI-002377': 'SC-1 a 1',
  'CCI-002378': 'SC-1 a 1',
  'CCI-002379': 'SC-1 a 2',
  'CCI-002380': 'SC-1 a 2',
  'CCI-002381': 'SC-3 (3)',
  'CCI-002382': 'SC-3 (4)',
  'CCI-002383': 'SC-4 (2)',
  'CCI-002384': 'SC-4 (2)',
  'CCI-002385': 'SC-5 a',
  'CCI-002386': 'SC-5',
  'CCI-002387': 'SC-5 (1)',
  'CCI-002388': 'SC-5 (3) (a)',
  'CCI-002389': 'SC-5 (3) (a)',
  'CCI-002390': 'SC-5 (3) (b)',
  'CCI-002391': 'SC-5 (3) (b)',
  'CCI-002392': 'SC-6',
  'CCI-002393': 'SC-6',
  'CCI-002394': 'SC-6',
  'CCI-002395': 'SC-7 b',
  'CCI-002396': 'SC-7 (4) (c)',
  'CCI-002397': 'SC-7 (7)',
  'CCI-002398': 'SC-7 (9) (a)',
  'CCI-002399': 'SC-7 (9) (a)',
  'CCI-002400': 'SC-7 (9) (b)',
  'CCI-002401': 'SC-7 (11)',
  'CCI-002402': 'SC-7 (11)',
  'CCI-002403': 'SC-7 (11)',
  'CCI-002404': 'SC-7 (12)',
  'CCI-002405': 'SC-7 (12)',
  'CCI-002406': 'SC-7 (12)',
  'CCI-002407': 'SC-7 (14)',
  'CCI-002408': 'SC-7 (19)',
  'CCI-002409': 'SC-7 (19)',
  'CCI-002410': 'SC-7 (20)',
  'CCI-002411': 'SC-7 (20)',
  'CCI-002412': 'SC-7 (21)',
  'CCI-002413': 'SC-7 (21)',
  'CCI-002414': 'SC-7 (21)',
  'CCI-002415': 'SC-7 (21)',
  'CCI-002416': 'SC-7 (22)',
  'CCI-002417': 'SC-7 (23)',
  'CCI-002418': 'SC-8',
  'CCI-002419': 'SC-8 (1)',
  'CCI-002420': 'SC-8 (2)',
  'CCI-002421': 'SC-8 (1)',
  'CCI-002422': 'SC-8 (2)',
  'CCI-002423': 'SC-8 (3)',
  'CCI-002424': 'SC-8 (4)',
  'CCI-002425': 'SC-8 (4)',
  'CCI-002426': 'SC-11 (1) (a)',
  'CCI-002427': 'SC-8 (3)',
  'CCI-002428': 'SC-12',
  'CCI-002429': 'SC-12',
  'CCI-002430': 'SC-12',
  'CCI-002431': 'SC-12',
  'CCI-002432': 'SC-12',
  'CCI-002433': 'SC-12',
  'CCI-002434': 'SC-12',
  'CCI-002435': 'SC-12',
  'CCI-002436': 'SC-12',
  'CCI-002437': 'SC-12',
  'CCI-002438': 'SC-12',
  'CCI-002439': 'SC-12',
  'CCI-002440': 'SC-12',
  'CCI-002441': 'SC-12',
  'CCI-002442': 'SC-12',
  'CCI-002443': 'SC-12 (2)',
  'CCI-002444': 'SC-12 (2)',
  'CCI-002445': 'SC-12 (2)',
  'CCI-002446': 'SC-12 (3)',
  'CCI-002447': 'SC-12 (3)',
  'CCI-002448': 'SC-12 (3)',
  'CCI-002449': 'SC-13',
  'CCI-002450': 'SC-13 b',
  'CCI-002451': 'SC-15 (3)',
  'CCI-002452': 'SC-15 (4)',
  'CCI-002453': 'SC-15 (4)',
  'CCI-002454': 'SC-16',
  'CCI-002455': 'SC-16',
  'CCI-002456': 'SC-17 a',
  'CCI-002457': 'SC-18 (1)',
  'CCI-002458': 'SC-18 (1)',
  'CCI-002459': 'SC-18 (3)',
  'CCI-002460': 'SC-18 (4)',
  'CCI-002461': 'SC-18 (5)',
  'CCI-002462': 'SC-20 a',
  'CCI-002463': 'SC-20 (2)',
  'CCI-002464': 'SC-20 (2)',
  'CCI-002465': 'SC-21',
  'CCI-002466': 'SC-21',
  'CCI-002467': 'SC-21',
  'CCI-002468': 'SC-21',
  'CCI-002469': 'SC-23 (5)',
  'CCI-002470': 'SC-23 (5)',
  'CCI-002471': 'SC-25',
  'CCI-002472': 'SC-28',
  'CCI-002473': 'SC-28 (1)',
  'CCI-002474': 'SC-28 (1)',
  'CCI-002475': 'SC-28 (1)',
  'CCI-002476': 'SC-28 (1)',
  'CCI-002477': 'SC-28 (2)',
  'CCI-002478': 'SC-28 (2)',
  'CCI-002479': 'SC-28 (2)',
  'CCI-002480': 'SC-29',
  'CCI-002481': 'SC-29 (1)',
  'CCI-002482': 'SC-30',
  'CCI-002483': 'SC-30',
  'CCI-002484': 'SC-30',
  'CCI-002485': 'SC-30',
  'CCI-002486': 'SC-30 (2)',
  'CCI-002487': 'SC-30 (2)',
  'CCI-002488': 'SC-30 (2)',
  'CCI-002489': 'SC-30 (3)',
  'CCI-002490': 'SC-30 (3)',
  'CCI-002491': 'SC-30 (3)',
  'CCI-002492': 'SC-30 (3)',
  'CCI-002493': 'SC-30 (4)',
  'CCI-002494': 'SC-30 (4)',
  'CCI-002495': 'SC-30 (5)',
  'CCI-002496': 'SC-30 (5)',
  'CCI-002497': 'SC-30 (5)',
  'CCI-002498': 'SC-31 a',
  'CCI-002499': 'SC-31 b',
  'CCI-002500': 'SC-31 (2)',
  'CCI-002501': 'SC-31 (2)',
  'CCI-002502': 'SC-31 (3)',
  'CCI-002503': 'SC-31 (3)',
  'CCI-002504': 'SC-32',
  'CCI-002505': 'SC-32',
  'CCI-002506': 'SC-32',
  'CCI-002507': 'SC-34 (2)',
  'CCI-002508': 'SC-51 a',
  'CCI-002509': 'SC-51 a',
  'CCI-002510': 'SC-51 b',
  'CCI-002511': 'SC-51 b',
  'CCI-002512': 'SC-51 b',
  'CCI-002513': 'SC-36',
  'CCI-002514': 'SC-36',
  'CCI-002515': 'SC-36',
  'CCI-002516': 'SC-36',
  'CCI-002517': 'SC-36 (1) (a)',
  'CCI-002518': 'SC-36 (1) (a)',
  'CCI-002519': 'SC-36 (1) (a)',
  'CCI-002520': 'SC-36 (1) (a)',
  'CCI-002521': 'SC-37',
  'CCI-002522': 'SC-37',
  'CCI-002523': 'SC-37, SC-37 (1)',
  'CCI-002524': 'SC-37',
  'CCI-002525': 'SC-37 (1)',
  'CCI-002526': 'SC-37 (1)',
  'CCI-002527': 'SC-37 (1)',
  'CCI-002528': 'SC-38',
  'CCI-002529': 'SC-38',
  'CCI-002530': 'SC-39',
  'CCI-002531': 'SC-39 (1)',
  'CCI-002532': 'SC-39 (2)',
  'CCI-002533': 'SC-39 (2)',
  'CCI-002534': 'SC-40',
  'CCI-002535': 'SC-40',
  'CCI-002536': 'SC-40',
  'CCI-002537': 'SC-40 (1)',
  'CCI-002538': 'SC-40 (1)',
  'CCI-002539': 'SC-40 (2)',
  'CCI-002540': 'SC-40 (2)',
  'CCI-002541': 'SC-40 (3)',
  'CCI-002542': 'SC-40 (4)',
  'CCI-002543': 'SC-40 (4)',
  'CCI-002544': 'SC-41',
  'CCI-002545': 'SC-41',
  'CCI-002546': 'SC-41',
  'CCI-002547': 'SC-42 a',
  'CCI-002548': 'SC-42 a',
  'CCI-002549': 'SC-42 b',
  'CCI-002550': 'SC-42 b',
  'CCI-002551': 'SC-42 (1)',
  'CCI-002552': 'SC-42 (1)',
  'CCI-002553': 'SC-42 (2)',
  'CCI-002554': 'SC-42 (2)',
  'CCI-002555': 'SC-42 (2)',
  'CCI-002556': 'SC-42 a',
  'CCI-002557': 'SC-42 a',
  'CCI-002558': 'SC-42 (3)',
  'CCI-002559': 'SC-43 a',
  'CCI-002560': 'SC-43 a',
  'CCI-002561': 'SC-43 b',
  'CCI-002562': 'SC-43 b',
  'CCI-002563': 'SC-43 b',
  'CCI-002564': 'SC-44',
  'CCI-002565': 'SC-44',
  'CCI-002566': 'MP-1 a 1',
  'CCI-002567': 'MP-6 (1)',
  'CCI-002568': 'MP-6 (1)',
  'CCI-002569': 'MP-6 (1)',
  'CCI-002570': 'MP-6 (1)',
  'CCI-002571': 'MP-6 (1)',
  'CCI-002572': 'MP-6 (1)',
  'CCI-002573': 'MP-6 (7)',
  'CCI-002574': 'MP-6 (7)',
  'CCI-002575': 'MP-6 (8)',
  'CCI-002576': 'MP-6 (8)',
  'CCI-002577': 'MP-6 (8)',
  'CCI-002578': 'MP-6 a',
  'CCI-002579': 'MP-6 a',
  'CCI-002580': 'MP-6 b',
  'CCI-002581': 'MP-7 (a)',
  'CCI-002582': 'MP-7 (a)',
  'CCI-002583': 'MP-7 (a)',
  'CCI-002584': 'MP-7 (a)',
  'CCI-002585': 'MP-7 (b)',
  'CCI-002586': 'MP-7 (2)',
  'CCI-002587': 'MP-8 (1)',
  'CCI-002588': 'MP-8 (2)',
  'CCI-002589': 'MP-8 (2)',
  'CCI-002590': 'MP-8 (2)',
  'CCI-002591': 'MP-8 (2)',
  'CCI-002592': 'MP-8 (3)',
  'CCI-002593': 'MP-8 (3)',
  'CCI-002594': 'MP-8 (4)',
  'CCI-002595': 'MP-8 a',
  'CCI-002596': 'MP-8 a',
  'CCI-002597': 'MP-8 a',
  'CCI-002598': 'MP-8 b',
  'CCI-002599': 'MP-8 c',
  'CCI-002600': 'MP-8 d',
  'CCI-002601': 'SI-1 a',
  'CCI-002602': 'SI-2 b',
  'CCI-002603': 'SI-2 b',
  'CCI-002604': 'SI-2 c',
  'CCI-002605': 'SI-2 c',
  'CCI-002606': 'SI-2 c',
  'CCI-002607': 'SI-2 c',
  'CCI-002608': 'SI-2 (3) (b)',
  'CCI-002609': 'SI-2 (5)',
  'CCI-002610': 'SI-2 (5)',
  'CCI-002611': 'SI-2 (5)',
  'CCI-002612': 'SI-2 (5)',
  'CCI-002613': 'SI-2 (5)',
  'CCI-002614': 'SI-2 (5)',
  'CCI-002615': 'SI-2 (6)',
  'CCI-002616': 'SI-2 (6)',
  'CCI-002617': 'SI-2 (6)',
  'CCI-002618': 'SI-2 (6)',
  'CCI-002619': 'SI-3 a',
  'CCI-002620': 'SI-3 a',
  'CCI-002621': 'SI-3 a',
  'CCI-002622': 'SI-3 a',
  'CCI-002623': 'SI-3 c 1',
  'CCI-002624': 'SI-3 c 1',
  'CCI-002625': 'SI-3 (6) (b)',
  'CCI-002626': 'SI-3 (6) (b)',
  'CCI-002627': 'SI-3 (7)',
  'CCI-002628': 'SI-3 (8) (a)',
  'CCI-002629': 'SI-3 (8) (a)',
  'CCI-002630': 'SI-3 (8) (a)',
  'CCI-002631': 'SI-3 (8) (b)',
  'CCI-002632': 'SI-3 (9)',
  'CCI-002633': 'SI-3 (9)',
  'CCI-002634': 'SI-3 (10) (a)',
  'CCI-002635': 'SI-3 (10) (a)',
  'CCI-002636': 'SI-3 (10) (a)',
  'CCI-002637': 'SI-3 (9)',
  'CCI-002638': 'SI-3 (10) (a)',
  'CCI-002639': 'SI-3 (10) (b)',
  'CCI-002640': 'SI-3 (10) (b)',
  'CCI-002641': 'SI-4 a 1',
  'CCI-002642': 'SI-4 a 2',
  'CCI-002643': 'SI-4 a 2',
  'CCI-002644': 'SI-4 a 2',
  'CCI-002645': 'SI-4 b',
  'CCI-002646': 'SI-4 b',
  'CCI-002647': 'SI-4 d',
  'CCI-002648': 'SI-4 d',
  'CCI-002649': 'SI-4 d',
  'CCI-002650': 'SI-4 g',
  'CCI-002651': 'SI-4 g',
  'CCI-002652': 'SI-4 g',
  'CCI-002653': 'SI-4',
  'CCI-002654': 'SI-4 g',
  'CCI-002655': 'SI-4 (1)',
  'CCI-002656': 'SI-4 (1)',
  'CCI-002657': 'SI-4 (3)',
  'CCI-002658': 'SI-4 (3)',
  'CCI-002659': 'SI-4 (4) (b)',
  'CCI-002660': 'SI-4 (4) (b)',
  'CCI-002661': 'SI-4 (4) (b)',
  'CCI-002662': 'SI-4 (4) (b)',
  'CCI-002663': 'SI-4 (5)',
  'CCI-002664': 'SI-4 (5)',
  'CCI-002665': 'SI-4 (10)',
  'CCI-002666': 'SI-4 (10)',
  'CCI-002667': 'SI-4 (10)',
  'CCI-002668': 'SI-4 (11)',
  'CCI-002669': 'SI-4 (13) (c)',
  'CCI-002670': 'SI-4 (18)',
  'CCI-002671': 'SI-4 (18)',
  'CCI-002672': 'SI-4 (18)',
  'CCI-002673': 'SI-4 (19)',
  'CCI-002674': 'SI-4 (19)',
  'CCI-002675': 'SI-4 (19)',
  'CCI-002676': 'SI-4 (20)',
  'CCI-002677': 'SI-4 (20)',
  'CCI-002678': 'SI-4 (21)',
  'CCI-002679': 'SI-4 (21)',
  'CCI-002680': 'SI-4 (21)',
  'CCI-002681': 'SI-4 (22) (a)',
  'CCI-002682': 'SI-4 (22) (a)',
  'CCI-002683': 'SI-4 (22) (a)',
  'CCI-002684': 'SI-4 (22) (b)',
  'CCI-002685': 'SI-4 (23)',
  'CCI-002686': 'SI-4 (23)',
  'CCI-002687': 'SI-4 (23)',
  'CCI-002688': 'SI-4 (24)',
  'CCI-002689': 'SI-4 (24)',
  'CCI-002690': 'SI-4 (24)',
  'CCI-002691': 'SI-4 (24)',
  'CCI-002692': 'SI-5 a',
  'CCI-002693': 'SI-5 c',
  'CCI-002694': 'SI-5 c',
  'CCI-002695': 'SI-6 a',
  'CCI-002696': 'SI-6 a',
  'CCI-002697': 'SI-6 b',
  'CCI-002698': 'SI-6 b',
  'CCI-002699': 'SI-6 b',
  'CCI-002700': 'SI-6 c',
  'CCI-002701': 'SI-6 d',
  'CCI-002702': 'SI-6 d',
  'CCI-002703': 'SI-7',
  'CCI-002704': 'SI-7 a',
  'CCI-002705': 'SI-7 (1)',
  'CCI-002706': 'SI-7 (1)',
  'CCI-002707': 'SI-7 (1)',
  'CCI-002708': 'SI-7 (1)',
  'CCI-002709': 'SI-7 (1)',
  'CCI-002710': 'SI-7 (1)',
  'CCI-002711': 'SI-7 (1)',
  'CCI-002712': 'SI-7 (1)',
  'CCI-002713': 'SI-7 (2)',
  'CCI-002714': 'SI-7 (5)',
  'CCI-002715': 'SI-7 (5)',
  'CCI-002716': 'SI-7 (6)',
  'CCI-002717': 'SI-7 (6)',
  'CCI-002718': 'SI-7 (6)',
  'CCI-002719': 'SI-7 (7)',
  'CCI-002720': 'SI-7 (7)',
  'CCI-002721': 'SI-7 (8)',
  'CCI-002722': 'SI-7 (8)',
  'CCI-002723': 'SI-7 (8)',
  'CCI-002724': 'SI-7 (8)',
  'CCI-002725': 'SI-7 (9)',
  'CCI-002726': 'SI-7 (9)',
  'CCI-002727': 'SI-7 (10)',
  'CCI-002728': 'SI-7 (10)',
  'CCI-002729': 'SI-7 (10)',
  'CCI-002730': 'SI-7 (11)',
  'CCI-002731': 'SI-7 (11)',
  'CCI-002732': 'SI-7 (12)',
  'CCI-002733': 'SI-7 (12)',
  'CCI-002734': 'SI-7 (13)',
  'CCI-002735': 'SI-7 (13)',
  'CCI-002736': 'SI-7 (13)',
  'CCI-002737': 'SI-7 (14) (a)',
  'CCI-002738': 'SI-7 (14) (b)',
  'CCI-002739': 'SI-7 (15)',
  'CCI-002740': 'SI-7 (15)',
  'CCI-002741': 'SI-8 a',
  'CCI-002742': 'SI-8 a',
  'CCI-002743': 'SI-8 (3)',
  'CCI-002744': 'SI-10',
  'CCI-002745': 'SI-10 (1) (a)',
  'CCI-002746': 'SI-10 (1) (a)',
  'CCI-002747': 'SI-10 (1) (b)',
  'CCI-002748': 'SI-10 (1) (b)',
  'CCI-002749': 'SI-10 (1) (c)',
  'CCI-002750': 'SI-10 (2)',
  'CCI-002751': 'SI-10 (2)',
  'CCI-002752': 'SI-10 (2)',
  'CCI-002753': 'SI-10 (2)',
  'CCI-002754': 'SI-10 (3)',
  'CCI-002755': 'SI-10 (4)',
  'CCI-002756': 'SI-10 (5)',
  'CCI-002757': 'SI-10 (5)',
  'CCI-002758': 'SI-10 (5)',
  'CCI-002759': 'SI-11 b',
  'CCI-002760': 'SI-13 a',
  'CCI-002761': 'SI-13 a',
  'CCI-002762': 'SI-13 b',
  'CCI-002763': 'SI-13 b',
  'CCI-002764': 'SI-14',
  'CCI-002765': 'SI-14',
  'CCI-002766': 'SI-14',
  'CCI-002767': 'SI-14',
  'CCI-002768': 'SI-14 (1)',
  'CCI-002769': 'SI-14 (1)',
  'CCI-002770': 'SI-15',
  'CCI-002771': 'SI-15',
  'CCI-002772': 'SI-15',
  'CCI-002773': 'SI-17',
  'CCI-002774': 'SI-17',
  'CCI-002775': 'SI-17',
  'CCI-002776': 'IR-1 a 1 (a)',
  'CCI-002777': 'IR-1 a 2',
  'CCI-002778': 'IR-2 a 1',
  'CCI-002779': 'IR-2 a 2',
  'CCI-002780': 'IR-3 (2)',
  'CCI-002781': 'IR-4 (2)',
  'CCI-002782': 'IR-4 (6)',
  'CCI-002783': 'IR-4 (7)',
  'CCI-002784': 'IR-4 (7)',
  'CCI-002785': 'IR-4 (8)',
  'CCI-002786': 'IR-4 (8)',
  'CCI-002787': 'IR-4 (8)',
  'CCI-002788': 'IR-4 (9)',
  'CCI-002789': 'IR-4 (9)',
  'CCI-002790': 'IR-4 (10)',
  'CCI-002791': 'IR-6 b',
  'CCI-002792': 'IR-6 (2)',
  'CCI-002793': 'IR-6 (3)',
  'CCI-002794': 'IR-8 a',
  'CCI-002795': 'IR-8 a 1',
  'CCI-002796': 'IR-8 a 2',
  'CCI-002797': 'IR-8 a 3',
  'CCI-002798': 'IR-8 a 4',
  'CCI-002799': 'IR-8 a 5',
  'CCI-002800': 'IR-8 a 6',
  'CCI-002801': 'IR-8 a 7',
  'CCI-002802': 'IR-8 a 9',
  'CCI-002803': 'IR-8 d',
  'CCI-002804': 'IR-8 e',
  'CCI-002805': 'IR-9 b',
  'CCI-002806': 'IR-9 c',
  'CCI-002807': 'IR-9 c',
  'CCI-002808': 'IR-9 d',
  'CCI-002809': 'IR-9 e',
  'CCI-002810': 'IR-9 f',
  'CCI-002811': 'IR-9 g',
  'CCI-002812': 'IR-9 g',
  'CCI-002813': 'IR-9 (1)',
  'CCI-002814': 'IR-9 (1)',
  'CCI-002815': 'IR-9 (1)',
  'CCI-002816': 'IR-9 (2)',
  'CCI-002817': 'IR-9 (2)',
  'CCI-002818': 'IR-9 (3)',
  'CCI-002819': 'IR-9 (3)',
  'CCI-002820': 'IR-9 (4)',
  'CCI-002821': 'IR-9 (4)',
  'CCI-002822': 'IR-10',
  'CCI-002823': 'SI-16',
  'CCI-002824': 'SI-16',
  'CCI-002825': 'CP-1 a 1 (a)',
  'CCI-002826': 'CP-1 a 2',
  'CCI-002827': 'CP-2 (7)',
  'CCI-002828': 'CP-2 (8)',
  'CCI-002829': 'CP-2 (8)',
  'CCI-002830': 'CP-2 a 7',
  'CCI-002831': 'CP-2 f',
  'CCI-002832': 'CP-2 h',
  'CCI-002833': 'CP-3 a 1',
  'CCI-002834': 'CP-3 a 2',
  'CCI-002835': 'CP-4 (2) (b)',
  'CCI-002836': 'CP-6 b',
  'CCI-002837': 'CP-7 (6)',
  'CCI-002838': 'CP-7 (6)',
  'CCI-002839': 'CP-7 a',
  'CCI-002840': 'CP-8',
  'CCI-002841': 'CP-8',
  'CCI-002842': 'CP-8 (4) (b)',
  'CCI-002843': 'CP-8 (4) (c)',
  'CCI-002844': 'CP-8 (4) (c)',
  'CCI-002845': 'CP-8 (4) (c)',
  'CCI-002846': 'CP-8 (4) (c)',
  'CCI-002847': 'CP-8 (5)',
  'CCI-002848': 'CP-8 (5)',
  'CCI-002849': 'CP-9 (3)',
  'CCI-002850': 'CP-9 (3)',
  'CCI-002851': 'CP-9 (7)',
  'CCI-002852': 'CP-9 (7)',
  'CCI-002853': 'CP-11',
  'CCI-002854': 'CP-11',
  'CCI-002855': 'CP-12',
  'CCI-002856': 'CP-12',
  'CCI-002857': 'CP-12',
  'CCI-002858': 'CP-13',
  'CCI-002859': 'CP-13',
  'CCI-002860': 'CP-13',
  'CCI-002861': 'MA-1 a 1 (a)',
  'CCI-002862': 'MA-1 a 2',
  'CCI-002863': 'MA-2 (2) (a)',
  'CCI-002864': 'MA-2 (2) (b)',
  'CCI-002865': 'MA-2 (2) (b)',
  'CCI-002866': 'MA-2 a',
  'CCI-002867': 'MA-2 a ',
  'CCI-002868': 'MA-2 a',
  'CCI-002869': 'MA-2 a',
  'CCI-002870': 'MA-2 a',
  'CCI-002871': 'MA-2 a',
  'CCI-002872': 'MA-2 a',
  'CCI-002873': 'MA-2 a',
  'CCI-002874': 'MA-2 c',
  'CCI-002875': 'MA-2 f',
  'CCI-002876': 'MA-2 f',
  'CCI-002877': 'MA-3 (3) (a)',
  'CCI-002878': 'MA-3 (3) (b)',
  'CCI-002879': 'MA-3 (3) (c)',
  'CCI-002880': 'MA-3 (3) (c)',
  'CCI-002881': 'MA-3 (3) (d)',
  'CCI-002882': 'MA-3 (3) (d)',
  'CCI-002883': 'MA-3 (4)',
  'CCI-002884': 'MA-4 (1) (a)',
  'CCI-002885': 'MA-4 (1) (a)',
  'CCI-002886': 'MA-4 (1) (b)',
  'CCI-002887': 'MA-4 (4) (a)',
  'CCI-002888': 'MA-4 (5) (a)',
  'CCI-002889': 'MA-4 (5) (b)',
  'CCI-002890': 'MA-4 (6)',
  'CCI-002891': 'MA-4 (7)',
  'CCI-002892': 'MA-5 (1) (b)',
  'CCI-002893': 'MA-5 (5)',
  'CCI-002894': 'MA-5 b',
  'CCI-002895': 'MA-5 c',
  'CCI-002896': 'MA-6',
  'CCI-002897': 'MA-6',
  'CCI-002898': 'MA-6 (1)',
  'CCI-002899': 'MA-6 (1)',
  'CCI-002900': 'MA-6 (1)',
  'CCI-002901': 'MA-6 (2)',
  'CCI-002902': 'MA-6 (2)',
  'CCI-002903': 'MA-6 (2)',
  'CCI-002904': 'MA-6 (3)',
  'CCI-002905': 'MA-2 (2) (a)',
  'CCI-002906': 'RA-5 (5)',
  'CCI-002907': 'AU-5 (4)',
  'CCI-002908': 'PE-1 a 1',
  'CCI-002909': 'PE-1 a 2',
  'CCI-002910': 'PE-2 a',
  'CCI-002911': 'PE-2 a',
  'CCI-002912': 'PE-2 (2)',
  'CCI-002913': 'PE-2 (3)',
  'CCI-002914': 'PE-2 (3)',
  'CCI-002915': 'PE-3 a',
  'CCI-002916': 'PE-3 a 2',
  'CCI-002917': 'PE-3 b',
  'CCI-002918': 'PE-3 b',
  'CCI-002919': 'PE-3 c',
  'CCI-002920': 'PE-3 c',
  'CCI-002921': 'PE-3 d',
  'CCI-002922': 'PE-3 d',
  'CCI-002923': 'PE-3 d',
  'CCI-002924': 'PE-3 d',
  'CCI-002925': 'PE-3 f',
  'CCI-002926': 'PE-3 (1)',
  'CCI-002927': 'PE-3 (2)',
  'CCI-002928': 'PE-3 (5)',
  'CCI-002929': 'PE-3 (5)',
  'CCI-002930': 'PE-4',
  'CCI-002931': 'PE-4',
  'CCI-002932': 'PE-5 (1) (a)',
  'CCI-002933': 'PE-5 (1) (a)',
  'CCI-002934': 'PE-5 (1) (b)',
  'CCI-002935': 'PE-5 (2) (a)',
  'CCI-002936': 'PE-5 (2) (b)',
  'CCI-002937': 'PE-5 (3)',
  'CCI-002938': 'PE-5 (3)',
  'CCI-002939': 'PE-6 a',
  'CCI-002940': 'PE-6 b',
  'CCI-002941': 'PE-6 b',
  'CCI-002942': 'PE-6 (2)',
  'CCI-002943': 'PE-6 (2)',
  'CCI-002944': 'PE-6 (2)',
  'CCI-002945': 'PE-6 (2)',
  'CCI-002946': 'PE-6 (3) (a)',
  'CCI-002947': 'PE-6 (3) (a)',
  'CCI-002948': 'PE-6 (3) (c)',
  'CCI-002949': 'PE-6 (3) (c)',
  'CCI-002950': 'PE-6 (4)',
  'CCI-002951': 'PE-6 (4)',
  'CCI-002952': 'PE-8 a',
  'CCI-002953': 'PE-9 (1)',
  'CCI-002954': 'PE-9 (1)',
  'CCI-002955': 'PE-11',
  'CCI-002956': 'PE-11 (2) (a)',
  'CCI-002957': 'PE-11 (2) (b)',
  'CCI-002958': 'PE-11 (2) (c)',
  'CCI-002959': 'PE-12 (1)',
  'CCI-002960': 'PE-12 (1)',
  'CCI-002961': 'PE-13 (1)',
  'CCI-002962': 'PE-13 (1)',
  'CCI-002963': 'PE-13 (1)',
  'CCI-002964': 'PE-13 (1)',
  'CCI-002965': 'PE-13 (2) (a)',
  'CCI-002966': 'PE-13 (2) (a)',
  'CCI-002967': 'PE-13 (2) (a)',
  'CCI-002968': 'PE-13 (4)',
  'CCI-002969': 'PE-13 (4)',
  'CCI-002970': 'PE-13 (4)',
  'CCI-002971': 'PE-13 (4)',
  'CCI-002972': 'PE-15 (1)',
  'CCI-002973': 'PE-15 (1)',
  'CCI-002974': 'PE-16 a',
  'CCI-002975': 'PE-17 b',
  'CCI-002976': 'PE-18',
  'CCI-002977': 'PE-18 (1)',
  'CCI-002978': 'PE-18 (1)',
  'CCI-002979': 'PE-20',
  'CCI-002980': 'PE-20',
  'CCI-002981': 'PE-20',
  'CCI-002982': 'PE-20',
  'CCI-002983': 'PE-20 b',
  'CCI-002984': 'PM-1 a 3',
  'CCI-002985': 'PM-1 a 1',
  'CCI-002986': 'PM-1 a 2',
  'CCI-002987': 'PM-1 a 3',
  'CCI-002988': 'PM-1 a 4',
  'CCI-002989': 'PM-1 c',
  'CCI-002990': 'PM-1 c',
  'CCI-002991': 'PM-4 a 1',
  'CCI-002992': 'PM-4 a 3',
  'CCI-002993': 'PM-4 b',
  'CCI-002994': 'PM-9 c',
  'CCI-002995': 'PM-9 c',
  'CCI-002996': 'PM-12',
  'CCI-002997': 'PM-13',
  'CCI-002998': 'PM-14 a 1',
  'CCI-002999': 'PM-14 a 1',
  'CCI-003000': 'PM-14 a 1',
  'CCI-003001': 'PM-14 a 1',
  'CCI-003002': 'PM-14 a 1',
  'CCI-003003': 'PM-14 a 1',
  'CCI-003004': 'PM-14 a 2',
  'CCI-003005': 'PM-14 a 2',
  'CCI-003006': 'PM-14 a 2',
  'CCI-003007': 'PM-14 b',
  'CCI-003008': 'PM-14 b',
  'CCI-003009': 'PM-14 b',
  'CCI-003010': 'PM-15 a',
  'CCI-003011': 'PM-15 b',
  'CCI-003012': 'PM-15 c',
  'CCI-003013': 'PM-16',
  'CCI-003014': 'AC-3 (3)',
  'CCI-003015': 'AC-3 (3) (c)',
  'CCI-003016': 'PS-4 f',
  'CCI-003017': 'PS-1 a 1',
  'CCI-003018': 'PS-1 a 2',
  'CCI-003019': 'PS-3 (3) (a)',
  'CCI-003020': 'PS-3 (3) (b)',
  'CCI-003021': 'PS-3 (3) (b)',
  'CCI-003022': 'PS-4 a',
  'CCI-003023': 'PS-4 b',
  'CCI-003024': 'PS-4 c',
  'CCI-003025': 'PS-4 f',
  'CCI-003026': 'PS-4 f',
  'CCI-003027': 'PS-4 (1) (a)',
  'CCI-003028': 'PS-4 (1) (b)',
  'CCI-003029': 'PS-4 (2)',
  'CCI-003030': 'PS-4 (2)',
  'CCI-003031': 'PS-5 c',
  'CCI-003032': 'PS-5 d',
  'CCI-003033': 'PS-5 d',
  'CCI-003034': 'PS-5 d',
  'CCI-003035': 'PS-6 a',
  'CCI-003036': 'PS-6 c 2',
  'CCI-003037': 'PS-6 c 2',
  'CCI-003038': 'PS-6 (3) (a)',
  'CCI-003039': 'PS-6 (3) (b)',
  'CCI-003040': 'PS-7 b',
  'CCI-003041': 'PS-7 d',
  'CCI-003042': 'PS-7 d',
  'CCI-003043': 'PS-7 d',
  'CCI-003044': 'PS-8 b',
  'CCI-003045': 'PS-8 b',
  'CCI-003046': 'PS-8 b',
  'CCI-003047': 'PL-1 a 1 (a)',
  'CCI-003048': 'PL-1 a 2',
  'CCI-003049': 'PL-2 a',
  'CCI-003050': 'PL-2 a 1',
  'CCI-003051': 'PL-2 a 2',
  'CCI-003052': 'PL-2 a 3',
  'CCI-003053': 'PL-2 a 6',
  'CCI-003054': 'PL-2 a 9',
  'CCI-003055': 'PL-2 a 10',
  'CCI-003056': 'PL-2 a 11',
  'CCI-003057': 'PL-2 a 12',
  'CCI-003058': 'PL-2 b',
  'CCI-003059': 'PL-2 b',
  'CCI-003060': 'PL-2 b',
  'CCI-003061': 'PL-2 b',
  'CCI-003062': 'PL-2 b',
  'CCI-003063': 'PL-2 e',
  'CCI-003064': 'PL-2 e',
  'CCI-003065': 'PL-2 (3)',
  'CCI-003066': 'PL-2 (3)',
  'CCI-003067': 'PL-2 (3)',
  'CCI-003068': 'PL-4 c',
  'CCI-003069': 'PL-4 c',
  'CCI-003070': 'PL-4 d',
  'CCI-003071': 'PL-7 a',
  'CCI-003072': 'PL-8 a',
  'CCI-003073': 'PL-8 a 1',
  'CCI-003074': 'PL-8 a 3',
  'CCI-003075': 'PL-8 a 4',
  'CCI-003076': 'PL-8 b',
  'CCI-003077': 'PL-8 b',
  'CCI-003078': 'PL-8 c',
  'CCI-003079': 'PL-8 c',
  'CCI-003080': 'PL-8 c',
  'CCI-003081': 'PL-8 (1) (a)',
  'CCI-003082': 'PL-8 (1) (a)',
  'CCI-003083': 'PL-8 (1) (a)',
  'CCI-003084': 'PL-8 (1) (a)',
  'CCI-003085': 'PL-8 (1) (a)',
  'CCI-003086': 'PL-8 (1) (a)',
  'CCI-003087': 'PL-8 (1) (b)',
  'CCI-003088': 'PL-8 (2)',
  'CCI-003089': 'SA-1 a 1 (a)',
  'CCI-003090': 'SA-1 a 2',
  'CCI-003091': 'SA-2 a',
  'CCI-003092': 'SA-3 a',
  'CCI-003093': 'SA-3 d',
  'CCI-003094': 'SA-4 a',
  'CCI-003095': 'SA-4 b',
  'CCI-003096': 'SA-4 c',
  'CCI-003097': 'SA-4 e',
  'CCI-003098': 'SA-4 f',
  'CCI-003099': 'SA-4 g',
  'CCI-003100': 'SA-4 i',
  'CCI-003101': 'SA-4 (2)',
  'CCI-003102': 'SA-4 (2)',
  'CCI-003103': 'SA-4 (2)',
  'CCI-003104': 'SA-4 (2)',
  'CCI-003105': 'SA-4 (2)',
  'CCI-003106': 'SA-4 (2)',
  'CCI-003107': 'SA-4 (3)',
  'CCI-003108': 'SA-4 (3)',
  'CCI-003109': 'SA-4 (5) (a)',
  'CCI-003110': 'SA-4 (5) (a)',
  'CCI-003111': 'SA-4 (5) (b)',
  'CCI-003112': 'SA-4 (8)',
  'CCI-003113': 'SA-4 (8)',
  'CCI-003114': 'SA-4 (9)',
  'CCI-003115': 'SA-4 (9)',
  'CCI-003116': 'SA-4 (10)',
  'CCI-003117': 'PL-9',
  'CCI-003118': 'PL-9',
  'CCI-003119': 'RA-6',
  'CCI-003120': 'RA-6',
  'CCI-003121': 'RA-6',
  'CCI-003122': 'RA-6',
  'CCI-003123': 'MA-4 (6)',
  'CCI-003124': 'SA-5 a 1',
  'CCI-003125': 'SA-5 a 1',
  'CCI-003126': 'SA-5 a 1',
  'CCI-003127': 'SA-5 a 2',
  'CCI-003128': 'SA-5 a 3',
  'CCI-003129': 'SA-5 b 1',
  'CCI-003130': 'SA-5 b 2',
  'CCI-003131': 'SA-5 b 3',
  'CCI-003132': 'SA-5 c',
  'CCI-003133': 'SA-5 c',
  'CCI-003134': 'SA-5 d',
  'CCI-003135': 'SA-5 d',
  'CCI-003136': 'SA-5 d',
  'CCI-003137': 'SA-9 a',
  'CCI-003138': 'SA-9 c',
  'CCI-003139': 'SA-9 c',
  'CCI-003140': 'SA-9 (1) (a)',
  'CCI-003141': 'SA-9 (1) (b)',
  'CCI-003142': 'SA-9 (1) (b)',
  'CCI-003143': 'SA-9 (2)',
  'CCI-003144': 'SA-9 (2)',
  'CCI-003145': 'SA-9 (3)',
  'CCI-003146': 'SA-9 (3)',
  'CCI-003147': 'SA-9 (3)',
  'CCI-003148': 'SA-9 (3)',
  'CCI-003149': 'SA-9 (4)',
  'CCI-003150': 'SA-9 (4)',
  'CCI-003151': 'SA-9 (4)',
  'CCI-003152': 'SA-9 (5)',
  'CCI-003153': 'SA-9 (5)',
  'CCI-003154': 'SA-9 (5)',
  'CCI-003155': 'SA-10 a',
  'CCI-003156': 'SA-10 b',
  'CCI-003157': 'SA-10 b',
  'CCI-003158': 'SA-10 b',
  'CCI-003159': 'SA-10 b',
  'CCI-003160': 'SA-10 d',
  'CCI-003161': 'SA-10 e',
  'CCI-003162': 'SA-10 e',
  'CCI-003163': 'SA-10 e',
  'CCI-003164': 'SA-10 e',
  'CCI-003165': 'SA-10 (3)',
  'CCI-003166': 'SA-10 (4)',
  'CCI-003167': 'SA-10 (4)',
  'CCI-003168': 'SA-10 (4)',
  'CCI-003169': 'SA-10 (5)',
  'CCI-003170': 'SA-10 (6)',
  'CCI-003171': 'SA-11 a',
  'CCI-003172': 'SA-11 a',
  'CCI-003173': 'SA-11 b',
  'CCI-003174': 'SA-11 b',
  'CCI-003175': 'SA-11 c',
  'CCI-003176': 'SA-11 c',
  'CCI-003177': 'SA-11 d',
  'CCI-003178': 'SA-11 e',
  'CCI-003179': 'SA-11 (1)',
  'CCI-003180': 'SA-11 (1)',
  'CCI-003181': 'SA-11 (2)',
  'CCI-003182': 'SA-11 (2)',
  'CCI-003183': 'SA-11 (3) (a)',
  'CCI-003184': 'SA-11 (3) (a)',
  'CCI-003185': 'SA-11 (3) (a)',
  'CCI-003186': 'SA-11 (3) (b)',
  'CCI-003187': 'SA-11 (4)',
  'CCI-003188': 'SA-11 (4)',
  'CCI-003189': 'SA-11 (4)',
  'CCI-003190': 'SA-11 (5)',
  'CCI-003191': 'SA-11 (5) (a)',
  'CCI-003192': 'SA-11 (5) (b)',
  'CCI-003193': 'SA-11 (6)',
  'CCI-003194': 'SA-11 (7)',
  'CCI-003195': 'SA-11 (7)',
  'CCI-003196': 'SA-11 (8)',
  'CCI-003197': 'SA-11 (8)',
  'CCI-003198': 'SA-12 (1)',
  'CCI-003199': 'SA-12 (1)',
  'CCI-003200': 'SA-12 (2)',
  'CCI-003201': 'SA-12 (5)',
  'CCI-003202': 'SA-12 (5)',
  'CCI-003203': 'SA-12 (7)',
  'CCI-003204': 'SA-12 (7)',
  'CCI-003205': 'SA-12 (8)',
  'CCI-003206': 'SA-12 (9)',
  'CCI-003207': 'SA-12 (1)',
  'CCI-003208': 'SA-12 (1)',
  'CCI-003209': 'SA-12 (1)',
  'CCI-003210': 'SA-12 (9)',
  'CCI-003211': 'SA-12 (9)',
  'CCI-003212': 'SA-12 (10)',
  'CCI-003213': 'SA-12 (10)',
  'CCI-003214': 'SA-12 (11)',
  'CCI-003215': 'SA-12 (11)',
  'CCI-003216': 'SA-12 (12)',
  'CCI-003217': 'SA-12 (12)',
  'CCI-003218': 'SA-12 (13)',
  'CCI-003219': 'SA-12 (13)',
  'CCI-003220': 'SA-12 (13)',
  'CCI-003221': 'SA-12 (14)',
  'CCI-003222': 'SA-12 (14)',
  'CCI-003223': 'SA-12 (14)',
  'CCI-003224': 'SA-12 (15)',
  'CCI-003225': 'SA-13 a',
  'CCI-003226': 'SA-13 a',
  'CCI-003227': 'SA-13 b',
  'CCI-003228': 'SA-13 b',
  'CCI-003229': 'SA-14',
  'CCI-003230': 'SA-14',
  'CCI-003231': 'SA-14',
  'CCI-003232': 'SA-14',
  'CCI-003233': 'SA-15 a',
  'CCI-003234': 'SA-15 a 1',
  'CCI-003235': 'SA-15 a 2',
  'CCI-003236': 'SA-15 a 2',
  'CCI-003237': 'SA-15 a 3',
  'CCI-003238': 'SA-15 a 4',
  'CCI-003239': 'SA-15 a 4',
  'CCI-003240': 'SA-15 a 4',
  'CCI-003241': 'SA-15 b',
  'CCI-003242': 'SA-15 b',
  'CCI-003243': 'SA-15 b',
  'CCI-003244': 'SA-15 b',
  'CCI-003245': 'SA-15 b',
  'CCI-003246': 'SA-15 b',
  'CCI-003247': 'SA-15 (1) (a)',
  'CCI-003248': 'SA-15 (1) (b)',
  'CCI-003249': 'SA-15 (1) (b)',
  'CCI-003250': 'SA-15 (1) (b)',
  'CCI-003251': 'SA-15 (2)',
  'CCI-003252': 'SA-15 (2)',
  'CCI-003253': 'SA-15 (3)',
  'CCI-003254': 'SA-15 (3) (b)',
  'CCI-003255': 'SA-15 (3) (a)',
  'CCI-003256': 'SA-15 (4)',
  'CCI-003257': 'SA-15 (4)',
  'CCI-003258': 'SA-15 (4)',
  'CCI-003259': 'SA-15 (4)',
  'CCI-003260': 'SA-15 (4) (a)',
  'CCI-003261': 'SA-15 (4) (a)',
  'CCI-003262': 'SA-15 (4) (a)',
  'CCI-003263': 'SA-15 (4) (a)',
  'CCI-003264': 'SA-15 (4) (b)',
  'CCI-003265': 'SA-15 (4) (b)',
  'CCI-003266': 'SA-15 (4) (b)',
  'CCI-003267': 'SA-15 (4) (b)',
  'CCI-003268': 'SA-15 (4) (c)',
  'CCI-003269': 'SA-15 (4) (c)',
  'CCI-003270': 'SA-15 (4) (c)',
  'CCI-003271': 'SA-15 (4) (c)',
  'CCI-003272': 'SA-15 (5)',
  'CCI-003273': 'SA-15 (5)',
  'CCI-003274': 'SA-15 (6)',
  'CCI-003275': 'SA-15 (7) (a)',
  'CCI-003276': 'SA-15 (7) (a)',
  'CCI-003277': 'SA-15 (7) (b)',
  'CCI-003278': 'SA-15 (7) (c)',
  'CCI-003279': 'SA-15 (7) (d)',
  'CCI-003280': 'SA-15 (7) (d)',
  'CCI-003281': 'SA-15 (8)',
  'CCI-003282': 'SA-15 (8)',
  'CCI-003283': 'SA-15 (9)',
  'CCI-003284': 'SA-15 (9)',
  'CCI-003285': 'SA-15 (9)',
  'CCI-003286': 'SA-15 (9)',
  'CCI-003287': 'SA-15 (9)',
  'CCI-003288': 'SA-15 (9)',
  'CCI-003289': 'SA-15 (10)',
  'CCI-003290': 'SA-15 (11)',
  'CCI-003291': 'SA-16',
  'CCI-003292': 'SA-16',
  'CCI-003293': 'SA-17',
  'CCI-003294': 'SA-17 a',
  'CCI-003295': 'SA-17 b',
  'CCI-003296': 'SA-17 b',
  'CCI-003297': 'SA-17 c',
  'CCI-003298': 'SA-17 (1) (a)',
  'CCI-003299': 'SA-17 (1) (a)',
  'CCI-003300': 'SA-17 (1) (b)',
  'CCI-003301': 'SA-17 (2) (a)',
  'CCI-003302': 'SA-17 (2) (a)',
  'CCI-003303': 'SA-17 (2) (a)',
  'CCI-003304': 'SA-17 (2) (a)',
  'CCI-003305': 'SA-17 (2) (b)',
  'CCI-003306': 'SA-17 (2) (b)',
  'CCI-003307': 'SA-17 (2) (b)',
  'CCI-003308': 'SA-17 (3) (a)',
  'CCI-003309': 'SA-17 (3) (a)',
  'CCI-003310': 'SA-17 (3) (a)',
  'CCI-003311': 'SA-17 (3) (b)',
  'CCI-003312': 'SA-17 (3) (c)',
  'CCI-003313': 'SA-17 (3) (c)',
  'CCI-003314': 'SA-17 (3) (c)',
  'CCI-003315': 'SA-17 (3) (d)',
  'CCI-003316': 'SA-17 (3) (d)',
  'CCI-003317': 'SA-17 (3) (d)',
  'CCI-003318': 'SA-17 (3) (e)',
  'CCI-003319': 'SA-17 (3) (e)',
  'CCI-003320': 'SA-17 (3) (e)',
  'CCI-003321': 'SA-17 (4) (a)',
  'CCI-003322': 'SA-17 (4) (a)',
  'CCI-003323': 'SA-17 (4) (a)',
  'CCI-003324': 'SA-17 (4) (b)',
  'CCI-003325': 'SA-17 (4) (c)',
  'CCI-003326': 'SA-17 (4) (c)',
  'CCI-003327': 'SA-17 (4) (c)',
  'CCI-003328': 'SA-17 (4) (d)',
  'CCI-003329': 'SA-17 (4) (d)',
  'CCI-003330': 'SA-17 (4) (d)',
  'CCI-003331': 'SA-17 (4) (e)',
  'CCI-003332': 'SA-17 (4) (e)',
  'CCI-003333': 'SA-17 (4) (e)',
  'CCI-003334': 'SA-17 (5) (a)',
  'CCI-003335': 'SA-17 (5) (a)',
  'CCI-003336': 'SA-17 (5) (a)',
  'CCI-003337': 'SA-17 (5) (b)',
  'CCI-003338': 'SA-17 (5) (b)',
  'CCI-003339': 'SA-17 (5) (b)',
  'CCI-003340': 'SA-17 (6)',
  'CCI-003341': 'SA-17 (6)',
  'CCI-003342': 'SA-17 (6)',
  'CCI-003343': 'SA-17 (7)',
  'CCI-003344': 'SA-17 (7)',
  'CCI-003345': 'SA-17 (7)',
  'CCI-003346': 'SA-18',
  'CCI-003347': 'SA-18 (1)',
  'CCI-003348': 'SA-18 (1)',
  'CCI-003349': 'SA-18 (1)',
  'CCI-003350': 'SA-18 (1)',
  'CCI-003351': 'SA-18 (1)',
  'CCI-003352': 'SA-18 (2)',
  'CCI-003353': 'SA-18 (2)',
  'CCI-003354': 'SA-18 (2)',
  'CCI-003355': 'SA-18 (2)',
  'CCI-003356': 'SA-19 a',
  'CCI-003357': 'SA-19 a',
  'CCI-003358': 'SA-19 a',
  'CCI-003359': 'SA-19 a',
  'CCI-003360': 'SA-19 a',
  'CCI-003361': 'SA-19 a',
  'CCI-003362': 'SA-19 a',
  'CCI-003363': 'SA-19 a',
  'CCI-003364': 'SA-19 b',
  'CCI-003365': 'SA-19 b',
  'CCI-003366': 'SA-19 b',
  'CCI-003367': 'SA-19 (1)',
  'CCI-003368': 'SA-19 (1)',
  'CCI-003369': 'SA-19 (2)',
  'CCI-003370': 'SA-19 (2)',
  'CCI-003371': 'SA-19 (2)',
  'CCI-003372': 'SA-22 b',
  'CCI-003373': 'SA-22 b',
  'CCI-003374': 'SA-22 b',
  'CCI-003375': 'SA-22 b',
  'CCI-003376': 'SA-22 a',
  'CCI-003377': 'SA-21 (1)',
  'CCI-003378': 'SA-21 (1)',
  'CCI-003379': 'SA-21 (1)',
  'CCI-003380': 'SA-21 (1)',
  'CCI-003381': 'SA-21 b',
  'CCI-003382': 'SA-21 b',
  'CCI-003383': 'SA-21 a',
  'CCI-003384': 'SA-21',
  'CCI-003385': 'SA-21 a',
  'CCI-003386': 'SA-20',
  'CCI-003387': 'SA-20',
  'CCI-003388': 'SA-19 (4)',
  'CCI-003389': 'SA-19 (4)',
  'CCI-003390': 'SA-19 (3)',
  'CCI-003391': 'SA-19 (3)',
  'CCI-003392': 'AP-1',
  'CCI-003393': 'AP-1',
  'CCI-003394': 'AP-1',
  'CCI-003395': 'AP-1',
  'CCI-003396': 'AP-2',
  'CCI-003397': 'AR-1 a',
  'CCI-003398': 'AP-2',
  'CCI-003399': 'AP-2',
  'CCI-003400': 'AP-2',
  'CCI-003401': 'AR-1 b',
  'CCI-003402': 'AR-1 c',
  'CCI-003403': 'AR-1 c',
  'CCI-003404': 'AR-1 c',
  'CCI-003405': 'AR-1 c',
  'CCI-003406': 'AR-1 d',
  'CCI-003407': 'AR-1 e',
  'CCI-003408': 'AR-1 e',
  'CCI-003409': 'AR-1 e',
  'CCI-003410': 'AR-1 e',
  'CCI-003411': 'AR-1 e',
  'CCI-003412': 'AR-1 e',
  'CCI-003413': 'AR-1 f',
  'CCI-003414': 'AR-1 f',
  'CCI-003415': 'AR-1 f',
  'CCI-003416': 'AR-1 f',
  'CCI-003417': 'AR-2 a',
  'CCI-003418': 'AR-2 a',
  'CCI-003419': 'AR-2 a',
  'CCI-003420': 'AR-2 a',
  'CCI-003421': 'AR-2 a',
  'CCI-003422': 'AR-2 a',
  'CCI-003423': 'AR-2 a',
  'CCI-003424': 'AR-2 a',
  'CCI-003425': 'AR-2 b',
  'CCI-003426': 'AR-3 a',
  'CCI-003427': 'AR-3 a',
  'CCI-003428': 'AR-3 a',
  'CCI-003429': 'AR-3 a',
  'CCI-003430': 'AR-3 a',
  'CCI-003431': 'AR-3 a',
  'CCI-003432': 'AR-3 b',
  'CCI-003433': 'AR-3 b',
  'CCI-003434': 'AR-4',
  'CCI-003435': 'AR-4',
  'CCI-003436': 'AR-4',
  'CCI-003437': 'AR-4',
  'CCI-003438': 'AR-4',
  'CCI-003439': 'AR-4',
  'CCI-003440': 'AR-5 a',
  'CCI-003441': 'AR-5 a',
  'CCI-003442': 'AR-5 a',
  'CCI-003443': 'AR-5 b',
  'CCI-003444': 'AR-5 b',
  'CCI-003445': 'AR-5 b',
  'CCI-003446': 'AR-5 b',
  'CCI-003447': 'AR-5 c',
  'CCI-003448': 'AR-5 c',
  'CCI-003449': 'AR-6',
  'CCI-003450': 'AR-6',
  'CCI-003451': 'AR-6',
  'CCI-003452': 'AR-6',
  'CCI-003453': 'AR-6',
  'CCI-003454': 'AR-6',
  'CCI-003455': 'AR-7',
  'CCI-003456': 'AR-8 a (1)',
  'CCI-003457': 'AR-8 a (1)',
  'CCI-003458': 'AR-8 a (1)',
  'CCI-003459': 'AR-8 a (1)',
  'CCI-003460': 'AR-8 a (2)',
  'CCI-003461': 'AR-8 b',
  'CCI-003462': 'AR-8 c',
  'CCI-003463': 'DI-1 a',
  'CCI-003464': 'DI-1 a',
  'CCI-003465': 'DI-1 a',
  'CCI-003466': 'DI-1 a',
  'CCI-003467': 'DI-1 b',
  'CCI-003468': 'DI-1 c',
  'CCI-003469': 'DI-1 c',
  'CCI-003470': 'DI-1 d',
  'CCI-003471': 'DI-1 d',
  'CCI-003472': 'DI-1 d',
  'CCI-003473': 'DI-1 d',
  'CCI-003474': 'DI-1 d',
  'CCI-003475': 'DI-1 d',
  'CCI-003476': 'DI-1 d',
  'CCI-003477': 'DI-1 d',
  'CCI-003478': 'DI-1 (1)',
  'CCI-003479': 'DI-1 (2)',
  'CCI-003480': 'DI-1 (2)',
  'CCI-003481': 'DI-2 a',
  'CCI-003482': 'DI-2 b',
  'CCI-003483': 'DI-2 b',
  'CCI-003484': 'DI-2 b',
  'CCI-003485': 'DI-2 (1)',
  'CCI-003486': 'DM-1 a',
  'CCI-003487': 'DM-1 b',
  'CCI-003488': 'DM-1 b',
  'CCI-003489': 'DM-1 c',
  'CCI-003490': 'DM-1 c',
  'CCI-003491': 'DM-1 c',
  'CCI-003492': 'DM-1 c',
  'CCI-003493': 'DM-1 c',
  'CCI-003494': 'DM-1 c',
  'CCI-003495': 'DM-1 (1)',
  'CCI-003496': 'DM-1 (1)',
  'CCI-003497': 'DM-2 a',
  'CCI-003498': 'DM-2 a',
  'CCI-003499': 'DM-2 b',
  'CCI-003500': 'DM-2 b',
  'CCI-003501': 'DM-2 c',
  'CCI-003502': 'DM-2 c',
  'CCI-003503': 'DM-2 (1)',
  'CCI-003504': 'DM-2 (1)',
  'CCI-003505': 'DM-2 (1)',
  'CCI-003506': 'DM-2 (1)',
  'CCI-003507': 'DM-3 a',
  'CCI-003508': 'DM-3 a',
  'CCI-003509': 'DM-3 a',
  'CCI-003510': 'DM-3 a',
  'CCI-003511': 'DM-3 a',
  'CCI-003512': 'DM-3 a',
  'CCI-003513': 'DM-3 b',
  'CCI-003514': 'DM-3 b',
  'CCI-003515': 'DM-3 b',
  'CCI-003516': 'DM-3 (1)',
  'CCI-003517': 'DM-3 (1)',
  'CCI-003518': 'DM-3 (1)',
  'CCI-003519': 'IP-1 a',
  'CCI-003520': 'IP-1 a',
  'CCI-003521': 'IP-1 a',
  'CCI-003522': 'IP-1 a',
  'CCI-003523': 'IP-1 b',
  'CCI-003524': 'IP-1 b',
  'CCI-003525': 'IP-1 b',
  'CCI-003526': 'IP-1 b',
  'CCI-003527': 'IP-1 c',
  'CCI-003528': 'IP-1 d',
  'CCI-003529': 'IP-1 d',
  'CCI-003530': 'IP-1 (1)',
  'CCI-003531': 'IP-2 a',
  'CCI-003532': 'IP-2 b',
  'CCI-003533': 'IP-2 b',
  'CCI-003534': 'IP-2 c',
  'CCI-003535': 'IP-2 d',
  'CCI-003536': 'IP-2 d',
  'CCI-003537': 'IP-3 a',
  'CCI-003538': 'IP-3 b',
  'CCI-003539': 'IP-3 b',
  'CCI-003540': 'IP-4',
  'CCI-003541': 'IP-4',
  'CCI-003542': 'IP-4 (1)',
  'CCI-003543': 'IP-4 (1)',
  'CCI-003544': 'SE-1 a',
  'CCI-003545': 'SE-1 a',
  'CCI-003546': 'SE-1 a',
  'CCI-003547': 'SE-1 a',
  'CCI-003548': 'SE-1 a',
  'CCI-003549': 'SE-1 a',
  'CCI-003550': 'SE-1 a',
  'CCI-003551': 'SE-1 b',
  'CCI-003552': 'SE-1 b',
  'CCI-003553': 'SE-2 a',
  'CCI-003554': 'SE-2 a',
  'CCI-003555': 'SE-2 b',
  'CCI-003556': 'TR-1 a',
  'CCI-003557': 'TR-1 a',
  'CCI-003558': 'TR-1 a',
  'CCI-003559': 'TR-1 a',
  'CCI-003560': 'TR-1 a',
  'CCI-003561': 'TR-1 a',
  'CCI-003562': 'TR-1 a',
  'CCI-003563': 'TR-1 a',
  'CCI-003564': 'TR-1 a',
  'CCI-003565': 'TR-1 a',
  'CCI-003566': 'TR-1 a',
  'CCI-003567': 'TR-1 a',
  'CCI-003568': 'TR-1 b',
  'CCI-003569': 'TR-1 b',
  'CCI-003570': 'TR-1 b',
  'CCI-003571': 'TR-1 b',
  'CCI-003572': 'TR-1 b',
  'CCI-003573': 'TR-1 b',
  'CCI-003574': 'TR-1 b',
  'CCI-003575': 'TR-1 b',
  'CCI-003576': 'TR-1 b',
  'CCI-003577': 'TR-1 b',
  'CCI-003578': 'TR-1 c',
  'CCI-003579': 'TR-1 c',
  'CCI-003580': 'TR-1 (1)',
  'CCI-003581': 'TR-2 a',
  'CCI-003582': 'TR-2 b',
  'CCI-003583': 'TR-2 c',
  'CCI-003584': 'TR-2 (1)',
  'CCI-003585': 'TR-3 a',
  'CCI-003586': 'TR-3 a',
  'CCI-003587': 'TR-3 b',
  'CCI-003588': 'UL-1',
  'CCI-003589': 'UL-2 a',
  'CCI-003590': 'UL-2 b',
  'CCI-003591': 'UL-2 b',
  'CCI-003592': 'UL-2 c',
  'CCI-003593': 'UL-2 c',
  'CCI-003594': 'UL-2 c',
  'CCI-003595': 'UL-2 c',
  'CCI-003596': 'UL-2 d',
  'CCI-003597': 'UL-2 d',
  'CCI-003599': 'SC-37 (1)',
  'CCI-003601': 'AC-1 a 1 (b)',
  'CCI-003602': 'AC-1 a 1 (a)',
  'CCI-003603': 'AC-1 a 1 (b)',
  'CCI-003604': 'AC-1 a 2',
  'CCI-003605': 'AC-1 b',
  'CCI-003606': 'AC-1 b',
  'CCI-003607': 'AC-1 b',
  'CCI-003608': 'AC-1 c 1',
  'CCI-003609': 'AC-1 c 1',
  'CCI-003610': 'AC-1 c 2',
  'CCI-003611': 'AC-1 c 2',
  'CCI-003612': 'AC-2 a',
  'CCI-003613': 'AC-2 c',
  'CCI-003614': 'AC-2 c',
  'CCI-003615': 'AC-2 c',
  'CCI-003616': 'AC-2 d 3',
  'CCI-003617': 'AC-2 f',
  'CCI-003618': 'AC-2 f',
  'CCI-003619': 'AC-2 f',
  'CCI-003620': 'AC-2 f',
  'CCI-003621': 'AC-2 f',
  'CCI-003622': 'AC-2 f',
  'CCI-003623': 'AC-2 h',
  'CCI-003624': 'AC-2 h',
  'CCI-003625': 'AC-2 i 3',
  'CCI-003626': 'AC-2 l',
  'CCI-003627': 'AC-2 (3) (a)',
  'CCI-003628': 'AC-2 (3) (b)',
  'CCI-003629': 'AC-2 (3) (c)',
  'CCI-003630': 'AC-2 (7) (c)',
  'CCI-003631': 'AC-2 (8)',
  'CCI-003632': 'AC-2 (8)',
  'CCI-003633': 'AC-2 (8)',
  'CCI-003634': 'AC-2 (8)',
  'CCI-003635': 'AC-2 (8)',
  'CCI-003636': 'AC-2 (8)',
  'CCI-003637': 'AC-2 (13)',
  'CCI-003638': 'AC-3 (4) (a)',
  'CCI-003639': 'AC-3 (4) (b)',
  'CCI-003640': 'AC-3 (4) (c)',
  'CCI-003641': 'AC-3 (4) (d)',
  'CCI-003642': 'AC-3 (4) (e)',
  'CCI-003643': 'AC-3 (10)',
  'CCI-003644': 'AC-3 (11)',
  'CCI-003645': 'AC-3 (11)',
  'CCI-003646': 'AC-3 (12) (a)',
  'CCI-003647': 'AC-3 (12) (a)',
  'CCI-003648': 'AC-3 (12) (b)',
  'CCI-003649': 'AC-3 (12) (c)',
  'CCI-003650': 'AC-3 (13)',
  'CCI-003651': 'AC-3 (13)',
  'CCI-003652': 'AC-3 (13)',
  'CCI-003653': 'AC-3 (13)',
  'CCI-003654': 'AC-3 (14)',
  'CCI-003655': 'AC-3 (14)',
  'CCI-003656': 'AC-3 (14)',
  'CCI-003657': 'AC-3 (15) (a)',
  'CCI-003658': 'AC-3 (15) (a)',
  'CCI-003659': 'AC-3 (15) (b)',
  'CCI-003660': 'AC-3 (15) (b)',
  'CCI-003661': 'AC-4 (1)',
  'CCI-003662': 'AC-4 (4)',
  'CCI-003663': 'AC-4 (8) (a)',
  'CCI-003664': 'AC-4 (8) (b)',
  'CCI-003665': 'AC-4 (8) (b)',
  'CCI-003666': 'AC-4 (19)',
  'CCI-003667': 'AC-4 (23)',
  'CCI-003668': 'AC-4 (23)',
  'CCI-003669': 'AC-4 (24)',
  'CCI-003670': 'AC-4 (24)',
  'CCI-003671': 'AC-4 (25)',
  'CCI-003672': 'AC-4 (25)',
  'CCI-003673': 'AC-4 (26)',
  'CCI-003674': 'AC-4 (27)',
  'CCI-003675': 'AC-4 (28)',
  'CCI-003676': 'AC-4 (29) (a)',
  'CCI-003677': 'AC-4 (29) (b)',
  'CCI-003678': 'AC-4 (30)',
  'CCI-003679': 'AC-4 (31)',
  'CCI-003680': 'AC-4 (32) (a)',
  'CCI-003681': 'AC-4 (32) (b)',
  'CCI-003682': 'AC-4 (32) (c)',
  'CCI-003683': 'AC-4 (32) (d)',
  'CCI-003684': 'AC-5 a',
  'CCI-003685': 'AC-6 (1) (a)',
  'CCI-003686': 'AC-6 (1) (b)',
  'CCI-003687': 'AC-7 (3)',
  'CCI-003688': 'AC-7 (3)',
  'CCI-003689': 'AC-7 (4) (a)',
  'CCI-003690': 'AC-7 (4) (a)',
  'CCI-003691': 'AC-7 (4) (b)',
  'CCI-003692': 'AC-7 (4) (b)',
  'CCI-003693': 'AC-12 (3)',
  'CCI-003694': 'AC-12 (3)',
  'CCI-003695': 'AC-14 a',
  'CCI-003696': 'AC-16 a',
  'CCI-003697': 'AC-16 a',
  'CCI-003698': 'AC-16 a',
  'CCI-003699': 'AC-16 a',
  'CCI-003700': 'AC-16 a',
  'CCI-003701': 'AC-16 a',
  'CCI-003702': 'AC-16 b',
  'CCI-003703': 'AC-16 b',
  'CCI-003704': 'AC-16 c',
  'CCI-003705': 'AC-16 c',
  'CCI-003706': 'AC-16 d',
  'CCI-003707': 'AC-16 e',
  'CCI-003708': 'AC-16 f',
  'CCI-003709': 'AC-16 f',
  'CCI-003710': 'AC-16 f',
  'CCI-003711': 'AC-16 f',
  'CCI-003712': 'AC-16 (1)',
  'CCI-003713': 'AC-16 (1)',
  'CCI-003714': 'AC-16 (1)',
  'CCI-003715': 'AC-16 (2)',
  'CCI-003716': 'AC-16 (2)',
  'CCI-003717': 'AC-16 (3)',
  'CCI-003718': 'AC-16 (3)',
  'CCI-003719': 'AC-16 (3)',
  'CCI-003720': 'AC-16 (3)',
  'CCI-003721': 'AC-16 (3)',
  'CCI-003722': 'AC-16 (4)',
  'CCI-003723': 'AC-16 (4)',
  'CCI-003724': 'AC-16 (4)',
  'CCI-003725': 'AC-16 (4)',
  'CCI-003726': 'AC-16 (4)',
  'CCI-003727': 'AC-16 (5)',
  'CCI-003728': 'AC-16 (5)',
  'CCI-003729': 'AC-16 (5)',
  'CCI-003730': 'AC-16 (6)',
  'CCI-003731': 'AC-16 (6)',
  'CCI-003732': 'AC-16 (6)',
  'CCI-003733': 'AC-16 (6)',
  'CCI-003734': 'AC-16 (6)',
  'CCI-003735': 'AC-16 (6)',
  'CCI-003736': 'AC-16 (6)',
  'CCI-003737': 'AC-16 (6)',
  'CCI-003738': 'AC-16 (7)',
  'CCI-003739': 'AC-16 (8)',
  'CCI-003740': 'AC-16 (8)',
  'CCI-003741': 'AC-16 (8)',
  'CCI-003742': 'AC-16 (9)',
  'CCI-003743': 'AC-16 (10)',
  'CCI-003744': 'AC-16 (10)',
  'CCI-003745': 'AC-16 (10)',
  'CCI-003746': 'AC-16 (10)',
  'CCI-003747': 'AC-17 (10)',
  'CCI-003748': 'AC-17 (10)',
  'CCI-003749': 'AC-17 (10)',
  'CCI-003750': 'AC-20 a 1',
  'CCI-003751': 'AC-20 a 1',
  'CCI-003752': 'AC-20 a 2',
  'CCI-003753': 'AC-20 a 2',
  'CCI-003754': 'AC-20 b',
  'CCI-003755': 'AC-20 b',
  'CCI-003756': 'AC-20 (1) (a)',
  'CCI-003757': 'AC-20 (1) (a)',
  'CCI-003758': 'AC-20 (2)',
  'CCI-003759': 'AC-20 (5)',
  'CCI-003760': 'AC-24 (2)',
  'CCI-003761': 'AT-1 a 1 (b)',
  'CCI-003762': 'AT-1 b',
  'CCI-003763': 'AT-1 b',
  'CCI-003764': 'AT-1 b',
  'CCI-003765': 'AT-1 b',
  'CCI-003766': 'AT-2 a 2',
  'CCI-003767': 'AT-2 b',
  'CCI-003768': 'AT-2 b',
  'CCI-003769': 'AT-2 b',
  'CCI-003770': 'AT-2 c',
  'CCI-003771': 'AT-2 c',
  'CCI-003772': 'AT-2 c',
  'CCI-003773': 'AT-2 c',
  'CCI-003774': 'AT-2 d',
  'CCI-003775': 'AT-2 (3)',
  'CCI-003776': 'AT-2 (3)',
  'CCI-003777': 'AT-2 (4)',
  'CCI-003778': 'AT-2 (4)',
  'CCI-003779': 'AT-2 (5)',
  'CCI-003780': 'AT-2 (6) (a)',
  'CCI-003781': 'AT-2 (6) (b)',
  'CCI-003782': 'AT-3 a',
  'CCI-003783': 'AT-3 a 1',
  'CCI-003784': 'AT-3 a 2',
  'CCI-003785': 'AT-3 b',
  'CCI-003786': 'AT-3 b',
  'CCI-003787': 'AT-3 b',
  'CCI-003788': 'AT-3 b',
  'CCI-003789': 'AT-3 c',
  'CCI-003790': 'AT-3 (3)',
  'CCI-003791': 'AT-3 (5)',
  'CCI-003792': 'AT-3 (5)',
  'CCI-003793': 'AT-3 (5)',
  'CCI-003794': 'AT-4 a',
  'CCI-003795': 'AT-4 a',
  'CCI-003796': 'AT-6',
  'CCI-003797': 'AT-6',
  'CCI-003798': 'AT-6',
  'CCI-003799': 'AU-1 a 1 (b)',
  'CCI-003800': 'AU-1 b',
  'CCI-003801': 'AU-1 b',
  'CCI-003802': 'AU-1 b',
  'CCI-003803': 'AU-1 b',
  'CCI-003804': 'AU-1 b',
  'CCI-003805': 'AU-1 b',
  'CCI-003806': 'AU-1 c 1',
  'CCI-003807': 'AU-1 c 1',
  'CCI-003808': 'AU-1 c 2',
  'CCI-003809': 'AU-1 c 2',
  'CCI-003810': 'AU-2 e',
  'CCI-003811': 'AU-2 e',
  'CCI-003812': 'AU-3 (3)',
  'CCI-003813': 'AU-3 (3)',
  'CCI-003814': 'AU-5 a',
  'CCI-003815': 'AU-5 (5)',
  'CCI-003816': 'AU-5 (5)',
  'CCI-003817': 'AU-6 a',
  'CCI-003818': 'AU-6 c',
  'CCI-003819': 'AU-6 c',
  'CCI-003820': 'AU-6 (1)',
  'CCI-003821': 'AU-6 (4)',
  'CCI-003822': 'AU-7 a',
  'CCI-003823': 'AU-7 a',
  'CCI-003824': 'AU-7 a',
  'CCI-003825': 'AU-7 a',
  'CCI-003826': 'AU-7 a',
  'CCI-003827': 'AU-7 a',
  'CCI-003828': 'AU-7 b',
  'CCI-003829': 'AU-7 b',
  'CCI-003830': 'AU-7 (1)',
  'CCI-003831': 'AU-9 b',
  'CCI-003832': 'AU-9 b',
  'CCI-003833': 'AU-9 (7)',
  'CCI-003834': 'AU-12 (3)',
  'CCI-003835': 'AU-12 (4)',
  'CCI-003836': 'AU-12 (4)',
  'CCI-003837': 'AU-13 b 1',
  'CCI-003838': 'AU-13 b 1',
  'CCI-003839': 'AU-13 b 2',
  'CCI-003840': 'AU-13 b 2',
  'CCI-003841': 'AU-13 (1)',
  'CCI-003842': 'AU-13 (1)',
  'CCI-003843': 'AU-13 (3)',
  'CCI-003844': 'AU-14 a',
  'CCI-003845': 'AU-14 a',
  'CCI-003846': 'AU-14 a',
  'CCI-003847': 'AU-14 b',
  'CCI-003848': 'AU-14 (3)',
  'CCI-003849': 'CA-1 a 1 (b)',
  'CCI-003850': 'CA-1 a 2',
  'CCI-003851': 'CA-1 b',
  'CCI-003852': 'CA-1 b',
  'CCI-003853': 'CA-1 b',
  'CCI-003854': 'CA-1 b',
  'CCI-003855': 'CA-1 c 1',
  'CCI-003856': 'CA-1 c 1',
  'CCI-003857': 'CA-1 c 2',
  'CCI-003858': 'CA-1 c 2',
  'CCI-003859': 'CA-2 a',
  'CCI-003860': 'CA-2 c',
  'CCI-003861': 'CA-2 d',
  'CCI-003862': 'CA-3 a',
  'CCI-003863': 'CA-3 b',
  'CCI-003864': 'CA-3 (6)',
  'CCI-003865': 'CA-3 (7) (a)',
  'CCI-003866': 'CA-3 (7) (b)',
  'CCI-003867': 'CA-5 (1)',
  'CCI-003868': 'CA-6 b',
  'CCI-003869': 'CA-6 c 1',
  'CCI-003870': 'CA-6 d',
  'CCI-003871': 'CA-6 (1)',
  'CCI-003872': 'CA-6 (2)',
  'CCI-003873': 'CA-7',
  'CCI-003874': 'CA-7 a',
  'CCI-003875': 'CA-7 b',
  'CCI-003876': 'CA-7 b',
  'CCI-003877': 'CA-7 b',
  'CCI-003878': 'CA-7 c',
  'CCI-003879': 'CA-7 g',
  'CCI-003880': 'CA-7 g',
  'CCI-003881': 'CA-7 (4) (a)',
  'CCI-003882': 'CA-7 (4) (b)',
  'CCI-003883': 'CA-7 (4) (c)',
  'CCI-003884': 'CA-7 (5)',
  'CCI-003885': 'CA-7 (5)',
  'CCI-003886': 'CA-7 (5)',
  'CCI-003887': 'CA-7 (6)',
  'CCI-003888': 'CA-7 (6)',
  'CCI-003889': 'CA-8 (3)',
  'CCI-003890': 'CA-8 (3)',
  'CCI-003891': 'CA-9 (b)',
  'CCI-003892': 'CA-9 (c)',
  'CCI-003893': 'CA-9 (c)',
  'CCI-003894': 'CA-9 (d)',
  'CCI-003895': 'CA-9 (d)',
  'CCI-003896': 'CA-9 (1)',
  'CCI-003897': 'CM-1 a 1 (b)',
  'CCI-003898': 'CM-1 b',
  'CCI-003899': 'CM-1 b',
  'CCI-003900': 'CM-1 b',
  'CCI-003901': 'CM-1 b',
  'CCI-003902': 'CM-1 b',
  'CCI-003903': 'CM-1 b',
  'CCI-003904': 'CM-1 c 1',
  'CCI-003905': 'CM-1 c 1',
  'CCI-003906': 'CM-1 c 2',
  'CCI-003907': 'CM-1 c 2',
  'CCI-003908': 'CM-1 c 2',
  'CCI-003909': 'CM-2 a',
  'CCI-003910': 'CM-2 b 3',
  'CCI-003911': 'CM-2 (2)',
  'CCI-003912': 'CM-3 b',
  'CCI-003913': 'CM-3 (1) (a)',
  'CCI-003914': 'CM-3 (1) (b)',
  'CCI-003915': 'CM-3 (1) (c)',
  'CCI-003916': 'CM-3 (1) (d)',
  'CCI-003917': 'CM-3 (1) (e)',
  'CCI-003918': 'CM-3 (1) (f)',
  'CCI-003919': 'CM-3 (3)',
  'CCI-003920': 'CM-3 (3)',
  'CCI-003921': 'CM-3 (4)',
  'CCI-003922': 'CM-3 (4)',
  'CCI-003923': 'CM-3 (4)',
  'CCI-003924': 'CM-3 (4)',
  'CCI-003925': 'CM-3 (7)',
  'CCI-003926': 'CM-3 (7)',
  'CCI-003927': 'CM-3 (7)',
  'CCI-003928': 'CM-3 (8)',
  'CCI-003929': 'CM-3 (8)',
  'CCI-003930': 'CM-4',
  'CCI-003931': 'CM-4 (1)',
  'CCI-003932': 'CM-4 (2)',
  'CCI-003933': 'CM-4 (2)',
  'CCI-003934': 'CM-4 (2)',
  'CCI-003935': 'CM-5',
  'CCI-003936': 'CM-5',
  'CCI-003937': 'CM-5 (1) (a)',
  'CCI-003938': 'CM-5 (1) (b)',
  'CCI-003939': 'CM-5 (5) (b)',
  'CCI-003940': 'CM-5 (5) (b)',
  'CCI-003941': 'CM-6 a',
  'CCI-003942': 'CM-6 a',
  'CCI-003943': 'CM-6 d',
  'CCI-003944': 'CM-6 d',
  'CCI-003945': 'CM-6 d',
  'CCI-003946': 'CM-6 d',
  'CCI-003947': 'CM-6 (1)',
  'CCI-003948': 'CM-7 a',
  'CCI-003949': 'CM-7 (6)',
  'CCI-003950': 'CM-7 (6)',
  'CCI-003951': 'CM-7 (7) (a)',
  'CCI-003952': 'CM-7 (7) (a)',
  'CCI-003953': 'CM-7 (7) (b)',
  'CCI-003954': 'CM-7 (7) (b)',
  'CCI-003955': 'CM-7 (8) (a)',
  'CCI-003956': 'CM-7 (8) (b)',
  'CCI-003957': 'CM-7 (9) (a)',
  'CCI-003958': 'CM-7 (9) (a)',
  'CCI-003959': 'CM-7 (9) (b)',
  'CCI-003960': 'CM-7 (9) (c)',
  'CCI-003961': 'CM-7 (9) (c)',
  'CCI-003962': 'CM-8 a 1',
  'CCI-003963': 'CM-8 a 2',
  'CCI-003964': 'CM-8 a 3',
  'CCI-003965': 'CM-8 a 4',
  'CCI-003966': 'CM-8 a 4',
  'CCI-003967': 'CM-8 a 5',
  'CCI-003968': 'CM-8 (2)',
  'CCI-003969': 'CM-8 (3) (a)',
  'CCI-003970': 'CM-8 (8)',
  'CCI-003971': 'CM-9 a',
  'CCI-003972': 'CM-9 a',
  'CCI-003973': 'CM-9 b',
  'CCI-003974': 'CM-9 b',
  'CCI-003975': 'CM-9 c',
  'CCI-003976': 'CM-9 c',
  'CCI-003977': 'CM-9 d',
  'CCI-003978': 'CM-9 d',
  'CCI-003979': 'CM-9 d',
  'CCI-003980': 'CM-11 (2)',
  'CCI-003981': 'CM-11 (3)',
  'CCI-003982': 'CM-12 a',
  'CCI-003983': 'CM-12 a',
  'CCI-003984': 'CM-12 a',
  'CCI-003985': 'CM-12 b',
  'CCI-003986': 'CM-12 b',
  'CCI-003987': 'CM-12 c',
  'CCI-003988': 'CM-12 (1)',
  'CCI-003989': 'CM-12 (1)',
  'CCI-003990': 'CM-12 (1)',
  'CCI-003991': 'CM-13',
  'CCI-003992': 'CM-14',
  'CCI-003993': 'CM-14',
  'CCI-003994': 'CP-1 a 1 (b)',
  'CCI-003995': 'CP-1 a 1 (b)',
  'CCI-003996': 'CP-1 b',
  'CCI-003997': 'CP-1 b',
  'CCI-003998': 'CP-1 b',
  'CCI-003999': 'CP-1 b',
  'CCI-004000': 'CP-1 b',
  'CCI-004001': 'CP-1 b',
  'CCI-004002': 'CP-1 c 1',
  'CCI-004003': 'CP-1 c 1',
  'CCI-004004': 'CP-1 c 2',
  'CCI-004005': 'CP-1 c 2',
  'CCI-004006': 'CP-2 a 4',
  'CCI-004007': 'CP-2 a 4',
  'CCI-004008': 'CP-2 a 6',
  'CCI-004009': 'CP-2 g',
  'CCI-004010': 'CP-3 b',
  'CCI-004011': 'CP-3 b',
  'CCI-004012': 'CP-3 b',
  'CCI-004013': 'CP-3 b',
  'CCI-004014': 'CP-4 (3)',
  'CCI-004015': 'CP-4 (5)',
  'CCI-004016': 'CP-4 (5)',
  'CCI-004017': 'CP-4 (5)',
  'CCI-004018': 'CP-6 a',
  'CCI-004019': 'CP-8 (1) (b)',
  'CCI-004020': 'CP-9 (a)',
  'CCI-004021': 'CP-9 (c)',
  'CCI-004022': 'CP-9 (d)',
  'CCI-004023': 'CP-9 (d)',
  'CCI-004024': 'CP-9 (d)',
  'CCI-004025': 'CP-9 (8)',
  'CCI-004026': 'CP-9 (8)',
  'CCI-004027': 'CP-9 (8)',
  'CCI-004028': 'CP-10',
  'CCI-004029': 'CP-10',
  'CCI-004030': 'CP-10 (6)',
  'CCI-004031': 'IA-1 a 1',
  'CCI-004032': 'IA-1 a 1 (a)',
  'CCI-004033': 'IA-1 a 1 (b)',
  'CCI-004034': 'IA-1 a 2',
  'CCI-004035': 'IA-1 b',
  'CCI-004036': 'IA-1 b',
  'CCI-004037': 'IA-1 b',
  'CCI-004038': 'IA-1 b',
  'CCI-004039': 'IA-1 b',
  'CCI-004040': 'IA-1 b',
  'CCI-004041': 'IA-1 c 1',
  'CCI-004042': 'IA-1 c 1',
  'CCI-004043': 'IA-1 c 2',
  'CCI-004044': 'IA-1 c 2',
  'CCI-004045': 'IA-2 (5)',
  'CCI-004046': 'IA-2 (6) (a)',
  'CCI-004047': 'IA-2 (6) (b)',
  'CCI-004048': 'IA-2 (6) (b)',
  'CCI-004049': 'IA-4 (5)',
  'CCI-004050': 'IA-4 (8)',
  'CCI-004051': 'IA-4 (9)',
  'CCI-004052': 'IA-4 (9)',
  'CCI-004053': 'IA-5 d',
  'CCI-004054': 'IA-5 d',
  'CCI-004055': 'IA-5 e',
  'CCI-004056': 'IA-5 f',
  'CCI-004057': 'IA-5 (1) (a)',
  'CCI-004058': 'IA-5 (1) (a)',
  'CCI-004059': 'IA-5 (1) (a)',
  'CCI-004060': 'IA-5 (1) (a)',
  'CCI-004061': 'IA-5 (1) (b)',
  'CCI-004062': 'IA-5 (1) (d)',
  'CCI-004063': 'IA-5 (1) (e)',
  'CCI-004064': 'IA-5 (1) (f)',
  'CCI-004065': 'IA-5 (1) (g)',
  'CCI-004066': 'IA-5 (1) (h)',
  'CCI-004067': 'IA-5 (1) (h)',
  'CCI-004068': 'IA-5 (2) (b) (2)',
  'CCI-004069': 'IA-5 (7)',
  'CCI-004070': 'IA-5 (9)',
  'CCI-004071': 'IA-5 (9)',
  'CCI-004072': 'IA-5 (10)',
  'CCI-004073': 'IA-5 (15)',
  'CCI-004074': 'IA-5 (16)',
  'CCI-004075': 'IA-5 (16)',
  'CCI-004076': 'IA-5 (16)',
  'CCI-004077': 'IA-5 (16)',
  'CCI-004078': 'IA-5 (17)',
  'CCI-004079': 'IA-5 (18) (a)',
  'CCI-004080': 'IA-5 (18) (a)',
  'CCI-004081': 'IA-5 (18) (b)',
  'CCI-004082': 'IA-5 (18) (b)',
  'CCI-004083': 'IA-8 (2) (a)',
  'CCI-004084': 'IA-8 (2) (b)',
  'CCI-004085': 'IA-8 (4)',
  'CCI-004086': 'IA-8 (4)',
  'CCI-004087': 'IA-8 (5)',
  'CCI-004088': 'IA-8 (6)',
  'CCI-004089': 'IA-8 (6)',
  'CCI-004090': 'IA-8 (6)',
  'CCI-004091': 'IA-8 (6)',
  'CCI-004092': 'IA-12 a',
  'CCI-004093': 'IA-12 a',
  'CCI-004094': 'IA-12 b',
  'CCI-004095': 'IA-12 c',
  'CCI-004096': 'IA-12 c',
  'CCI-004097': 'IA-12 c',
  'CCI-004098': 'IA-12 (1)',
  'CCI-004099': 'IA-12 (2)',
  'CCI-004100': 'IA-12 (3)',
  'CCI-004101': 'IA-12 (3)',
  'CCI-004102': 'IA-12 (3)',
  'CCI-004103': 'IA-12 (3)',
  'CCI-004104': 'IA-12 (4)',
  'CCI-004105': 'IA-12 (4)',
  'CCI-004106': 'IA-12 (5)',
  'CCI-004107': 'IA-12 (6)',
  'CCI-004108': 'IA-12 (6)',
  'CCI-004109': 'IR-1 a 1 (b)',
  'CCI-004110': 'IR-1 b',
  'CCI-004111': 'IR-1 b',
  'CCI-004112': 'IR-1 b',
  'CCI-004113': 'IR-1 c 1',
  'CCI-004114': 'IR-1 c 1',
  'CCI-004115': 'IR-1 c 2',
  'CCI-004116': 'IR-1 c 2',
  'CCI-004117': 'IR-2 (2)',
  'CCI-004118': 'IR-2 (3)',
  'CCI-004119': 'IR-3 (1)',
  'CCI-004120': 'IR-3 (3) (a)',
  'CCI-004121': 'IR-3 (3) (a)',
  'CCI-004122': 'IR-3 (3) (b)',
  'CCI-004123': 'IR-3 (3) (b)',
  'CCI-004124': 'IR-3 (3) (c)',
  'CCI-004125': 'IR-3 (3) (c)',
  'CCI-004126': 'IR-3 (3) (c)',
  'CCI-004127': 'IR-3 (3) (c)',
  'CCI-004128': 'IR-3 (3) (c)',
  'CCI-004129': 'IR-3 (3) (c)',
  'CCI-004130': 'IR-4 c',
  'CCI-004131': 'IR-4 c',
  'CCI-004132': 'IR-4 c',
  'CCI-004133': 'IR-4 d',
  'CCI-004134': 'IR-4 d',
  'CCI-004135': 'IR-4 d',
  'CCI-004136': 'IR-4 d',
  'CCI-004137': 'IR-4 (1)',
  'CCI-004138': 'IR-4 (2)',
  'CCI-004139': 'IR-4 (3)',
  'CCI-004140': 'IR-4 (3)',
  'CCI-004141': 'IR-4 (7)',
  'CCI-004142': 'IR-4 (7)',
  'CCI-004143': 'IR-4 (11)',
  'CCI-004144': 'IR-4 (11)',
  'CCI-004145': 'IR-4 (12)',
  'CCI-004146': 'IR-4 (13)',
  'CCI-004147': 'IR-4 (13)',
  'CCI-004148': 'IR-4 (14)',
  'CCI-004149': 'IR-4 (15) (a)',
  'CCI-004150': 'IR-4 (15) (b)',
  'CCI-004151': 'IR-5 (1)',
  'CCI-004152': 'IR-5 (1)',
  'CCI-004153': 'IR-5 (1)',
  'CCI-004154': 'IR-5 (1)',
  'CCI-004155': 'IR-6 (1)',
  'CCI-004156': 'IR-6 (3)',
  'CCI-004157': 'IR-8 a 8',
  'CCI-004158': 'IR-8 a 9',
  'CCI-004159': 'IR-8 a 10',
  'CCI-004160': 'IR-8 (1) (a)',
  'CCI-004161': 'IR-8 (1) (b)',
  'CCI-004162': 'IR-8 (1) (c)',
  'CCI-004163': 'IR-9 a',
  'CCI-004164': 'IR-9 a',
  'CCI-004165': 'MA-1 a 1 (b)',
  'CCI-004166': 'MA-1 b',
  'CCI-004167': 'MA-1 b',
  'CCI-004168': 'MA-1 b',
  'CCI-004169': 'MA-1 b',
  'CCI-004170': 'MA-1 c 1',
  'CCI-004171': 'MA-1 c 1',
  'CCI-004172': 'MA-1 c 2',
  'CCI-004173': 'MA-1 c 2',
  'CCI-004174': 'MA-2 a',
  'CCI-004175': 'MA-2 a',
  'CCI-004176': 'MA-2 a',
  'CCI-004177': 'MA-2 b',
  'CCI-004178': 'MA-2 b',
  'CCI-004179': 'MA-2 b',
  'CCI-004180': 'MA-2 b',
  'CCI-004181': 'MA-2 d',
  'CCI-004182': 'MA-2 (2) (a)',
  'CCI-004183': 'MA-2 (2) (a)',
  'CCI-004184': 'MA-2 (2) (a)',
  'CCI-004185': 'MA-2 (2) (b)',
  'CCI-004186': 'MA-3 b',
  'CCI-004187': 'MA-3 b',
  'CCI-004188': 'MA-3 (5)',
  'CCI-004189': 'MA-3 (6)',
  'CCI-004190': 'MA-4 e',
  'CCI-004191': 'MA-4 e',
  'CCI-004192': 'MA-4 (4) (b) (2)',
  'CCI-004193': 'MA-4 (6)',
  'CCI-004194': 'MA-5 (1) (b)',
  'CCI-004195': 'MA-5 (1) (b)',
  'CCI-004196': 'MA-5 (1) (b)',
  'CCI-004197': 'MA-6 (3)',
  'CCI-004198': 'MA-7',
  'CCI-004199': 'MA-7',
  'CCI-004200': 'MA-7',
  'CCI-004201': 'MP-1 a 1 (b)',
  'CCI-004202': 'MP-1 b',
  'CCI-004203': 'MP-1 b',
  'CCI-004204': 'MP-1 b',
  'CCI-004205': 'MP-1 b',
  'CCI-004206': 'MP-1 b',
  'CCI-004207': 'MP-1 c 1',
  'CCI-004208': 'MP-1 c 1',
  'CCI-004209': 'MP-1 c 2',
  'CCI-004210': 'MP-1 c 2',
  'CCI-004211': 'MP-4 a',
  'CCI-004212': 'MP-4 a',
  'CCI-004213': 'MP-4 b',
  'CCI-004214': 'MP-4 b',
  'CCI-004215': 'MP-4 b',
  'CCI-004216': 'MP-4 (2)',
  'CCI-004217': 'MP-5 a',
  'CCI-004218': 'MP-5 a',
  'CCI-004219': 'MP-6 (2)',
  'CCI-004220': 'MP-6 (2)',
  'CCI-004221': 'MP-8 a',
  'CCI-004222': 'MP-8 a',
  'CCI-004223': 'MP-8 b',
  'CCI-004224': 'MP-8 b',
  'CCI-004225': 'MP-8 c',
  'CCI-004226': 'MP-8 c',
  'CCI-004227': 'MP-8 (2)',
  'CCI-004228': 'MP-8 (2)',
  'CCI-004229': 'PE-1 a 1 (b)',
  'CCI-004230': 'PE-1 b',
  'CCI-004231': 'PE-1 b',
  'CCI-004232': 'PE-1 b',
  'CCI-004233': 'PE-1 b',
  'CCI-004234': 'PE-1 b',
  'CCI-004235': 'PE-1 b',
  'CCI-004236': 'PE-1 c 1',
  'CCI-004237': 'PE-1 c 1',
  'CCI-004238': 'PE-1 c 2',
  'CCI-004239': 'PE-1 c 2',
  'CCI-004240': 'PE-3 a',
  'CCI-004241': 'PE-3 a',
  'CCI-004242': 'PE-3 a 2',
  'CCI-004243': 'PE-3 a 2',
  'CCI-004244': 'PE-3 (7)',
  'CCI-004245': 'PE-3 (8)',
  'CCI-004246': 'PE-3 (8)',
  'CCI-004247': 'PE-5 (2)',
  'CCI-004248': 'PE-6 (2)',
  'CCI-004249': 'PE-6 (3) (b)',
  'CCI-004250': 'PE-6 (3) (b)',
  'CCI-004251': 'PE-8 c',
  'CCI-004252': 'PE-8 c',
  'CCI-004253': 'PE-8 (1)',
  'CCI-004254': 'PE-8 (3)',
  'CCI-004255': 'PE-8 (3)',
  'CCI-004256': 'PE-10 a',
  'CCI-004257': 'PE-14 (1)',
  'CCI-004258': 'PE-14 (2)',
  'CCI-004259': 'PE-15 (1)',
  'CCI-004260': 'PE-15 (1)',
  'CCI-004261': 'PE-15 (1)',
  'CCI-004262': 'PE-17 a',
  'CCI-004263': 'PE-17 d',
  'CCI-004264': 'PE-19 (1)',
  'CCI-004265': 'PE-19 (1)',
  'CCI-004266': 'PE-21',
  'CCI-004267': 'PE-21',
  'CCI-004268': 'PE-21',
  'CCI-004269': 'PE-22',
  'CCI-004270': 'PE-22',
  'CCI-004271': 'PE-23 a',
  'CCI-004272': 'PE-23 b',
  'CCI-004273': 'PL-1 a 1 (b)',
  'CCI-004274': 'PL-1 b',
  'CCI-004275': 'PL-1 b',
  'CCI-004276': 'PL-1 c 1',
  'CCI-004277': 'PL-1 c 2',
  'CCI-004278': 'PL-2 a 4',
  'CCI-004279': 'PL-2 a 5',
  'CCI-004280': 'PL-2 a 7',
  'CCI-004281': 'PL-2 a 8',
  'CCI-004282': 'PL-2 a 13',
  'CCI-004283': 'PL-2 a 14',
  'CCI-004284': 'PL-4 a',
  'CCI-004285': 'PL-4 a',
  'CCI-004286': 'PL-4 a',
  'CCI-004287': 'PL-4 a',
  'CCI-004288': 'PL-4 a',
  'CCI-004289': 'PL-4 d',
  'CCI-004290': 'PL-4 (1) (c)',
  'CCI-004291': 'PL-7 a',
  'CCI-004292': 'PL-8 a',
  'CCI-004293': 'PL-8 a 1',
  'CCI-004294': 'PL-8 a 2',
  'CCI-004295': 'PL-8 a 2',
  'CCI-004296': 'PL-8 a 3',
  'CCI-004297': 'PL-8 a 4',
  'CCI-004298': 'PL-8 c',
  'CCI-004299': 'PL-8 c',
  'CCI-004300': 'PL-8 c',
  'CCI-004301': 'PL-8 (1) (a)',
  'CCI-004302': 'PL-8 (1) (a)',
  'CCI-004303': 'PL-8 (1) (a)',
  'CCI-004304': 'PL-8 (1) (a)',
  'CCI-004305': 'PL-8 (1) (a)',
  'CCI-004306': 'PL-8 (1) (a)',
  'CCI-004307': 'PL-8 (1) (b)',
  'CCI-004308': 'PL-8 (2)',
  'CCI-004309': 'PL-8 (2)',
  'CCI-004310': 'PL-10',
  'CCI-004311': 'PL-11',
  'CCI-004312': 'PM-1 b',
  'CCI-004313': 'PM-1 b',
  'CCI-004314': 'PM-3 a',
  'CCI-004315': 'PM-3 a',
  'CCI-004316': 'PM-3 b',
  'CCI-004317': 'PM-3 b',
  'CCI-004318': 'PM-3 c',
  'CCI-004319': 'PM-4 a 1',
  'CCI-004320': 'PM-4 a 1',
  'CCI-004321': 'PM-4 a 1',
  'CCI-004322': 'PM-4 a 1',
  'CCI-004323': 'PM-4 a 2',
  'CCI-004324': 'PM-4 a 2',
  'CCI-004325': 'PM-4 a 3',
  'CCI-004326': 'PM-4 a 3',
  'CCI-004327': 'PM-4 a 3',
  'CCI-004328': 'PM-5',
  'CCI-004329': 'PM-5',
  'CCI-004330': 'PM-5',
  'CCI-004331': 'PM-5 (1)',
  'CCI-004332': 'PM-5 (1)',
  'CCI-004333': 'PM-5 (1)',
  'CCI-004334': 'PM-5 (1)',
  'CCI-004335': 'PM-6',
  'CCI-004336': 'PM-6',
  'CCI-004337': 'PM-6',
  'CCI-004338': 'PM-7',
  'CCI-004339': 'PM-7',
  'CCI-004340': 'PM-7',
  'CCI-004341': 'PM-7 (1)',
  'CCI-004342': 'PM-7 (1)',
  'CCI-004343': 'PM-8',
  'CCI-004344': 'PM-8',
  'CCI-004345': 'PM-9 a 2',
  'CCI-004346': 'PM-10 a',
  'CCI-004347': 'PM-10 a',
  'CCI-004348': 'PM-11 a',
  'CCI-004349': 'PM-11 b',
  'CCI-004350': 'PM-11 c',
  'CCI-004351': 'PM-11 c',
  'CCI-004352': 'PM-13',
  'CCI-004353': 'PM-14 a 1',
  'CCI-004354': 'PM-14 a 1',
  'CCI-004355': 'PM-14 a 1',
  'CCI-004356': 'PM-14 a 1',
  'CCI-004357': 'PM-14 a 1',
  'CCI-004358': 'PM-14 a 1',
  'CCI-004359': 'PM-14 a 2',
  'CCI-004360': 'PM-14 a 2',
  'CCI-004361': 'PM-14 a 2',
  'CCI-004362': 'PM-15 a',
  'CCI-004363': 'PM-15 b',
  'CCI-004364': 'PM-15 c',
  'CCI-004365': 'PM-16 (1)',
  'CCI-004366': 'PM-17 a',
  'CCI-004367': 'PM-17 a',
  'CCI-004368': 'PM-17 b',
  'CCI-004369': 'PM-17 b',
  'CCI-004370': 'PM-17 b',
  'CCI-004371': 'PM-17 b',
  'CCI-004372': 'PM-18 a',
  'CCI-004373': 'PM-18 a',
  'CCI-004374': 'PM-18 a 1',
  'CCI-004375': 'PM-18 a 1',
  'CCI-004376': 'PM-18 a 2',
  'CCI-004377': 'PM-18 a 2',
  'CCI-004378': 'PM-18 a 2',
  'CCI-004379': 'PM-18 a 2',
  'CCI-004380': 'PM-18 a 3',
  'CCI-004381': 'PM-18 a 3',
  'CCI-004382': 'PM-18 a 4',
  'CCI-004383': 'PM-18 a 4',
  'CCI-004384': 'PM-18 a 5',
  'CCI-004385': 'PM-18 a 5',
  'CCI-004386': 'PM-18 a 6',
  'CCI-004387': 'PM-18 a 6',
  'CCI-004388': 'PM-18 a 6',
  'CCI-004389': 'PM-18 b',
  'CCI-004390': 'PM-19',
  'CCI-004391': 'PM-19',
  'CCI-004392': 'PM-19',
  'CCI-004393': 'PM-19',
  'CCI-004394': 'PM-20',
  'CCI-004395': 'PM-20 a',
  'CCI-004396': 'PM-20 a',
  'CCI-004397': 'PM-20 b',
  'CCI-004398': 'PM-20 c',
  'CCI-004399': 'PM-20 (1) (a)',
  'CCI-004400': 'PM-20 (1) (a)',
  'CCI-004401': 'PM-20 (1) (b)',
  'CCI-004402': 'PM-20 (1) (c)',
  'CCI-004403': 'PM-20 (1) (c)',
  'CCI-004404': 'PM-21 a',
  'CCI-004405': 'PM-21 a',
  'CCI-004406': 'PM-21 a 1',
  'CCI-004407': 'PM-21 a 1',
  'CCI-004408': 'PM-21 a 2',
  'CCI-004409': 'PM-21 a 2',
  'CCI-004410': 'PM-21 b',
  'CCI-004411': 'PM-21 c',
  'CCI-004412': 'PM-22 a',
  'CCI-004413': 'PM-22 a',
  'CCI-004414': 'PM-22 b',
  'CCI-004415': 'PM-22 b',
  'CCI-004416': 'PM-22 c',
  'CCI-004417': 'PM-22 c',
  'CCI-004418': 'PM-22 d',
  'CCI-004419': 'PM-22 d',
  'CCI-004420': 'PM-23',
  'CCI-004421': 'PM-23',
  'CCI-004422': 'PM-23',
  'CCI-004423': 'PM-24 a',
  'CCI-004424': 'PM-24 b',
  'CCI-004425': 'PM-25 a',
  'CCI-004426': 'PM-25 a',
  'CCI-004427': 'PM-25 a',
  'CCI-004428': 'PM-25 a',
  'CCI-004429': 'PM-25 b',
  'CCI-004430': 'PM-25 c',
  'CCI-004431': 'PM-25 d',
  'CCI-004432': 'PM-25 d',
  'CCI-004433': 'PM-25 d',
  'CCI-004434': 'PM-25 d',
  'CCI-004435': 'PM-26',
  'CCI-004436': 'PM-26',
  'CCI-004437': 'PM-26 a',
  'CCI-004438': 'PM-26 a',
  'CCI-004439': 'PM-26 b',
  'CCI-004440': 'PM-26 c',
  'CCI-004441': 'PM-26 c',
  'CCI-004442': 'PM-26 d',
  'CCI-004443': 'PM-26 d',
  'CCI-004444': 'PM-26 e',
  'CCI-004445': 'PM-26 e',
  'CCI-004446': 'PM-27',
  'CCI-004447': 'PM-27',
  'CCI-004448': 'PM-27 a 1',
  'CCI-004449': 'PM-27 a 2',
  'CCI-004450': 'PM-27 a 2',
  'CCI-004451': 'PM-27 a 2',
  'CCI-004452': 'PM-27 b',
  'CCI-004453': 'PM-27 b',
  'CCI-004454': 'PM-28 a 1',
  'CCI-004455': 'PM-28 a 2',
  'CCI-004456': 'PM-28 a 3',
  'CCI-004457': 'PM-28 a 4',
  'CCI-004458': 'PM-28 b',
  'CCI-004459': 'PM-28 b',
  'CCI-004460': 'PM-28 c',
  'CCI-004461': 'PM-28 c',
  'CCI-004462': 'PM-29 a',
  'CCI-004463': 'PM-29 a',
  'CCI-004464': 'PM-29 b',
  'CCI-004465': 'PM-29 b',
  'CCI-004466': 'PM-30 a',
  'CCI-004467': 'PM-30 a',
  'CCI-004468': 'PM-30 a',
  'CCI-004469': 'PM-30 a',
  'CCI-004470': 'PM-30 b',
  'CCI-004471': 'PM-30 c',
  'CCI-004472': 'PM-30 c',
  'CCI-004473': 'PM-31 a',
  'CCI-004474': 'PM-31 a',
  'CCI-004475': 'PM-31 a',
  'CCI-004476': 'PM-31 b',
  'CCI-004477': 'PM-31 b',
  'CCI-004478': 'PM-31 b',
  'CCI-004479': 'PM-31 b',
  'CCI-004480': 'PM-31 b',
  'CCI-004481': 'PM-31 b',
  'CCI-004482': 'PM-31 c',
  'CCI-004483': 'PM-31 c',
  'CCI-004484': 'PM-31 d',
  'CCI-004485': 'PM-31 d',
  'CCI-004486': 'PM-31 e',
  'CCI-004487': 'PM-31 e',
  'CCI-004488': 'PM-31 f',
  'CCI-004489': 'PM-31 f',
  'CCI-004490': 'PM-31 f',
  'CCI-004491': 'PM-31 f',
  'CCI-004492': 'PM-31 f',
  'CCI-004493': 'PM-31 f',
  'CCI-004494': 'PM-31 f',
  'CCI-004495': 'PM-31 f',
  'CCI-004496': 'PM-32',
  'CCI-004497': 'PM-32',
  'CCI-004498': 'PS-1 a 1 (b)',
  'CCI-004499': 'PS-1 b',
  'CCI-004500': 'PS-1 b',
  'CCI-004501': 'PS-1 b',
  'CCI-004502': 'PS-1 b',
  'CCI-004503': 'PS-1 b',
  'CCI-004504': 'PS-1 b',
  'CCI-004505': 'PS-1 c 1',
  'CCI-004506': 'PS-1 c 1',
  'CCI-004507': 'PS-1 c 2',
  'CCI-004508': 'PS-1 c 2',
  'CCI-004509': 'PS-3 (4)',
  'CCI-004510': 'PS-3 (4)',
  'CCI-004511': 'PS-3 (4)',
  'CCI-004512': 'PS-4 (2)',
  'CCI-004513': 'PS-6 c 1',
  'CCI-004514': 'PS-6 c 1',
  'CCI-004515': 'PS-6 c 2',
  'CCI-004516': 'PS-6 c 2',
  'CCI-004517': 'PS-6 c 2',
  'CCI-004518': 'PS-6 c 2',
  'CCI-004519': 'PS-7 b',
  'CCI-004520': 'PS-7 b',
  'CCI-004521': 'PS-8 a',
  'CCI-004522': 'PS-8 a',
  'CCI-004523': 'PS-9',
  'CCI-004524': 'PS-9',
  'CCI-004525': 'PT-1 a 1 (a)',
  'CCI-004526': 'PT-1 a',
  'CCI-004527': 'PT-1 a',
  'CCI-004528': 'PT-1 a 1 (b)',
  'CCI-004529': 'PT-1 a 2',
  'CCI-004530': 'PT-1 b',
  'CCI-004531': 'PT-1 b',
  'CCI-004532': 'PT-1 b',
  'CCI-004533': 'PT-1 c 1',
  'CCI-004534': 'PT-1 c 1',
  'CCI-004535': 'PT-1 c 1',
  'CCI-004536': 'PT-1 c 2',
  'CCI-004537': 'PT-1 c 2',
  'CCI-004538': 'PT-1 c 2',
  'CCI-004539': 'PT-2 a',
  'CCI-004540': 'PT-2 a',
  'CCI-004541': 'PT-2 a',
  'CCI-004542': 'PT-2 b',
  'CCI-004543': 'PT-2 b',
  'CCI-004544': 'PT-2 (1)',
  'CCI-004545': 'PT-2 (1)',
  'CCI-004546': 'PT-2 (1)',
  'CCI-004547': 'PT-2 (2)',
  'CCI-004548': 'PT-2 (2)',
  'CCI-004549': 'PT-3 a',
  'CCI-004550': 'PT-3 a',
  'CCI-004551': 'PT-3 b',
  'CCI-004552': 'PT-3 c',
  'CCI-004553': 'PT-3 c',
  'CCI-004554': 'PT-3 d',
  'CCI-004555': 'PT-3 d',
  'CCI-004556': 'PT-3 d',
  'CCI-004557': 'PT-3 d',
  'CCI-004558': 'PT-3 (1)',
  'CCI-004559': 'PT-3 (1)',
  'CCI-004560': 'PT-3 (2)',
  'CCI-004561': 'PT-4',
  'CCI-004562': 'PT-4',
  'CCI-004563': 'PT-4 (1)',
  'CCI-004564': 'PT-4 (1)',
  'CCI-004565': 'PT-4 (2)',
  'CCI-004566': 'PT-4 (2)',
  'CCI-004567': 'PT-4 (2)',
  'CCI-004568': 'PT-4 (2)',
  'CCI-004569': 'PT-4 (3)',
  'CCI-004570': 'PT-4 (3)',
  'CCI-004571': 'PT-5 a',
  'CCI-004572': 'PT-5 a',
  'CCI-004573': 'PT-5 b',
  'CCI-004574': 'PT-5 c',
  'CCI-004575': 'PT-5 d',
  'CCI-004576': 'PT-5 e',
  'CCI-004577': 'PT-5 e',
  'CCI-004578': 'PT-5 (1)',
  'CCI-004579': 'PT-5 (1)',
  'CCI-004580': 'PT-5 (2)',
  'CCI-004581': 'PT-6 a',
  'CCI-004582': 'PT-6 a',
  'CCI-004583': 'PT-6 b',
  'CCI-004584': 'PT-6 c',
  'CCI-004585': 'PT-6 (1)',
  'CCI-004586': 'PT-6 (1)',
  'CCI-004587': 'PT-6 (1)',
  'CCI-004588': 'PT-6 (2)',
  'CCI-004589': 'PT-6 (2)',
  'CCI-004590': 'PT-6 (2)',
  'CCI-004591': 'PT-6 (2)',
  'CCI-004592': 'PT-7',
  'CCI-004593': 'PT-7',
  'CCI-004594': 'PT-7 (1) (a)',
  'CCI-004595': 'PT-7 (1) (b)',
  'CCI-004596': 'PT-7 (1) (c)',
  'CCI-004597': 'PT-7 (2)',
  'CCI-004598': 'PT-8 a',
  'CCI-004599': 'PT-8 b',
  'CCI-004600': 'PT-8 c',
  'CCI-004601': 'PT-8 d',
  'CCI-004602': 'PT-8 e',
  'CCI-004603': 'RA-1 a 1 (b)',
  'CCI-004604': 'RA-1 a 1 (b)',
  'CCI-004605': 'RA-1 b',
  'CCI-004606': 'RA-1 b',
  'CCI-004607': 'RA-1 b',
  'CCI-004608': 'RA-1 b',
  'CCI-004609': 'RA-1 b',
  'CCI-004610': 'RA-1 c 1',
  'CCI-004611': 'RA-1 c 1',
  'CCI-004612': 'RA-1 c 2',
  'CCI-004613': 'RA-1 c 2',
  'CCI-004614': 'RA-2 a',
  'CCI-004615': 'RA-2 a',
  'CCI-004616': 'RA-2 a',
  'CCI-004617': 'RA-2 (1)',
  'CCI-004618': 'RA-3 a 1',
  'CCI-004619': 'RA-3 a 1',
  'CCI-004620': 'RA-3 a 3',
  'CCI-004621': 'RA-3 b',
  'CCI-004622': 'RA-3 b',
  'CCI-004623': 'RA-3 b',
  'CCI-004624': 'RA-3 (1) (a)',
  'CCI-004625': 'RA-3 (1) (a)',
  'CCI-004626': 'RA-3 (1) (b)',
  'CCI-004627': 'RA-3 (1) (b)',
  'CCI-004628': 'RA-3 (2)',
  'CCI-004629': 'RA-3 (3)',
  'CCI-004630': 'RA-3 (3)',
  'CCI-004631': 'RA-3 (4)',
  'CCI-004632': 'RA-3 (4)',
  'CCI-004633': 'RA-3 (4)',
  'CCI-004634': 'RA-5 b 2',
  'CCI-004635': 'RA-5 b 3',
  'CCI-004636': 'RA-5 f',
  'CCI-004637': 'RA-5 (6)',
  'CCI-004638': 'RA-5 (8)',
  'CCI-004639': 'RA-5 (8)',
  'CCI-004640': 'RA-5 (11)',
  'CCI-004641': 'RA-7',
  'CCI-004642': 'RA-7',
  'CCI-004643': 'RA-7',
  'CCI-004644': 'RA-7',
  'CCI-004645': 'RA-8 a',
  'CCI-004646': 'RA-8 b 1',
  'CCI-004647': 'RA-8 b 2',
  'CCI-004648': 'RA-9',
  'CCI-004649': 'RA-9',
  'CCI-004650': 'RA-9',
  'CCI-004651': 'RA-10 a 1',
  'CCI-004652': 'RA-10 a 2',
  'CCI-004653': 'RA-10 b',
  'CCI-004654': 'RA-10 b',
  'CCI-004655': 'SA-1 a 1 (b)',
  'CCI-004656': 'SA-1 b',
  'CCI-004657': 'SA-1 b',
  'CCI-004658': 'SA-1 b',
  'CCI-004659': 'SA-1 b',
  'CCI-004660': 'SA-1 b',
  'CCI-004661': 'SA-1 b',
  'CCI-004662': 'SA-1 c 1',
  'CCI-004663': 'SA-1 c 1',
  'CCI-004664': 'SA-1 c 2',
  'CCI-004665': 'SA-1 c 2',
  'CCI-004666': 'SA-2 a',
  'CCI-004667': 'SA-2 c',
  'CCI-004668': 'SA-2 c',
  'CCI-004669': 'SA-3 a',
  'CCI-004670': 'SA-3 a',
  'CCI-004671': 'SA-3 a',
  'CCI-004672': 'SA-3 a',
  'CCI-004673': 'SA-3 a',
  'CCI-004674': 'SA-3 a',
  'CCI-004675': 'SA-3 a',
  'CCI-004676': 'SA-3 b',
  'CCI-004677': 'SA-3 c',
  'CCI-004678': 'SA-3 d',
  'CCI-004679': 'SA-3 (1)',
  'CCI-004680': 'SA-3 (2) (a)',
  'CCI-004681': 'SA-3 (2) (a)',
  'CCI-004682': 'SA-3 (2) (a)',
  'CCI-004683': 'SA-3 (2) (b)',
  'CCI-004684': 'SA-3 (3)',
  'CCI-004685': 'SA-3 (3)',
  'CCI-004686': 'SA-4',
  'CCI-004687': 'SA-4 a',
  'CCI-004688': 'SA-4 c',
  'CCI-004689': 'SA-4 d',
  'CCI-004690': 'SA-4 d',
  'CCI-004691': 'SA-4 e',
  'CCI-004692': 'SA-4 f',
  'CCI-004693': 'SA-4 f',
  'CCI-004694': 'SA-4 h',
  'CCI-004695': 'SA-4 h',
  'CCI-004696': 'SA-4 h',
  'CCI-004697': 'SA-4 (3) (a)',
  'CCI-004698': 'SA-4 (3) (a)',
  'CCI-004699': 'SA-4 (3) (b)',
  'CCI-004700': 'SA-4 (3) (b)',
  'CCI-004701': 'SA-4 (3) (c)',
  'CCI-004702': 'SA-4 (3) (c)',
  'CCI-004703': 'SA-4 (11)',
  'CCI-004704': 'SA-4 (11)',
  'CCI-004705': 'SA-4 (12) (a)',
  'CCI-004706': 'SA-4 (12) (b)',
  'CCI-004707': 'SA-4 (12) (b)',
  'CCI-004708': 'SA-5 a 2',
  'CCI-004709': 'SA-5 b 1',
  'CCI-004710': 'SA-5 b 2',
  'CCI-004711': 'SA-5 b 3',
  'CCI-004712': 'SA-8',
  'CCI-004713': 'SA-8',
  'CCI-004714': 'SA-8',
  'CCI-004715': 'SA-8',
  'CCI-004716': 'SA-8',
  'CCI-004717': 'SA-8 (1)',
  'CCI-004718': 'SA-8 (2)',
  'CCI-004719': 'SA-8 (2)',
  'CCI-004720': 'SA-8 (3)',
  'CCI-004721': 'SA-8 (3)',
  'CCI-004722': 'SA-8 (4)',
  'CCI-004723': 'SA-8 (4)',
  'CCI-004724': 'SA-8 (5)',
  'CCI-004725': 'SA-8 (5)',
  'CCI-004726': 'SA-8 (6)',
  'CCI-004727': 'SA-8 (6)',
  'CCI-004728': 'SA-8 (7)',
  'CCI-004729': 'SA-8 (7)',
  'CCI-004730': 'SA-8 (8)',
  'CCI-004731': 'SA-8 (8)',
  'CCI-004732': 'SA-8 (9)',
  'CCI-004733': 'SA-8 (9)',
  'CCI-004734': 'SA-8 (10)',
  'CCI-004735': 'SA-8 (10)',
  'CCI-004736': 'SA-8 (11)',
  'CCI-004737': 'SA-8 (11)',
  'CCI-004738': 'SA-8 (12)',
  'CCI-004739': 'SA-8 (12)',
  'CCI-004740': 'SA-8 (13)',
  'CCI-004741': 'SA-8 (13)',
  'CCI-004742': 'SA-8 (14)',
  'CCI-004743': 'SA-8 (14)',
  'CCI-004744': 'SA-8 (15)',
  'CCI-004745': 'SA-8 (15)',
  'CCI-004746': 'SA-8 (16)',
  'CCI-004747': 'SA-8 (16)',
  'CCI-004748': 'SA-8 (17)',
  'CCI-004749': 'SA-8 (17)',
  'CCI-004750': 'SA-8 (18)',
  'CCI-004751': 'SA-8 (18)',
  'CCI-004752': 'SA-8 (19)',
  'CCI-004753': 'SA-8 (19)',
  'CCI-004754': 'SA-8 (20)',
  'CCI-004755': 'SA-8 (20)',
  'CCI-004756': 'SA-8 (21)',
  'CCI-004757': 'SA-8 (21)',
  'CCI-004758': 'SA-8 (22)',
  'CCI-004759': 'SA-8 (22)',
  'CCI-004760': 'SA-8 (23)',
  'CCI-004761': 'SA-8 (23)',
  'CCI-004762': 'SA-8 (24)',
  'CCI-004763': 'SA-8 (24)',
  'CCI-004764': 'SA-8 (25)',
  'CCI-004765': 'SA-8 (25)',
  'CCI-004766': 'SA-8 (26)',
  'CCI-004767': 'SA-8 (26)',
  'CCI-004768': 'SA-8 (27)',
  'CCI-004769': 'SA-8 (27)',
  'CCI-004770': 'SA-8 (28)',
  'CCI-004771': 'SA-8 (28)',
  'CCI-004772': 'SA-8 (29)',
  'CCI-004773': 'SA-8 (29)',
  'CCI-004774': 'SA-8 (30)',
  'CCI-004775': 'SA-8 (30)',
  'CCI-004776': 'SA-8 (31)',
  'CCI-004777': 'SA-8 (31)',
  'CCI-004778': 'SA-8 (32)',
  'CCI-004779': 'SA-8 (32)',
  'CCI-004780': 'SA-8 (33)',
  'CCI-004781': 'SA-8 (33)',
  'CCI-004782': 'SA-9 a',
  'CCI-004783': 'SA-9 a',
  'CCI-004784': 'SA-9 a',
  'CCI-004785': 'SA-9 b',
  'CCI-004786': 'SA-9 b',
  'CCI-004787': 'SA-9 (3)',
  'CCI-004788': 'SA-9 (3)',
  'CCI-004789': 'SA-9 (3)',
  'CCI-004790': 'SA-9 (3)',
  'CCI-004791': 'SA-9 (6)',
  'CCI-004792': 'SA-9 (7)',
  'CCI-004793': 'SA-9 (8)',
  'CCI-004794': 'SA-10 d',
  'CCI-004795': 'SA-10 (7)',
  'CCI-004796': 'SA-10 (7)',
  'CCI-004797': 'SA-10 (7)',
  'CCI-004798': 'SA-11 a',
  'CCI-004799': 'SA-11 a',
  'CCI-004800': 'SA-11 b',
  'CCI-004801': 'SA-11 (2) (a)',
  'CCI-004802': 'SA-11 (2) (a)',
  'CCI-004803': 'SA-11 (2) (b)',
  'CCI-004804': 'SA-11 (2) (b)',
  'CCI-004805': 'SA-11 (2) (c)',
  'CCI-004806': 'SA-11 (2) (c)',
  'CCI-004807': 'SA-11 (2) (d)',
  'CCI-004808': 'SA-11 (2) (d)',
  'CCI-004809': 'SA-11 (3) (a)',
  'CCI-004810': 'SA-11 (3) (a)',
  'CCI-004811': 'SA-11 (3) (a)',
  'CCI-004812': 'SA-11 (5) (a)',
  'CCI-004813': 'SA-11 (5) (b)',
  'CCI-004814': 'SA-11 (9)',
  'CCI-004815': 'SA-11 (9)',
  'CCI-004816': 'SA-15 a 1',
  'CCI-004817': 'SA-15 b',
  'CCI-004818': 'SA-15 b',
  'CCI-004819': 'SA-15 b',
  'CCI-004820': 'SA-15 b',
  'CCI-004821': 'SA-15 b',
  'CCI-004822': 'SA-15 b',
  'CCI-004823': 'SA-15 (2)',
  'CCI-004824': 'SA-15 (2)',
  'CCI-004825': 'SA-15 (3) (a)',
  'CCI-004826': 'SA-15 (3) (b)',
  'CCI-004827': 'SA-15 (7) (a)',
  'CCI-004828': 'SA-15 (7) (b)',
  'CCI-004829': 'SA-15 (7) (c)',
  'CCI-004830': 'SA-15 (7) (d)',
  'CCI-004831': 'SA-15 (10)',
  'CCI-004832': 'SA-15 (10)',
  'CCI-004833': 'SA-15 (11)',
  'CCI-004834': 'SA-15 (12)',
  'CCI-004835': 'SA-16',
  'CCI-004836': 'SA-16',
  'CCI-004837': 'SA-17',
  'CCI-004838': 'SA-17 a',
  'CCI-004839': 'SA-17 b',
  'CCI-004840': 'SA-17 b',
  'CCI-004841': 'SA-17 c',
  'CCI-004842': 'SA-17 (1) (a)',
  'CCI-004843': 'SA-17 (1) (a)',
  'CCI-004844': 'SA-17 (1) (b)',
  'CCI-004845': 'SA-17 (8)',
  'CCI-004846': 'SA-17 (8)',
  'CCI-004847': 'SA-17 (8)',
  'CCI-004848': 'SA-17 (9)',
  'CCI-004849': 'SA-17 (9)',
  'CCI-004850': 'SA-23',
  'CCI-004851': 'SA-23',
  'CCI-004852': 'SC-1 a 1 (a)',
  'CCI-004853': 'SC-1 a 1 (b)',
  'CCI-004854': 'SC-1 a 2',
  'CCI-004855': 'SC-1 b',
  'CCI-004856': 'SC-1 b',
  'CCI-004857': 'SC-1 b',
  'CCI-004858': 'SC-1 b',
  'CCI-004859': 'SC-1 b',
  'CCI-004860': 'SC-1 b',
  'CCI-004861': 'SC-1 c 1',
  'CCI-004862': 'SC-1 c 1',
  'CCI-004863': 'SC-1 c 2',
  'CCI-004864': 'SC-1 c 2',
  'CCI-004865': 'SC-2 (2)',
  'CCI-004866': 'SC-5 b',
  'CCI-004867': 'SC-5 b',
  'CCI-004868': 'SC-7 c',
  'CCI-004869': 'SC-7 (4) (f)',
  'CCI-004870': 'SC-7 (4) (g)',
  'CCI-004871': 'SC-7 (4) (h)',
  'CCI-004872': 'SC-7 (5)',
  'CCI-004873': 'SC-7 (7)',
  'CCI-004874': 'SC-7 (10) (b)',
  'CCI-004875': 'SC-7 (10) (b)',
  'CCI-004876': 'SC-7 (24) (a)',
  'CCI-004877': 'SC-7 (24) (a)',
  'CCI-004878': 'SC-7 (24) (b)',
  'CCI-004879': 'SC-7 (24) (c)',
  'CCI-004880': 'SC-7 (24) (d)',
  'CCI-004881': 'SC-7 (25)',
  'CCI-004882': 'SC-7 (25)',
  'CCI-004883': 'SC-7 (25)',
  'CCI-004884': 'SC-7 (26)',
  'CCI-004885': 'SC-7 (26)',
  'CCI-004886': 'SC-7 (27)',
  'CCI-004887': 'SC-7 (27)',
  'CCI-004888': 'SC-7 (27)',
  'CCI-004889': 'SC-7 (28)',
  'CCI-004890': 'SC-7 (28)',
  'CCI-004891': 'SC-7 (29)',
  'CCI-004892': 'SC-7 (29)',
  'CCI-004893': 'SC-8 (5)',
  'CCI-004894': 'SC-8 (5)',
  'CCI-004895': 'SC-11 b',
  'CCI-004896': 'SC-11 (1) (b)',
  'CCI-004897': 'SC-11 (1) (b)',
  'CCI-004898': 'SC-12 (3)',
  'CCI-004899': 'SC-12 (6)',
  'CCI-004900': 'SC-13 a',
  'CCI-004901': 'SC-16',
  'CCI-004902': 'SC-16',
  'CCI-004903': 'SC-16',
  'CCI-004904': 'SC-16 (1)',
  'CCI-004905': 'SC-16 (2)',
  'CCI-004906': 'SC-16 (3)',
  'CCI-004907': 'SC-16 (3)',
  'CCI-004908': 'SC-16 (3)',
  'CCI-004909': 'SC-17 b',
  'CCI-004910': 'SC-28 (3)',
  'CCI-004911': 'SC-28 (3)',
  'CCI-004912': 'SC-32 (1)',
  'CCI-004913': 'SC-36 (1) (b)',
  'CCI-004914': 'SC-36 (1) (b)',
  'CCI-004915': 'SC-36 (2)',
  'CCI-004916': 'SC-36 (2)',
  'CCI-004917': 'SC-42 (4)',
  'CCI-004918': 'SC-42 (4)',
  'CCI-004919': 'SC-42 (4)',
  'CCI-004920': 'SC-42 (5)',
  'CCI-004921': 'SC-42 (5)',
  'CCI-004922': 'SC-45',
  'CCI-004923': 'SC-45 (1) (a)',
  'CCI-004924': 'SC-45 (1) (a)',
  'CCI-004925': 'SC-45 (1) (a)',
  'CCI-004926': 'SC-45 (1) (b)',
  'CCI-004927': 'SC-45 (1) (b)',
  'CCI-004928': 'SC-45 (2) (a)',
  'CCI-004929': 'SC-45 (2) (b)',
  'CCI-004930': 'SC-46',
  'CCI-004931': 'SC-47',
  'CCI-004932': 'SC-48',
  'CCI-004933': 'SC-48',
  'CCI-004934': 'SC-48',
  'CCI-004935': 'SC-48',
  'CCI-004936': 'SC-48 (1)',
  'CCI-004937': 'SC-48 (1)',
  'CCI-004938': 'SC-48 (1)',
  'CCI-004939': 'SC-48 (1)',
  'CCI-004940': 'SC-49',
  'CCI-004941': 'SC-49',
  'CCI-004942': 'SC-50',
  'CCI-004943': 'SC-50',
  'CCI-004944': 'SI-1 a 1 (b)',
  'CCI-004945': 'SI-1 b',
  'CCI-004946': 'SI-1 b',
  'CCI-004947': 'SI-1 b',
  'CCI-004948': 'SI-1 b',
  'CCI-004949': 'SI-1 b',
  'CCI-004950': 'SI-1 b',
  'CCI-004951': 'SI-1 c 1',
  'CCI-004952': 'SI-1 c 1',
  'CCI-004953': 'SI-1 c 2',
  'CCI-004954': 'SI-1 c 2',
  'CCI-004955': 'SI-2 (2)',
  'CCI-004956': 'SI-2 (2)',
  'CCI-004957': 'SI-2 (2)',
  'CCI-004958': 'SI-2 (2)',
  'CCI-004959': 'SI-2 (2)',
  'CCI-004960': 'SI-2 (2)',
  'CCI-004961': 'SI-2 (4)',
  'CCI-004962': 'SI-2 (4)',
  'CCI-004963': 'SI-3 a',
  'CCI-004964': 'SI-3 b',
  'CCI-004965': 'SI-3 b',
  'CCI-004966': 'SI-3 c 2',
  'CCI-004967': 'SI-4 d',
  'CCI-004968': 'SI-4 (2)',
  'CCI-004969': 'SI-4 (3)',
  'CCI-004970': 'SI-4 (3)',
  'CCI-004971': 'SI-4 (4) (a)',
  'CCI-004972': 'SI-4 (4) (a)',
  'CCI-004973': 'SI-4 (4) (b)',
  'CCI-004974': 'SI-4 (4) (b)',
  'CCI-004975': 'SI-4 (9)',
  'CCI-004976': 'SI-4 (9)',
  'CCI-004977': 'SI-4 (10)',
  'CCI-004978': 'SI-4 (10)',
  'CCI-004979': 'SI-4 (10)',
  'CCI-004980': 'SI-4 (12)',
  'CCI-004981': 'SI-4 (16)',
  'CCI-004982': 'SI-4 (25)',
  'CCI-004983': 'SI-5 (1)',
  'CCI-004984': 'SI-6 a',
  'CCI-004985': 'SI-6 a',
  'CCI-004986': 'SI-6 b',
  'CCI-004987': 'SI-6 b',
  'CCI-004988': 'SI-6 b',
  'CCI-004989': 'SI-6 c',
  'CCI-004990': 'SI-6 c',
  'CCI-004991': 'SI-6 d',
  'CCI-004992': 'SI-6 d',
  'CCI-004993': 'SI-6 (2)',
  'CCI-004994': 'SI-6 (3)',
  'CCI-004995': 'SI-6 (3)',
  'CCI-004996': 'SI-7 b',
  'CCI-004997': 'SI-7 b',
  'CCI-004998': 'SI-7 (17)',
  'CCI-004999': 'SI-7 (17)',
  'CCI-005000': 'SI-8 b',
  'CCI-005001': 'SI-8 b',
  'CCI-005002': 'SI-8 (2)',
  'CCI-005003': 'SI-10 (6)',
  'CCI-005004': 'SI-12 (1)',
  'CCI-005005': 'SI-12 (1)',
  'CCI-005006': 'SI-12 (2)',
  'CCI-005007': 'SI-12 (2)',
  'CCI-005008': 'SI-12 (3)',
  'CCI-005009': 'SI-13 (3)',
  'CCI-005010': 'SI-13 (4) (b)',
  'CCI-005011': 'SI-14 (2) (a)',
  'CCI-005012': 'SI-14 (2) (a)',
  'CCI-005013': 'SI-14 (2) (a)',
  'CCI-005014': 'SI-14 (2) (a)',
  'CCI-005015': 'SI-14 (2) (b)',
  'CCI-005016': 'SI-14 (3)',
  'CCI-005017': 'SI-14 (3)',
  'CCI-005018': 'SI-18 a',
  'CCI-005019': 'SI-18 a',
  'CCI-005020': 'SI-18 b 1',
  'CCI-005021': 'SI-18 (1)',
  'CCI-005022': 'SI-18 (1)',
  'CCI-005023': 'SI-18 (2)',
  'CCI-005024': 'SI-18 (3)',
  'CCI-005025': 'SI-18 (4)',
  'CCI-005026': 'SI-18 (5)',
  'CCI-005027': 'SI-18 (5)',
  'CCI-005028': 'SI-18 (5)',
  'CCI-005029': 'SI-19 a',
  'CCI-005030': 'SI-19 a',
  'CCI-005031': 'SI-19 b',
  'CCI-005032': 'SI-19 b',
  'CCI-005033': 'SI-19 (1)',
  'CCI-005034': 'SI-19 (2)',
  'CCI-005035': 'SI-19 (3)',
  'CCI-005036': 'SI-19 (4)',
  'CCI-005037': 'SI-19 (5)',
  'CCI-005038': 'SI-19 (6)',
  'CCI-005039': 'SI-19 (7)',
  'CCI-005040': 'SI-19 (8)',
  'CCI-005041': 'SI-20',
  'CCI-005042': 'SI-20',
  'CCI-005043': 'SI-21',
  'CCI-005044': 'SI-21',
  'CCI-005045': 'SI-21',
  'CCI-005046': 'SI-22 a',
  'CCI-005047': 'SI-22 a',
  'CCI-005048': 'SI-22 b',
  'CCI-005049': 'SI-22 b',
  'CCI-005050': 'SI-23 a',
  'CCI-005051': 'SI-23 a',
  'CCI-005052': 'SI-23 a',
  'CCI-005053': 'SI-23 b',
  'CCI-005054': 'SI-23 b',
  'CCI-005055': 'SI-23 b',
  'CCI-005056': 'SR-1 a 1',
  'CCI-005057': 'SR-1 a 1 (a)',
  'CCI-005058': 'SR-1 a 1 (b)',
  'CCI-005059': 'SR-1 a 2',
  'CCI-005060': 'SR-1 b',
  'CCI-005061': 'SR-1 b',
  'CCI-005062': 'SR-1 b',
  'CCI-005063': 'SR-1 b',
  'CCI-005064': 'SR-1 c 1',
  'CCI-005065': 'SR-1 c 1',
  'CCI-005066': 'SR-1 c 1',
  'CCI-005067': 'SR-1 c 1',
  'CCI-005068': 'SR-1 c 2',
  'CCI-005069': 'SR-1 c 2',
  'CCI-005070': 'SR-1 c 2',
  'CCI-005071': 'SR-1 c 2',
  'CCI-005072': 'SR-2 a',
  'CCI-005073': 'SR-2 a',
  'CCI-005074': 'SR-2 b',
  'CCI-005075': 'SR-2 b',
  'CCI-005076': 'SR-2 c',
  'CCI-005077': 'SR-2 (1)',
  'CCI-005078': 'SR-2 (1)',
  'CCI-005079': 'SR-2 (1)',
  'CCI-005080': 'SR-3 a',
  'CCI-005081': 'SR-3 a',
  'CCI-005082': 'SR-3 a',
  'CCI-005083': 'SR-3 a',
  'CCI-005084': 'SR-3 a',
  'CCI-005085': 'SR-3 a',
  'CCI-005086': 'SR-3 b',
  'CCI-005087': 'SR-3 b',
  'CCI-005088': 'SR-3 b',
  'CCI-005089': 'SR-3 c',
  'CCI-005090': 'SR-3 c',
  'CCI-005091': 'SR-3 (1)',
  'CCI-005092': 'SR-3 (1)',
  'CCI-005093': 'SR-3 (2)',
  'CCI-005094': 'SR-3 (2)',
  'CCI-005095': 'SR-3 (3)',
  'CCI-005096': 'SR-4',
  'CCI-005097': 'SR-4',
  'CCI-005098': 'SR-4',
  'CCI-005099': 'SR-4',
  'CCI-005100': 'SR-4 (1)',
  'CCI-005101': 'SR-4 (1)',
  'CCI-005102': 'SR-4 (2)',
  'CCI-005103': 'SR-4 (2)',
  'CCI-005104': 'SR-4 (3)',
  'CCI-005105': 'SR-4 (3)',
  'CCI-005106': 'SR-4 (3)',
  'CCI-005107': 'SR-4 (3)',
  'CCI-005108': 'SR-4 (4)',
  'CCI-005109': 'SR-4 (4)',
  'CCI-005110': 'SR-4 (4)',
  'CCI-005111': 'SR-4 (4)',
  'CCI-005112': 'SR-5',
  'CCI-005113': 'SR-5',
  'CCI-005114': 'SR-5 (1)',
  'CCI-005115': 'SR-5 (1)',
  'CCI-005116': 'SR-5 (1)',
  'CCI-005117': 'SR-5 (2)',
  'CCI-005118': 'SR-6',
  'CCI-005119': 'SR-6',
  'CCI-005120': 'SR-6 (1)',
  'CCI-005121': 'SR-6 (1)',
  'CCI-005122': 'SR-7',
  'CCI-005123': 'SR-7',
  'CCI-005124': 'SR-8',
  'CCI-005125': 'SR-8',
  'CCI-005126': 'SR-9',
  'CCI-005127': 'SR-9 (1)',
  'CCI-005128': 'SR-10',
  'CCI-005129': 'SR-10',
  'CCI-005130': 'SR-10',
  'CCI-005131': 'SR-10',
  'CCI-005132': 'SR-11 a',
  'CCI-005133': 'SR-11 a',
  'CCI-005134': 'SR-11 b',
  'CCI-005135': 'SR-11 b',
  'CCI-005136': 'SR-11 b',
  'CCI-005137': 'SR-11 (1)',
  'CCI-005138': 'SR-11 (1)',
  'CCI-005139': 'SR-11 (2)',
  'CCI-005140': 'SR-11 (2)',
  'CCI-005141': 'SR-11 (2)',
  'CCI-005142': 'SR-11 (3)',
  'CCI-005143': 'SR-11 (3)',
  'CCI-005144': 'SR-12',
  'CCI-005145': 'SR-12',
  'CCI-005146': 'SR-12',
  'CCI-005147': 'AT-2 a 1'
};
